export const createDecks = ({ helpers, asset }) => {
  const {
    ui,
    ExternalLink,
    SoftCard,
    ZoomableImage,
    EmojiCard,
    CleanList,
    SectionLabel,
    ConceptMark,
    ScreenshotFrame,
    NumberedList,
    ComparisonTable,
    BigStatement,
    Timeline,
  } = helpers;

  return {
overviewEn: {
  label: "English",
  description: "core pitch",
  slides: [
  {
  title: "",
  density: "medium",
  content: (
    <div className="mx-auto flex min-h-[500px] max-w-7xl flex-col justify-center px-4 py-5 text-center sm:px-6 lg:min-h-[600px] max-h-[720px]:min-h-[430px] max-h-[680px]:min-h-[405px] max-h-[720px]:py-3">
      {/* OPENING LABEL */}
      <div className="mx-auto mb-7 inline-flex rounded-full border border-red-200 bg-red-50/80 px-5 py-1.5 text-[10px] font-black uppercase tracking-[0.28em] text-red-700 shadow-sm ring-1 ring-white/80 max-h-[720px]:mb-5 max-h-[720px]:px-4 max-h-[720px]:py-1 max-h-[720px]:text-[9px]">
        The post-course plateau
      </div>

      {/* TITLE */}
      <h1 className="mx-auto max-w-5xl font-mono text-[clamp(2rem,3vw,3.15rem)] font-black leading-[1.02] tracking-tight text-gray-950 max-h-[760px]:text-[clamp(1.85rem,2.75vw,2.75rem)] max-h-[720px]:text-[2.35rem] max-h-[680px]:text-[2.1rem]">
        A student finished
        <br />
        the course.
        <br />
        <span className="tracking-normal">Now what?</span>
      </h1>

      <div className="mx-auto mt-6 h-1.5 w-52 rounded-full bg-gradient-to-r from-blue-600 via-purple-600 to-pink-500 sm:w-64 max-h-[720px]:mt-5 max-h-[720px]:h-1" />

      {/* CARDS */}
      <div className="mx-auto mt-10 grid w-full max-w-4xl gap-5 text-left md:grid-cols-3 max-h-[760px]:mt-8 max-h-[720px]:mt-7 max-h-[720px]:gap-4">
        {/* CARD 1 */}
        <SoftCard className="rounded-[2rem] border-white/70 bg-white/88 px-6 py-6 shadow-sm ring-1 ring-white/80 transition-transform duration-300 hover:-translate-y-1 max-h-[720px]:px-5 max-h-[720px]:py-5">
          <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-blue-50 shadow-sm ring-1 ring-blue-100 max-h-[720px]:mb-4 max-h-[720px]:h-14 max-h-[720px]:w-14">
            <svg width="42" height="42" viewBox="0 0 54 54" fill="none">
              <circle cx="27" cy="27" r="21" stroke="#2563eb" strokeWidth="3" />
              <circle cx="20" cy="23" r="2.8" fill="#2563eb" />
              <circle cx="34" cy="23" r="2.8" fill="#2563eb" />
              <path
                d="M20 34H34"
                stroke="#2563eb"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </svg>
          </div>

          <div className="text-[clamp(1rem,1.18vw,1.12rem)] font-black leading-[1.16] text-gray-900 max-h-[720px]:text-[0.96rem]">
            Can follow
            <br />
            lessons...
            <br />
            but real speech
            <br />
            still feels fragile.
          </div>
        </SoftCard>

        {/* CARD 2 */}
        <SoftCard className="rounded-[2rem] border-white/70 bg-white/88 px-6 py-6 shadow-sm ring-1 ring-white/80 transition-transform duration-300 hover:-translate-y-1 max-h-[720px]:px-5 max-h-[720px]:py-5">
          <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-violet-50 shadow-sm ring-1 ring-violet-100 max-h-[720px]:mb-4 max-h-[720px]:h-14 max-h-[720px]:w-14">
            <svg width="44" height="44" viewBox="0 0 56 56" fill="none">
              <path
                d="M15 46V22L28 12L41 22V46"
                stroke="#7c3aed"
                strokeWidth="3"
                strokeLinejoin="round"
              />
              <path d="M23 46V34H33V46" stroke="#7c3aed" strokeWidth="3" />
              <path
                d="M21 27H21.01"
                stroke="#7c3aed"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M35 27H35.01"
                stroke="#7c3aed"
                strokeWidth="4"
                strokeLinecap="round"
              />
            </svg>
          </div>

          <div className="text-[clamp(1rem,1.18vw,1.12rem)] font-black leading-[1.16] text-gray-900 max-h-[720px]:text-[0.96rem]">
            The basis
            <br />
            is there.
            <br />
            Confidence still
            <br />
            needs practice.
          </div>
        </SoftCard>

        {/* CARD 3 */}
        <SoftCard className="rounded-[2rem] border-white/70 bg-white/88 px-6 py-6 shadow-sm ring-1 ring-white/80 transition-transform duration-300 hover:-translate-y-1 max-h-[720px]:px-5 max-h-[720px]:py-5">
          <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-rose-50 shadow-sm ring-1 ring-rose-100 max-h-[720px]:mb-4 max-h-[720px]:h-14 max-h-[720px]:w-14">
            <svg width="52" height="40" viewBox="0 0 74 54" fill="none">
              <path
                d="M8 46V10"
                stroke="#9ca3af"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M8 46H66"
                stroke="#9ca3af"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M18 36 L34 20 L48 20 L62 20"
                stroke="#f43f5e"
                strokeWidth="4.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="34" cy="20" r="4.5" fill="#f43f5e" />
              <circle cx="48" cy="20" r="4.5" fill="#f43f5e" />
            </svg>
          </div>

          <div className="text-[clamp(1rem,1.18vw,1.12rem)] font-black leading-[1.16] text-gray-900 max-h-[720px]:text-[0.96rem]">
            Progress slows.
            <br />
            Habits settle.
            <br />
            What should
            <br />
            come next?
          </div>
        </SoftCard>
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#dbeafe,_transparent_35%),radial-gradient(circle_at_bottom_right,_#fce7f3,_transparent_35%),linear-gradient(135deg,#ffffff,#f8fafc)]",
},
    {
      title: "",
      density: "dense",
      content: (
        <div className={ui.shell.standard}>
          <h2 className={ui.title.main}>
            Usual paths after courses.
          </h2>

          <div className={ui.spacing.titleRule} />

          <div className={`${ui.spacing.section} mx-auto grid w-full max-w-6xl grid-cols-1 gap-5 text-center md:grid-cols-2 lg:grid-cols-4 max-h-[720px]:gap-3`}>
            {[
              {
                icon: "🌍",
                title: "Immersion",
                circle: "bg-blue-50",
                line: "bg-blue-500",
                text: <>You communicate,<br />but often with<br />the same safe phrases.</>,
                bold: <>Survival fluency<br />becomes a routine.</>,
              },
              {
                icon: "📱",
                title: "Language apps",
                circle: "bg-violet-50",
                line: "bg-violet-500",
                text: <>Good for repetition,<br />but weak on real<br />human interaction.</>,
                bold: <>Streaks do not<br />create conversation.</>,
              },
              {
                icon: "🧑‍🏫",
                title: "Private tutors",
                circle: "bg-amber-50",
                line: "bg-amber-500",
                text: <>One-to-one lessons help,<br />but can feel intense<br />and evaluative.</>,
                bold: <>Speaking needs social ease,<br />not only correction.</>,
              },
              {
                icon: "☕",
                title: "Language cafés",
                circle: "bg-rose-50",
                line: "bg-rose-500",
                text: <>Friendly and social,<br />but often loose<br />and irregular.</>,
                bold: <>Progress needs continuity<br />and commitment.</>,
              },
            ].map((item) => (
              <SoftCard
                key={item.title}
                className={`${ui.card.base} ${ui.card.pad} sm:min-h-[260px] lg:min-h-[280px] max-h-[720px]:min-h-[210px]`}
              >
                <div className={`${ui.card.icon} ${item.circle}`}>
                  {item.icon}
                </div>

                <h3 className={`mt-4 ${ui.title.card} max-h-[720px]:mt-3`}>
                  {item.title}
                </h3>

                <div className={`mx-auto mt-3 h-1 w-12 rounded-full ${item.line} max-h-[720px]:mt-2 max-h-[720px]:w-10`} />

                <p className={`mt-5 ${ui.text.body} max-h-[720px]:mt-3`}>
                  {item.text}
                </p>

                <p className={`mt-5 ${ui.text.strong} max-h-[720px]:mt-3`}>
                  {item.bold}
                </p>
              </SoftCard>
            ))}
          </div>

          <div className={`${ui.highlight} mt-7 max-w-5xl max-h-[760px]:mt-5 max-h-[720px]:mt-4`}>
            <div className="flex items-center justify-center gap-4 text-center">
              <div className="hidden h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white/65 text-2xl sm:flex max-h-[720px]:h-9 max-h-[720px]:w-9 max-h-[720px]:text-xl">
                🧩
              </div>

              <div className="text-[clamp(1.25rem,1.8vw,1.75rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-[1.1rem]">
                The missing piece is{" "}
                <span className="text-violet-700">
                  structured social speech practice.
                </span>
              </div>
            </div>
          </div>
        </div>
      ),
      bgColor:
        "bg-[radial-gradient(circle_at_top_left,_#dbeafe,_transparent_35%),radial-gradient(circle_at_bottom_right,_#fce7f3,_transparent_35%),linear-gradient(135deg,#ffffff,#f8fafc)]",
    },

   {
  title: "",
  density: "medium",
  content: (
    <div className={ui.shell.standard}>
      {/* TOP FRAME */}
      <div className="mx-auto max-w-6xl text-center">
        <div className="mx-auto max-w-2xl">
          <div className="text-[clamp(1rem,1.15vw,1.22rem)] font-semibold italic leading-tight text-gray-600 max-h-[720px]:text-[0.95rem]">
            “A person needs another person.”
          </div>

          <div className="mt-2 text-[10px] font-black uppercase tracking-[0.28em] text-gray-400 max-h-[720px]:text-[8px]">
            Solaris · Tarkovsky
          </div>
        </div>

        <h3 className="mx-auto mt-6 max-w-4xl text-[clamp(1.45rem,2.05vw,2.15rem)] font-black leading-[1.16] tracking-tight text-gray-950 max-h-[760px]:mt-5 max-h-[760px]:text-[clamp(1.35rem,1.9vw,1.95rem)] max-h-[720px]:text-[1.5rem]">
          Can online practice combine elements of classroom,
          <br className="hidden sm:block" />
          language-café ease, and individual pace?
        </h3>

        {/* FIRST CATCHPHRASER REVEAL */}
        <div className="mx-auto mt-6 flex max-w-4xl items-center justify-center gap-4 max-h-[720px]:mt-4">
          <div className="hidden h-px flex-1 bg-gradient-to-r from-transparent via-blue-300 to-purple-300 sm:block" />

          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-400/20 via-purple-400/20 to-pink-400/20 blur-xl" />

            <div className="relative rounded-full border border-purple-200 bg-white/90 px-7 py-2.5 shadow-sm ring-1 ring-white/80 max-h-[720px]:px-5 max-h-[720px]:py-2">
              <div className="text-[11px] font-black uppercase tracking-[0.28em] text-purple-700 max-h-[720px]:text-[9px]">
                Introducing
              </div>

              <div className="mt-0.5 text-[clamp(1.05rem,1.45vw,1.35rem)] font-black tracking-tight text-gray-950 max-h-[720px]:text-base">
                Catchphraser
              </div>
            </div>
          </div>

          <div className="hidden h-px flex-1 bg-gradient-to-l from-transparent via-pink-300 to-purple-300 sm:block" />
        </div>
      </div>

      {/* PRODUCT FORMULA */}
      <div className="mx-auto mt-7 grid w-full max-w-6xl items-stretch gap-5 lg:grid-cols-[1fr_auto_1fr_auto_1fr] max-h-[760px]:mt-5 max-h-[720px]:mt-4 max-h-[720px]:gap-3">
        {/* CARD 1 */}
        <SoftCard className={`${ui.card.base} flex min-h-[220px] flex-col items-center justify-center px-7 py-7 text-center max-h-[720px]:min-h-[175px] max-h-[720px]:px-5 max-h-[720px]:py-5`}>
          <div className="mb-4 text-4xl max-h-[720px]:mb-3 max-h-[720px]:text-3xl">
            🎧
          </div>

          <div className={ui.title.card}>
            Real speech
            <br />
            samples
          </div>

          <div className={`mx-auto mt-4 max-w-sm ${ui.text.body} max-h-[720px]:mt-3`}>
            Human-read audio, dialogues,
            and authentic pronunciation examples.
          </div>
        </SoftCard>

        {/* PLUS */}
        <div className="hidden items-center justify-center lg:flex">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/85 text-2xl font-black text-purple-400 shadow-sm ring-1 ring-purple-100">
            +
          </div>
        </div>

        {/* CARD 2 */}
        <SoftCard className={`${ui.card.base} relative flex min-h-[240px] flex-col items-center justify-center overflow-hidden rounded-[2.5rem] px-8 py-8 text-center shadow-md ring-purple-100 max-h-[720px]:min-h-[190px] max-h-[720px]:rounded-[2rem] max-h-[720px]:px-5 max-h-[720px]:py-5`}>
          <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500" />

          <div className="mb-4 flex justify-center gap-3 text-4xl max-h-[720px]:mb-3 max-h-[720px]:text-3xl">
            <span>📈</span>
            <span>🗣️</span>
          </div>

          <div className="text-[clamp(1.45rem,1.85vw,1.85rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-[1.3rem]">
            Sounds
            <br />
            <span className="text-purple-700">and flow</span>
          </div>

          <div className={`mx-auto mt-4 max-w-md ${ui.text.body} max-h-[720px]:mt-3`}>
            Pronunciation, rhythm,
            stress, intonation, timing,
            and speech melody.
          </div>
        </SoftCard>

        <div className="hidden items-center justify-center lg:flex">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/85 text-2xl font-black text-purple-400 shadow-sm ring-1 ring-purple-100">
            +
          </div>
        </div>

        {/* CARD 3 */}
        <SoftCard className={`${ui.card.base} flex min-h-[220px] flex-col items-center justify-center px-7 py-7 text-center max-h-[720px]:min-h-[175px] max-h-[720px]:px-5 max-h-[720px]:py-5`}>
          <div className="mb-4 text-4xl max-h-[720px]:mb-3 max-h-[720px]:text-3xl">
            💬
          </div>

          <div className={ui.title.card}>
            Social
            <br />
            layer
          </div>

          <div className={`mx-auto mt-4 max-w-sm ${ui.text.body} max-h-[720px]:mt-3`}>
            Feedback, peer review,
            comments, challenges,
            and shared rehearsal.
          </div>
        </SoftCard>
      </div>

      {/* BOTTOM FORMULA */}
      <div className="mx-auto mt-8 max-w-5xl rounded-[2rem] bg-gradient-to-r from-blue-100 via-purple-100 to-pink-100 px-8 py-5 text-center shadow-sm ring-1 ring-white/80 max-h-[760px]:mt-6 max-h-[720px]:mt-4 max-h-[720px]:px-5 max-h-[720px]:py-3">
        <div className="text-[clamp(1.08rem,1.45vw,1.35rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-base">
          Pronunciation training becomes preparation for social speech.
        </div>

        <div className="mt-2 text-[clamp(0.9rem,1.05vw,1rem)] font-semibold leading-relaxed text-gray-600 max-h-[720px]:mt-1 max-h-[720px]:text-sm">
          Not accent elimination — intelligible, confident speech learners can use with people.
        </div>
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#dbeafe,_transparent_32%),radial-gradient(circle_at_bottom_right,_#f3e8ff,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
},

    {
  title: "",
  density: "screenshot",
  content: (
    <div className="mx-auto flex min-h-[560px] max-w-7xl flex-col justify-center px-4 py-4 sm:px-6 max-h-[720px]:min-h-[500px] max-h-[720px]:py-3">
      <div className="mx-auto grid w-full max-w-6xl items-center gap-8 xl:grid-cols-[0.88fr_1.12fr] max-h-[720px]:gap-6">
        {/* LEFT COLUMN */}
        <div className="flex flex-col justify-center">
          <div className="max-w-xl text-left">
            <div className={ui.label.purple}>Specialized intonation course</div>

            <h3 className="mt-3 text-[clamp(1.8rem,2.45vw,2.5rem)] font-black leading-[1.08] tracking-tight text-gray-950 max-h-[720px]:mt-2 max-h-[720px]:text-[1.7rem]">
              Flyt og rytme
            </h3>

            <p className="mt-4 max-w-lg text-[clamp(0.98rem,1.1vw,1.08rem)] font-semibold leading-relaxed text-gray-600 max-h-[720px]:mt-3 max-h-[720px]:text-sm">
              We use focused rhythm-and-intonation tasks that make speech
              patterns concrete, repeatable, and easier to repair.
            </p>
          </div>

          <SoftCard className="mt-6 rounded-[2.2rem] bg-gradient-to-br from-purple-50 to-white px-7 py-7 text-left shadow-sm ring-1 ring-purple-100 max-h-[720px]:mt-4 max-h-[720px]:px-5 max-h-[720px]:py-5">
            <div className="flex items-center gap-5">
              <div className="h-24 w-24 overflow-hidden rounded-full border-4 border-white shadow-xl max-h-[720px]:h-20 max-h-[720px]:w-20">
                <img
                  src={asset("oh.jpg")}
                  alt="Olaf Husby"
                  className="h-full w-full object-cover"
                />
              </div>

              <div>
                <div className="text-[10px] font-black uppercase tracking-[0.24em] text-purple-700">
                  Course author
                </div>

                <div className="mt-2 text-[clamp(1.2rem,1.45vw,1.45rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-lg">
                  Olaf Husby
                </div>

                <div className="mt-1 text-[10px] font-black uppercase tracking-[0.22em] text-purple-700">
                  pronunciation pedagogy
                </div>
              </div>
            </div>

            <div className="mt-6 rounded-[1.5rem] bg-white/82 px-5 py-5 shadow-sm ring-1 ring-purple-100 max-h-[720px]:mt-4 max-h-[720px]:px-4 max-h-[720px]:py-4">
              <div className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-400">
                What the course trains
              </div>

              <div className="mt-3 space-y-2.5 text-[clamp(0.88rem,0.98vw,0.95rem)] font-semibold leading-relaxed text-gray-700 max-h-[720px]:space-y-2 max-h-[720px]:text-xs">
                <div>• concrete rhythm targets</div>
                <div>• perception and production together</div>
                <div>• rhythm and stress made visible</div>
                <div>• preparation for later social practice</div>
              </div>

              <a
                href="https://www.catchphraser.com/course/flyt-og-rytme"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-flex items-center rounded-full border border-purple-200 bg-white px-4 py-2 text-[10px] font-black uppercase tracking-[0.18em] text-purple-700 shadow-sm transition-all hover:-translate-y-0.5 hover:bg-purple-50 max-h-[720px]:px-3 max-h-[720px]:py-1.5"
              >
                Open course ↗
              </a>
            </div>
          </SoftCard>
        </div>

        {/* RIGHT COLUMN */}
        <div className="flex justify-center xl:justify-end">
          <div className="relative w-full max-w-[400px] max-h-[720px]:max-w-[365px]">
            <div className="absolute inset-0 rounded-[3rem] bg-gradient-to-br from-purple-200/35 via-blue-100/20 to-pink-200/30 blur-2xl" />

            <div className="relative rounded-[3rem] border border-slate-200 bg-slate-950 p-3 shadow-[0_32px_90px_rgba(15,23,42,0.22)] ring-1 ring-black/5 max-h-[720px]:rounded-[2.5rem] max-h-[720px]:p-2.5">
              <div className="pointer-events-none absolute left-1/2 top-3 z-10 flex -translate-x-1/2 items-center gap-2 rounded-full bg-slate-800 px-4 py-1.5 max-h-[720px]:top-2.5 max-h-[720px]:px-3 max-h-[720px]:py-1">
                <div className="h-1.5 w-10 rounded-full bg-slate-600 max-h-[720px]:w-8" />
                <div className="h-2 w-2 rounded-full bg-slate-600 max-h-[720px]:h-1.5 max-h-[720px]:w-1.5" />
              </div>

              <div className="overflow-hidden rounded-[2.45rem] bg-white pt-7 max-h-[720px]:rounded-[2rem] max-h-[720px]:pt-6">
                {/* mockup header */}
                <div className="border-b border-gray-100 px-4 py-3 max-h-[720px]:px-3 max-h-[720px]:py-2.5">
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <div className="text-[10px] font-semibold text-gray-400">
                        by Olaf Husby
                      </div>

                      <div className="text-[1rem] font-black leading-tight text-gray-950 max-h-[720px]:text-[0.9rem]">
                        Exercise 1A — What to focus on
                      </div>
                    </div>

                    <a
                      href="https://www.catchphraser.com/course/flyt-og-rytme"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="shrink-0 rounded-full border border-blue-200 bg-blue-50 px-3 py-1 text-[9px] font-black uppercase tracking-[0.14em] text-blue-700"
                    >
                      course ↗
                    </a>
                  </div>

                  <div className="mt-3 flex flex-wrap gap-2 text-[10px] font-semibold max-h-[720px]:mt-2">
                    {["Student", "Teacher", "Glossary", "About"].map(
                      (tab, index) => (
                        <div
                          key={tab}
                          className={`rounded-full px-2.5 py-1.5 ${
                            index === 0
                              ? "bg-gray-100 text-gray-900 ring-1 ring-gray-200"
                              : "text-gray-500"
                          }`}
                        >
                          {tab}
                        </div>
                      )
                    )}
                  </div>
                </div>

                {/* rhythm strip */}
                <div className="bg-[linear-gradient(90deg,#eff6ff,#faf5ff,#fff1f2)] px-4 py-2.5 max-h-[720px]:px-3 max-h-[720px]:py-2">
                  <div className="flex flex-wrap gap-2">
                    {["XxXx", "XX", "XxXx"].map((chip) => (
                      <div
                        key={chip}
                        className="rounded-full bg-white px-3 py-1.5 text-[10px] font-black text-gray-700 ring-1 ring-gray-200"
                      >
                        {chip}
                      </div>
                    ))}
                  </div>

                  <div className="mt-1.5 text-[10px] font-medium text-gray-500">
                    Clap on X • keep x light
                  </div>
                </div>

                {/* task blocks */}
                <div className="space-y-2.5 bg-[#fbfbfc] px-4 py-3.5 max-h-[720px]:space-y-2 max-h-[720px]:px-3 max-h-[720px]:py-2.5">
                  <div className="rounded-[1.35rem] border border-gray-100 bg-white px-4 py-3.5 shadow-sm">
                    <div className="text-center">
                      <div className="text-[9px] font-black uppercase tracking-[0.18em] text-gray-400">
                        Challenge
                      </div>

                      <div className="mt-1 text-[0.9rem] font-black text-gray-950">
                        Rhythm anchor
                      </div>

                      <div className="mt-2.5 text-[1.45rem] font-black leading-tight text-gray-950 max-h-[720px]:text-[1.2rem]">
                        Two beats, one chain.
                      </div>

                      <div className="mt-1 text-xs font-medium text-gray-500 max-h-[720px]:text-[10px]">
                        Don’t restart in the middle.
                      </div>
                    </div>
                  </div>

                  <div className="rounded-[1.35rem] border border-gray-100 bg-white px-4 py-3.5 shadow-sm">
                    <div className="text-center text-[9px] font-black uppercase tracking-[0.18em] text-gray-400">
                      Targets
                    </div>

                    <div className="mt-1 text-center text-[0.92rem] font-black text-gray-950">
                      Copy the rhythm shape
                    </div>

                    <div className="mt-3 space-y-2 max-h-[720px]:mt-2 max-h-[720px]:space-y-1.5">
                      {["KARi_SNAkker", "JENta_SYNger", "TOR_REIser"].map(
                        (item) => (
                          <div
                            key={item}
                            className="rounded-2xl bg-gray-50 px-4 py-2.5 text-center text-[0.9rem] font-medium tracking-[0.08em] text-gray-800 ring-1 ring-gray-100 max-h-[720px]:py-2 max-h-[720px]:text-[0.8rem]"
                          >
                            {item}
                          </div>
                        )
                      )}
                    </div>
                  </div>
                </div>

                <div className="bg-white px-4 pb-3 pt-1 max-h-[720px]:pb-2">
                  <div className="mx-auto h-1.5 w-24 rounded-full bg-gray-200 max-h-[720px]:w-20" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#ede9fe,_transparent_30%),radial-gradient(circle_at_bottom_right,_#dbeafe,_transparent_32%),linear-gradient(135deg,#ffffff,#faf5ff)]",
},

    {
  title: "",
  density: "screenshot",
  content: (
    <div className="mx-auto flex min-h-[560px] max-w-7xl flex-col justify-center px-4 py-4 text-center sm:px-6 max-h-[720px]:min-h-[500px] max-h-[720px]:py-3">
      <div className="mx-auto max-w-5xl">
        <div className={ui.label.purple}>
          Visual prosody cues
        </div>

        <h3 className="mx-auto mt-3 max-w-5xl text-[clamp(1.55rem,2.25vw,2.25rem)] font-black leading-[1.08] tracking-tight text-gray-950 max-h-[720px]:mt-2 max-h-[720px]:text-[1.45rem]">
          Learners can see rhythm,
          <br />
          stress, and intonation movement.
        </h3>
      </div>

      {/* MAIN IMAGE */}
      <div className="relative mx-auto mt-6 w-full max-w-[1120px] max-h-[720px]:mt-4">
        <div className="absolute inset-0 scale-[1.015] rounded-[2.8rem] bg-gradient-to-r from-blue-200/30 via-purple-200/25 to-pink-200/30 blur-3xl" />

        <ZoomableImage
          src={asset("flyt-og-rytme-interface-enhanced.png")}
          alt="Pitch contour visualization showing rhythm, stress, clickable words, and intonation movement"
          caption="Pitch contour visualization"
          className="relative block"
        >
          <div className="relative overflow-hidden rounded-[2.7rem] border border-white/80 bg-white/94 p-3 shadow-[0_32px_100px_rgba(15,23,42,0.16)] ring-1 ring-gray-200/70 transition-all duration-300 group-hover:scale-[1.006] max-h-[720px]:rounded-[2.2rem] max-h-[720px]:p-2.5">
            <div className="rounded-[2rem] border border-gray-100 bg-white px-3 py-3 max-h-[720px]:rounded-[1.6rem] max-h-[720px]:px-2 max-h-[720px]:py-2">
              <img
                src={asset("flyt-og-rytme-interface-enhanced.png")}
                alt="Pitch contour visualization showing rhythm, stress, clickable words, and intonation movement"
                className="mx-auto max-h-[430px] w-full object-contain contrast-[1.06] brightness-[1.02] max-h-[760px]:max-h-[380px] max-h-[720px]:max-h-[330px]"
              />
            </div>
          </div>
        </ZoomableImage>
      </div>

      {/* LABELS */}
      <div className="mx-auto mt-5 grid w-full max-w-5xl gap-3 md:grid-cols-4 max-h-[720px]:mt-4 max-h-[720px]:gap-2">
        {[
          "fall / rise",
          "intonation groups",
          "movement inside words",
          "clickable words",
        ].map((title, index) => (
          <SoftCard
            key={index}
            className="rounded-[1.35rem] border border-gray-200/80 bg-white/88 px-4 py-4 text-center shadow-sm ring-1 ring-white/80 max-h-[720px]:px-3 max-h-[720px]:py-3"
          >
            <div className="flex min-h-[34px] items-center justify-center text-[clamp(0.95rem,1.15vw,1.15rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-sm">
              {title}
            </div>
          </SoftCard>
        ))}
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#dbeafe,_transparent_32%),radial-gradient(circle_at_bottom_right,_#ede9fe,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
},

   {
  title: "",
  density: "screenshot",
  content: (
    <div className="mx-auto flex min-h-[560px] max-w-7xl flex-col justify-center px-4 py-4 text-center sm:px-6 max-h-[720px]:min-h-[500px] max-h-[720px]:py-3">
      {/* HEADER */}
      <div className="mx-auto max-w-6xl">
        <div className={ui.label.green || "text-sm font-black uppercase tracking-[0.24em] text-emerald-700"}>
          The first social layer
        </div>

        <h3 className="mx-auto mt-3 max-w-5xl text-[clamp(2rem,3vw,3rem)] font-black leading-[1.04] tracking-tight text-gray-950 max-h-[760px]:text-[clamp(1.7rem,2.45vw,2.4rem)] max-h-[720px]:mt-2 max-h-[720px]:text-[1.8rem]">
         People review people.
        </h3>
      </div>

      {/* SCREENSHOT AS MAIN FOCUS */}
      <div className="relative mx-auto mt-8 w-full max-w-[1160px] max-h-[760px]:mt-6 max-h-[720px]:mt-5">
        <div className="absolute inset-0 scale-[1.012] rounded-[2.8rem] bg-gradient-to-r from-emerald-200/30 via-blue-200/20 to-purple-200/25 blur-3xl" />

        <ZoomableImage
          src={asset("rateme-enhanced.png")}
          alt="Pronunciation review interface where users can rate pronunciation, mark mistakes, and leave comments"
          caption="Pronunciation review interface"
          className="relative block"
        >
          <div className="relative overflow-hidden rounded-[2.7rem] border border-white/80 bg-white/94 p-3 shadow-[0_32px_100px_rgba(15,23,42,0.16)] ring-1 ring-gray-200/70 transition-all duration-300 group-hover:scale-[1.006] max-h-[720px]:rounded-[2.2rem] max-h-[720px]:p-2.5">
            <div className="rounded-[2rem] border border-gray-100 bg-white px-3 py-3 max-h-[720px]:rounded-[1.6rem] max-h-[720px]:px-2 max-h-[720px]:py-2">
              <img
                src={asset("rateme-enhanced.png")}
                alt="Pronunciation review interface where users can rate pronunciation, mark mistakes, and leave comments"
                className="mx-auto max-h-[430px] w-full object-contain contrast-[1.04] brightness-[1.02] max-h-[760px]:max-h-[380px] max-h-[720px]:max-h-[335px]"
              />
            </div>
          </div>
        </ZoomableImage>
      </div>

      {/* COMPACT VALUE STRIP */}
      <div className="mx-auto mt-6 grid w-full max-w-5xl gap-3 md:grid-cols-3 max-h-[720px]:mt-4 max-h-[720px]:gap-2">
        {[
          ["Precise marking", "phoneme • word • sentence"],
          ["Human judgment", "peers • teachers • native speakers"],
          ["Reusable notes", "comments stay with examples"],
        ].map(([title, text]) => (
          <SoftCard
            key={title}
            className="rounded-[1.35rem] border border-gray-200/80 bg-white/88 px-4 py-3.5 text-center shadow-sm ring-1 ring-white/80 max-h-[720px]:px-3 max-h-[720px]:py-2.5"
          >
            <div className="text-[clamp(0.95rem,1.1vw,1.08rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-sm">
              {title}
            </div>

            <div className="mx-auto mt-1 max-w-xs text-[clamp(0.75rem,0.85vw,0.85rem)] font-semibold leading-relaxed text-gray-600 max-h-[720px]:text-xs">
              {text}
            </div>
          </SoftCard>
        ))}
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#dcfce7,_transparent_30%),radial-gradient(circle_at_bottom_right,_#dbeafe,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
},

    {
      title: "",
      density: "medium",
      content: (
        <div className={ui.shell.standard}>
          <div className={ui.label.green}>Peer review as learning</div>

          <h3 className={ui.title.main}>
            Learners gradually learn
            <br />
            how to hear and describe speech.
          </h3>

          <div className="mx-auto mt-5 max-w-4xl max-h-[720px]:mt-3">
            <div className="text-[clamp(0.95rem,1.2vw,1.1rem)] italic leading-relaxed text-gray-600 max-h-[720px]:text-sm">
              “What a child can do in cooperation today, he will do alone
              tomorrow.”
            </div>

            <div className={ui.label.gray}>Vygotsky</div>
          </div>

          <div className={`${ui.spacing.section} mx-auto w-full max-w-5xl`}>
            <div className="rounded-[2rem] border border-emerald-100 bg-white/82 px-6 py-7 shadow-sm ring-1 ring-emerald-100 max-h-[720px]:px-5 max-h-[720px]:py-5">
              <div className="grid items-center gap-7 md:grid-cols-3 max-h-[720px]:gap-4">
                {[
                  ["🧑‍🦱", "Assess", "others", "bg-blue-50", "ring-blue-100"],
                  ["💬", "Shared", "terms", "bg-emerald-50", "ring-emerald-100"],
                  ["👩‍🦰", "Hear your", "own mistakes", "bg-purple-50", "ring-purple-100"],
                ].map(([emoji, a, b, bg, ring]) => (
                  <div key={emoji} className="flex flex-col items-center">
                    <div
                      className={`mb-5 flex h-20 w-20 items-center justify-center rounded-full ${bg} text-5xl shadow-sm ring-1 ${ring} max-h-[720px]:mb-3 max-h-[720px]:h-14 max-h-[720px]:w-14 max-h-[720px]:text-3xl`}
                    >
                      {emoji}
                    </div>

                    <div className={ui.title.card}>
                      {a}
                      <br />
                      {b}
                    </div>
                  </div>
                ))}
              </div>

              <div className="mx-auto mt-8 max-w-3xl rounded-3xl bg-emerald-50/70 px-6 py-4 text-[clamp(0.9rem,1vw,1rem)] font-black leading-relaxed text-gray-950 max-h-[720px]:mt-5 max-h-[720px]:py-3 max-h-[720px]:text-sm">
                Learners develop assessment skill together with practical
                pronunciation terminology.
              </div>
            </div>
          </div>
        </div>
      ),
      bgColor:
        "bg-[radial-gradient(circle_at_top_left,_#dcfce7,_transparent_32%),radial-gradient(circle_at_bottom_right,_#ede9fe,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
    },

    {
      title: "",
      density: "screenshot",
      content: (
        <div className={ui.shell.screenshot}>
          <div className="mx-auto max-w-6xl">
            <div className={ui.label.green}>
              Every correction can help the next learner
            </div>

            <h3 className={ui.title.medium}>
              A useful comment stays
              <br />
              next to the example.
            </h3>
          </div>

          <div className="relative mx-auto mt-7 w-full max-w-6xl max-h-[760px]:mt-5 max-h-[720px]:mt-3">
            <div className="absolute inset-0 scale-[1.012] rounded-[2.6rem] bg-gradient-to-r from-emerald-200/30 via-blue-200/20 to-purple-200/25 blur-3xl" />

            <ZoomableImage
              src={asset("rated-enhanced.png")}
              alt="Community pronunciation review with comments and marked pronunciation issues"
              caption="Community pronunciation review"
              className="relative block"
            >
              <div className={ui.screenshot.frame}>
                <div className={ui.screenshot.inner}>
                  <img
                    src={asset("rated-enhanced.png")}
                    alt="Community pronunciation review with comments and marked pronunciation issues"
                    className={ui.screenshot.imgMedium}
                  />
                </div>
              </div>
            </ZoomableImage>
          </div>

          <div className="mx-auto mt-6 grid w-full max-w-6xl gap-4 md:grid-cols-3 max-h-[760px]:mt-5 max-h-[720px]:mt-3 max-h-[720px]:gap-3">
            {["L1→L2 patterns", "Reusable corrections", "Better feedback model"].map(
              (label) => (
                <SoftCard
                  key={label}
                  className={`${ui.card.base} px-5 py-4 text-center max-h-[720px]:px-4 max-h-[720px]:py-3`}
                >
                  <div className="flex min-h-[40px] items-center justify-center text-[clamp(1rem,1.25vw,1.25rem)] font-black leading-tight text-gray-950 max-h-[720px]:min-h-[30px] max-h-[720px]:text-sm">
                    {label}
                  </div>
                </SoftCard>
              )
            )}
          </div>
        </div>
      ),
      bgColor:
        "bg-[radial-gradient(circle_at_top_left,_#dcfce7,_transparent_34%),radial-gradient(circle_at_bottom_right,_#dbeafe,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
    },
   {
  title: "",
  density: "dense",
  content: (
    <div className="mx-auto flex w-full max-w-7xl items-center justify-center px-2 py-2">
      <svg
        viewBox="0 0 1280 720"
        preserveAspectRatio="xMidYMid meet"
        className="block aspect-video w-full"
        role="img"
        aria-label="Differentiated practice in a learning community"
      >
        <defs>
          <filter id="wheelShadowPremiumFinal4" x="-25%" y="-25%" width="150%" height="150%">
            <feDropShadow
              dx="0"
              dy="18"
              stdDeviation="22"
              floodColor="#0f172a"
              floodOpacity="0.105"
            />
          </filter>

          <filter id="softShadowPremiumFinal4" x="-25%" y="-25%" width="150%" height="150%">
            <feDropShadow
              dx="0"
              dy="8"
              stdDeviation="10"
              floodColor="#0f172a"
              floodOpacity="0.08"
            />
          </filter>

          <filter id="cardShadowPremiumFinal4" x="-10%" y="-10%" width="120%" height="120%">
            <feDropShadow
              dx="0"
              dy="18"
              stdDeviation="22"
              floodColor="#0f172a"
              floodOpacity="0.105"
            />
          </filter>

          <radialGradient id="wheelPlatePremiumFinal4" cx="50%" cy="50%" r="64%">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0.99" />
            <stop offset="58%" stopColor="#f8fafc" stopOpacity="0.95" />
            <stop offset="100%" stopColor="#eef2ff" stopOpacity="0.55" />
          </radialGradient>

          <linearGradient id="segBluePremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#dbeafe" />
            <stop offset="100%" stopColor="#bfd6fb" />
          </linearGradient>

          <linearGradient id="segVioletPremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#ede9fe" />
            <stop offset="100%" stopColor="#dad1fb" />
          </linearGradient>

          <linearGradient id="segPurplePremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#f3e8ff" />
            <stop offset="100%" stopColor="#e5d4fb" />
          </linearGradient>

          <linearGradient id="segCyanPremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#cffafe" />
            <stop offset="100%" stopColor="#a9edf7" />
          </linearGradient>

          <linearGradient id="segEmeraldPremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#d1fae5" />
            <stop offset="100%" stopColor="#b8eccf" />
          </linearGradient>

          <linearGradient id="segSkyPremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#e0f2fe" />
            <stop offset="100%" stopColor="#bfe3fa" />
          </linearGradient>

          <linearGradient id="hubGradPremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="100%" stopColor="#f8fafc" />
          </linearGradient>

          <linearGradient id="badgeBluePremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#93c5fd" />
            <stop offset="100%" stopColor="#2563eb" />
          </linearGradient>

          <linearGradient id="badgePurplePremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#c4b5fd" />
            <stop offset="100%" stopColor="#7c3aed" />
          </linearGradient>

          <linearGradient id="badgeTealPremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#67e8f9" />
            <stop offset="100%" stopColor="#0891b2" />
          </linearGradient>

          <linearGradient id="badgeGreenPremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#86efac" />
            <stop offset="100%" stopColor="#16a34a" />
          </linearGradient>

          {/* arrowheads */}
          <marker
            id="arrowBluePremiumFinal4"
            viewBox="0 0 10 10"
            refX="8.2"
            refY="5"
            markerWidth="4.4"
            markerHeight="4.4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" fill="#2563eb" />
          </marker>

          <marker
            id="arrowVioletPremiumFinal4"
            viewBox="0 0 10 10"
            refX="8.2"
            refY="5"
            markerWidth="4.4"
            markerHeight="4.4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" fill="#8b5cf6" />
          </marker>

          <marker
            id="arrowPurplePremiumFinal4"
            viewBox="0 0 10 10"
            refX="8.2"
            refY="5"
            markerWidth="4.4"
            markerHeight="4.4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" fill="#7c3aed" />
          </marker>

          <marker
            id="arrowTealPremiumFinal4"
            viewBox="0 0 10 10"
            refX="8.2"
            refY="5"
            markerWidth="4.4"
            markerHeight="4.4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" fill="#06b6d4" />
          </marker>

          <marker
            id="arrowGreenPremiumFinal4"
            viewBox="0 0 10 10"
            refX="8.2"
            refY="5"
            markerWidth="4.4"
            markerHeight="4.4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" fill="#22c55e" />
          </marker>

          <marker
            id="arrowSkyPremiumFinal4"
            viewBox="0 0 10 10"
            refX="8.2"
            refY="5"
            markerWidth="4.4"
            markerHeight="4.4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" fill="#60a5fa" />
          </marker>
        </defs>

        {/* background */}
        <rect x="0" y="0" width="1280" height="720" fill="transparent" />
        <circle cx="128" cy="88" r="230" fill="#dbeafe" fillOpacity="0.13" />
        <circle cx="1124" cy="642" r="248" fill="#dcfce7" fillOpacity="0.155" />
        <circle cx="586" cy="360" r="392" fill="#f5f3ff" fillOpacity="0.18" />

        {/* WHEEL */}
        <g transform="translate(-22 4)">
          <circle
            cx="392"
            cy="360"
            r="312"
            fill="url(#wheelPlatePremiumFinal4)"
            stroke="#e5e7eb"
            strokeWidth="1.5"
            filter="url(#wheelShadowPremiumFinal4)"
          />

          <circle
            cx="392"
            cy="360"
            r="292"
            fill="none"
            stroke="#ffffff"
            strokeWidth="3"
            opacity="0.88"
          />

          {[
            {
              d: "M260.2 77.3 A312 312 0 0 1 523.8 77.3 L449.6 223.8 A144 144 0 0 0 334.4 223.8 Z",
              fill: "url(#segBluePremiumFinal4)",
            },
            {
              d: "M550.1 92.9 A312 312 0 0 1 692.4 338.5 L528.6 347.1 A144 144 0 0 0 467.2 239.4 Z",
              fill: "url(#segVioletPremiumFinal4)",
            },
            {
              d: "M692.4 381.5 A312 312 0 0 1 550.1 627.1 L467.2 480.6 A144 144 0 0 0 528.6 372.9 Z",
              fill: "url(#segPurplePremiumFinal4)",
            },
            {
              d: "M523.8 642.7 A312 312 0 0 1 260.2 642.7 L334.4 496.2 A144 144 0 0 0 449.6 496.2 Z",
              fill: "url(#segCyanPremiumFinal4)",
            },
            {
              d: "M233.9 627.1 A312 312 0 0 1 91.6 381.5 L255.4 372.9 A144 144 0 0 0 316.8 480.6 Z",
              fill: "url(#segEmeraldPremiumFinal4)",
            },
            {
              d: "M91.6 338.5 A312 312 0 0 1 233.9 92.9 L316.8 239.4 A144 144 0 0 0 255.4 347.1 Z",
              fill: "url(#segSkyPremiumFinal4)",
            },
          ].map((seg, index) => (
            <path
              key={index}
              d={seg.d}
              fill={seg.fill}
              stroke="#ffffff"
              strokeWidth="10"
              filter="url(#softShadowPremiumFinal4)"
            />
          ))}

          {/* OUTSIDE SEGMENTED FLOW ARROWS */}
          <g
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="5.8"
            opacity="0.92"
          >
            {/* I → II */}
            <path
              d="M 438 33 A 330 330 0 0 1 629 131"
              stroke="#2563eb"
              markerEnd="url(#arrowBluePremiumFinal4)"
            />

            {/* II → III */}
            <path
              d="M 698 236 A 330 330 0 0 1 698 484"
              stroke="#8b5cf6"
              markerEnd="url(#arrowVioletPremiumFinal4)"
            />

            {/* III → IV */}
            <path
              d="M 652 563 A 330 330 0 0 1 438 687"
              stroke="#7c3aed"
              markerEnd="url(#arrowPurplePremiumFinal4)"
            />

            {/* IV → V */}
            <path
              d="M 346 687 A 330 330 0 0 1 132 563"
              stroke="#06b6d4"
              markerEnd="url(#arrowTealPremiumFinal4)"
            />

            {/* V → VI */}
            <path
              d="M 86 484 A 330 330 0 0 1 86 236"
              stroke="#22c55e"
              markerEnd="url(#arrowGreenPremiumFinal4)"
            />

            {/* VI → I */}
            <path
              d="M 132 157 A 330 330 0 0 1 346 33"
              stroke="#60a5fa"
              markerEnd="url(#arrowSkyPremiumFinal4)"
            />
          </g>

          {/* hub */}
          <circle
            cx="392"
            cy="360"
            r="122"
            fill="url(#hubGradPremiumFinal4)"
            stroke="#e5e7eb"
            strokeWidth="1.6"
            filter="url(#wheelShadowPremiumFinal4)"
          />

          <text
            x="392"
            y="350"
            textAnchor="middle"
            fontSize="31"
            fontWeight="900"
            fill="#111827"
          >
            Community
          </text>
          <text
            x="392"
            y="392"
            textAnchor="middle"
            fontSize="31"
            fontWeight="900"
            fill="#111827"
          >
            learning
          </text>
          <text
            x="392"
            y="428"
            textAnchor="middle"
            fontSize="22"
            fontWeight="800"
            fill="#475569"
          >
            loop
          </text>

          {/* stage badges */}
          {[
            { x: 392, y: 50, n: "I", fill: "url(#badgeBluePremiumFinal4)" },
            { x: 661, y: 204, n: "II", fill: "url(#badgePurplePremiumFinal4)" },
            { x: 661, y: 516, n: "III", fill: "url(#badgePurplePremiumFinal4)" },
            { x: 392, y: 672, n: "IV", fill: "url(#badgeTealPremiumFinal4)" },
            { x: 123, y: 516, n: "V", fill: "url(#badgeGreenPremiumFinal4)" },
            { x: 123, y: 204, n: "VI", fill: "url(#badgeBluePremiumFinal4)" },
          ].map((b) => (
            <g key={b.n}>
              <circle
                cx={b.x}
                cy={b.y}
                r="27"
                fill={b.fill}
                stroke="#ffffff"
                strokeWidth="5"
                filter="url(#softShadowPremiumFinal4)"
              />
              <text
                x={b.x}
                y={b.y + 9}
                textAnchor="middle"
                fontSize="27"
                fontWeight="900"
                fill="#ffffff"
              >
                {b.n}
              </text>
            </g>
          ))}

          {/* I Expectations */}
          <text
            x="392"
            y="136"
            textAnchor="middle"
            fontSize="21.5"
            fontWeight="950"
            fill="#111827"
          >
            Expectations
          </text>
          <text
            x="392"
            y="190"
            textAnchor="middle"
            fontSize="48"
            fontWeight="900"
            fill="#2563eb"
          >
            ↗
          </text>

          {/* II Tools */}
          <g>
            <path
              d="M522 264 C536 236, 556 236, 570 259 C581 278, 593 279, 606 252"
              fill="none"
              stroke="#5b21b6"
              strokeWidth="7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M544 283 C551 289, 560 290, 568 283"
              fill="none"
              stroke="#5b21b6"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="557" cy="274" r="5" fill="#5b21b6" />
            <text
              x="562"
              y="330"
              textAnchor="middle"
              fontSize="21.5"
              fontWeight="950"
              fill="#111827"
            >
              Tools
            </text>
          </g>

          {/* III Challenges */}
          <g>
            <path
              d="M520 465 H542 V444 H564 V423 H588"
              fill="none"
              stroke="#7c3aed"
              strokeWidth="8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M576 412 L590 423 L576 435"
              fill="none"
              stroke="#7c3aed"
              strokeWidth="7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <text
              x="548"
              y="518"
              textAnchor="middle"
              fontSize="21.5"
              fontWeight="950"
              fill="#111827"
            >
              Challenges
            </text>
          </g>

          {/* IV Feedback */}
          <text
            x="392"
            y="548"
            textAnchor="middle"
            fontSize="47"
            fill="#0891b2"
          >
            💬
          </text>
          <text
            x="392"
            y="604"
            textAnchor="middle"
            fontSize="21.5"
            fontWeight="950"
            fill="#111827"
          >
            Feedback
          </text>

          {/* V Growth */}
          <text
            x="240"
            y="454"
            textAnchor="middle"
            fontSize="47"
            fill="#16a34a"
          >
            🌱
          </text>
          <text
            x="240"
            y="518"
            textAnchor="middle"
            fontSize="21.5"
            fontWeight="950"
            fill="#111827"
          >
            Growth
          </text>

          {/* VI Baseline */}
          <text
            x="218"
            y="250"
            textAnchor="middle"
            fontSize="42"
            fill="#f4b400"
          >
            ✨
          </text>
          <text
            x="206"
            y="323"
            textAnchor="middle"
            fontSize="21.5"
            fontWeight="950"
            fill="#111827"
          >
            Baseline
          </text>
        </g>

        {/* RIGHT CARD */}
        <g>
          <rect
            x="746"
            y="76"
            width="488"
            height="618"
            rx="34"
            fill="#ffffff"
            fillOpacity="0.94"
            stroke="#e5e7eb"
            strokeWidth="1.3"
            filter="url(#cardShadowPremiumFinal4)"
          />

          <text
            x="990"
            y="128"
            textAnchor="middle"
            fontSize="34"
            fontWeight="900"
            fill="#111827"
          >
            Differentiated practice
          </text>

          <text
            x="990"
            y="164"
            textAnchor="middle"
            fontSize="34"
            fontWeight="900"
            fill="#111827"
          >
            in a learning community
          </text>

          <line
            x1="786"
            y1="192"
            x2="1194"
            y2="192"
            stroke="#e5e7eb"
            strokeWidth="1.32"
          />
          <circle cx="990" cy="192" r="5" fill="#c7d2fe" />

          {/* vertical connector arrows */}
          <g fill="none" strokeLinecap="round" strokeWidth="4.5" opacity="0.95">
            <path
              d="M830 268 L830 296"
              stroke="#3b82f6"
              markerEnd="url(#arrowBluePremiumFinal4)"
            />
            <path
              d="M830 352 L830 384"
              stroke="#8b5cf6"
              markerEnd="url(#arrowVioletPremiumFinal4)"
            />
            <path
              d="M830 440 L830 472"
              stroke="#7c3aed"
              markerEnd="url(#arrowPurplePremiumFinal4)"
            />
            <path
              d="M830 528 L830 560"
              stroke="#06b6d4"
              markerEnd="url(#arrowTealPremiumFinal4)"
            />
            <path
              d="M830 616 L830 636"
              stroke="#22c55e"
              markerEnd="url(#arrowGreenPremiumFinal4)"
            />
          </g>

          {[
            {
              y: 240,
              n: "I",
              fill: "url(#badgeBluePremiumFinal4)",
              lines: ["Raise shared expectations"],
            },
            {
              y: 324,
              n: "II",
              fill: "url(#badgePurplePremiumFinal4)",
              lines: ["Offer advanced tools", "(pitch and articulation cues)"],
            },
            {
              y: 412,
              n: "III",
              fill: "url(#badgePurplePremiumFinal4)",
              lines: ["Let learners take", "suitable challenges"],
            },
            {
              y: 500,
              n: "IV",
              fill: "url(#badgeTealPremiumFinal4)",
              lines: ["Peer feedback becomes", "more precise"],
            },
            {
              y: 588,
              n: "V",
              fill: "url(#badgeGreenPremiumFinal4)",
              lines: ["Visible examples", "help others follow"],
            },
            {
              y: 664,
              n: "VI",
              fill: "url(#badgeBluePremiumFinal4)",
              lines: ["The group baseline rises"],
            },
          ].map((row, index) => (
            <g key={row.n}>
              {index > 0 && (
                <line
                  x1="786"
                  y1={row.y - 41}
                  x2="1194"
                  y2={row.y - 41}
                  stroke="#e5e7eb"
                  strokeWidth="1.05"
                />
              )}

              <circle
                cx="830"
                cy={row.y}
                r="23.5"
                fill={row.fill}
                stroke="#ffffff"
                strokeWidth="4"
                filter="url(#softShadowPremiumFinal4)"
              />

              <text
                x="830"
                y={row.y + 8}
                textAnchor="middle"
                fontSize="21.5"
                fontWeight="900"
                fill="#ffffff"
              >
                {row.n}
              </text>

              <text
                x="880"
                y={row.lines.length === 1 ? row.y + 7 : row.y - 5}
                fontSize="18.2"
                fontWeight="850"
                fill="#111827"
              >
                {row.lines[0]}
              </text>

              {row.lines[1] && (
                <text
                  x="880"
                  y={row.y + 23}
                  fontSize="18.2"
                  fontWeight="850"
                  fill="#111827"
                >
                  {row.lines[1]}
                </text>
              )}
            </g>
          ))}
        </g>
      </svg>
    </div>
  ),
  bgColor: "bg-gradient-to-br from-white via-slate-50 to-blue-50",
},

{
  title: "",
  density: "medium",
  content: (
    <div className="mx-auto flex w-full max-w-7xl flex-col justify-center px-4 py-4 text-center sm:px-6">
      {/* CENTRAL QUOTE */}
      <div className="mx-auto max-w-5xl rounded-3xl border border-violet-100 bg-white/95 px-8 py-5 shadow-2xl ring-1 ring-white">
        <div className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-violet-50 to-blue-50 text-4xl font-black leading-none text-violet-500 shadow-md ring-1 ring-violet-100">
          “
        </div>

        <div className="mx-auto mt-3 max-w-4xl text-lg font-semibold italic leading-relaxed text-slate-800 lg:text-xl">
          “Life by its very nature is dialogic. To live means to participate
          in dialogue: to ask questions, to heed, to respond…”
        </div>

        <div className="mx-auto mt-4 h-1 w-24 rounded-full bg-gradient-to-r from-blue-500 via-violet-500 to-purple-600" />

        <div className="mt-3 text-xs font-black uppercase tracking-widest text-slate-400">
          Mikhail Bakhtin
        </div>
      </div>

      <div className="mx-auto mt-5 grid w-full max-w-6xl gap-6 lg:grid-cols-2">
        {/* LEFT: INDIVIDUAL APP PATH */}
        <div className="rounded-3xl border border-slate-200 bg-white/95 p-5 shadow-xl">
          <div className="flex items-center justify-between gap-3">
            <div className="text-left">
              <div className="text-xs font-black uppercase tracking-widest text-slate-700">
                Individual practice
              </div>
              <div className="mt-1 text-sm font-black text-slate-500">
                Same sequence for everyone
              </div>
            </div>

            <div className="rounded-full border border-slate-300 bg-white px-4 py-2 text-xs font-black uppercase tracking-wider text-slate-600 shadow-sm">
              fixed route
            </div>
          </div>

          <div className="relative mt-4 h-72 overflow-hidden rounded-3xl border border-slate-200 bg-gradient-to-br from-slate-50 via-white to-blue-50 shadow-inner">
            <svg
              className="absolute inset-0 h-full w-full"
              viewBox="0 0 620 280"
              preserveAspectRatio="none"
            >
              <rect
                x="40"
                y="24"
                width="540"
                height="232"
                rx="34"
                fill="rgb(248 250 252)"
                opacity="0.92"
              />

              {/* isolated parallel lanes */}
              {[62, 96, 130, 164, 198, 232].map((y) => (
                <g key={y}>
                  <path
                    d={`M92 ${y} L552 ${y}`}
                    fill="none"
                    stroke="rgb(226 232 240)"
                    strokeWidth="10"
                    strokeLinecap="round"
                  />
                  <path
                    d={`M92 ${y} L552 ${y}`}
                    fill="none"
                    stroke="rgb(100 116 139)"
                    strokeWidth="2.6"
                    strokeLinecap="round"
                    strokeDasharray="10 11"
                    opacity="0.78"
                  />
                  <path
                    d={`M538 ${y - 9} L554 ${y} L538 ${y + 9}`}
                    fill="none"
                    stroke="rgb(100 116 139)"
                    strokeWidth="3.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    opacity="0.9"
                  />
                </g>
              ))}

              <text
                x="310"
                y="266"
                textAnchor="middle"
                fill="rgb(71 85 105)"
                stroke="white"
                strokeWidth="6"
                paintOrder="stroke"
                dominantBaseline="middle"
                style={{
                  fontSize: 14,
                  fontWeight: 850,
                  letterSpacing: "0.08em",
                }}
              >
                isolated repetition
              </text>
            </svg>

            {/* identical isolated learners */}
            {[
              { left: "7%", top: "15%" },
              { left: "7%", top: "27%" },
              { left: "7%", top: "39%" },
              { left: "7%", top: "51%" },
              { left: "7%", top: "63%" },
              { left: "7%", top: "75%" },
            ].map((p, index) => (
              <div
                key={index}
                className="absolute"
                style={{ left: p.left, top: p.top }}
              >
                <div className="relative h-9 w-9">
                  <div className="absolute left-1/2 top-0 h-4 w-4 -translate-x-1/2 rounded-full bg-slate-500 shadow-md ring-4 ring-white" />
                  <div className="absolute bottom-0 left-1/2 h-5 w-7 -translate-x-1/2 rounded-t-2xl bg-slate-500 shadow-md ring-4 ring-white" />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT: DIALOGIC PATH */}
        <div className="relative overflow-hidden rounded-3xl border border-violet-200 bg-gradient-to-br from-violet-50 via-white to-blue-50 p-5 shadow-2xl">
          <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-violet-200/40 blur-2xl" />
          <div className="absolute -bottom-16 -left-16 h-48 w-48 rounded-full bg-blue-200/40 blur-2xl" />

          <div className="relative flex items-center justify-between gap-3">
            <div className="text-left">
              <div className="text-xs font-black uppercase tracking-widest text-violet-800">
                Interaction
              </div>
              <div className="mt-1 text-sm font-black text-violet-700">
                Paths adapt through interaction
              </div>
            </div>

            <div className="rounded-full border border-violet-200 bg-white px-4 py-2 text-xs font-black uppercase tracking-wider text-violet-700 shadow-sm">
              changing route
            </div>
          </div>

          <div className="relative mt-4 h-72 overflow-hidden rounded-3xl border border-white bg-white/80 shadow-inner">
            <svg
              className="absolute inset-0 h-full w-full"
              viewBox="0 0 620 280"
              preserveAspectRatio="none"
            >
              {/* soft social fields */}
              <circle cx="165" cy="88" r="64" fill="rgb(196 181 253)" opacity="0.24" />
              <circle cx="305" cy="148" r="88" fill="rgb(147 197 253)" opacity="0.23" />
              <circle cx="442" cy="88" r="70" fill="rgb(110 231 183)" opacity="0.18" />
              <circle cx="455" cy="198" r="68" fill="rgb(244 114 182)" opacity="0.16" />

              {/* subtle interaction traces */}
              <path
                d="M110 188 C182 108, 252 100, 322 140 C390 178, 462 166, 528 104"
                fill="none"
                stroke="rgb(100 116 139)"
                strokeWidth="2.3"
                strokeLinecap="round"
                strokeDasharray="6 10"
                opacity="0.34"
              />
              <path
                d="M200 72 C272 36, 382 46, 434 110 C478 166, 455 220, 360 232"
                fill="none"
                stroke="rgb(168 85 247)"
                strokeWidth="2.3"
                strokeLinecap="round"
                strokeDasharray="5 9"
                opacity="0.3"
              />
              <path
                d="M145 132 C225 184, 305 182, 388 126 C438 92, 480 94, 528 122"
                fill="none"
                stroke="rgb(14 165 233)"
                strokeWidth="2.3"
                strokeLinecap="round"
                strokeDasharray="4 9"
                opacity="0.28"
              />

              {/* living paths */}
              <path
                d="M54 198 C130 78, 224 70, 306 130 C390 192, 464 166, 560 82"
                fill="none"
                stroke="rgb(124 58 237)"
                strokeWidth="6.5"
                strokeLinecap="round"
              />

              <path
                d="M58 86 C146 164, 246 190, 336 130 C422 76, 492 88, 560 142"
                fill="none"
                stroke="rgb(37 99 235)"
                strokeWidth="5.6"
                strokeLinecap="round"
                opacity="0.96"
              />

              <path
                d="M70 140 C156 94, 246 112, 318 164 C392 216, 462 204, 545 154"
                fill="none"
                stroke="rgb(20 184 166)"
                strokeWidth="5"
                strokeLinecap="round"
                opacity="0.86"
              />

              <path
                d="M66 228 C150 220, 205 176, 282 184 C356 194, 402 242, 560 216"
                fill="none"
                stroke="rgb(236 72 153)"
                strokeWidth="5"
                strokeLinecap="round"
                opacity="0.82"
              />

              <path
                d="M70 220 C154 218, 210 179, 306 164 C410 144, 456 132, 546 174"
                fill="none"
                stroke="rgb(249 115 22)"
                strokeWidth="4.5"
                strokeLinecap="round"
                opacity="0.72"
              />

              {/* arrowheads */}
              <path
                d="M546 87 L562 81 L554 99"
                fill="none"
                stroke="rgb(124 58 237)"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M548 135 L563 142 L548 153"
                fill="none"
                stroke="rgb(37 99 235)"
                strokeWidth="4.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M530 148 L547 154 L532 166"
                fill="none"
                stroke="rgb(20 184 166)"
                strokeWidth="4.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M545 208 L562 216 L546 228"
                fill="none"
                stroke="rgb(236 72 153)"
                strokeWidth="4.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />

              <text
                x="310"
                y="266"
                textAnchor="middle"
                fill="rgb(109 40 217)"
                stroke="white"
                strokeWidth="6"
                paintOrder="stroke"
                dominantBaseline="middle"
                style={{
                  fontSize: 14,
                  fontWeight: 850,
                  letterSpacing: "0.07em",
                }}
              >
                response · adjustment · attention shift
              </text>
            </svg>

            {/* diverse learners */}
            {[
              {
                left: "7%",
                top: "52%",
                color: "bg-violet-500",
                size: "h-11 w-11",
                head: "h-5 w-5",
                body: "h-7 w-9",
              },
              {
                left: "18%",
                top: "72%",
                color: "bg-orange-400",
                size: "h-12 w-12",
                head: "h-5 w-5",
                body: "h-8 w-10",
              },
              {
                left: "30%",
                top: "16%",
                color: "bg-blue-500",
                size: "h-12 w-12",
                head: "h-5 w-5",
                body: "h-8 w-10",
              },
              {
                left: "40%",
                top: "44%",
                color: "bg-teal-600",
                size: "h-14 w-14",
                head: "h-6 w-6",
                body: "h-8 w-11",
              },
              {
                left: "55%",
                top: "76%",
                color: "bg-indigo-500",
                size: "h-10 w-10",
                head: "h-4 w-4",
                body: "h-6 w-8",
              },
              {
                left: "67%",
                top: "20%",
                color: "bg-violet-600",
                size: "h-12 w-12",
                head: "h-6 w-6",
                body: "h-8 w-10",
              },
              {
                left: "82%",
                top: "50%",
                color: "bg-amber-400",
                size: "h-11 w-11",
                head: "h-5 w-5",
                body: "h-7 w-9",
              },
            ].map((p, index) => (
              <div
                key={index}
                className="absolute"
                style={{ left: p.left, top: p.top }}
              >
                <div className={`relative ${p.size}`}>
                  <div
                    className={`absolute left-1/2 top-0 ${p.head} -translate-x-1/2 rounded-full ${p.color} shadow-lg ring-4 ring-white`}
                  />
                  <div
                    className={`absolute bottom-0 left-1/2 ${p.body} -translate-x-1/2 rounded-t-2xl ${p.color} shadow-lg ring-4 ring-white`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="mx-auto mt-5 max-w-4xl text-lg font-bold leading-relaxed text-slate-700">
        In individual practice, the route is usually fixed.
        <br className="hidden sm:block" />
        In interaction, the next step can change.
      </div>
    </div>
  ),
  bgColor: "bg-gradient-to-br from-white via-slate-50 to-blue-50",
},
    {
      title: "",
      density: "medium",
      content: (
        <div className={ui.shell.standard}>
          <div className={ui.label.purple}>Model under development</div>

          <h3 className={ui.title.main}>
            Dialogue practice as
            <br />
            role rehearsal.
          </h3>

          <p className={ui.text.lead}>
            Learners first build familiarity with the whole dialogue,
            then rehearse one role with gradually reduced support.
          </p>

          <div className={`${ui.spacing.section} mx-auto grid w-full max-w-6xl items-stretch gap-4 md:grid-cols-[1fr_38px_1fr_38px_1fr_38px_1fr] max-h-[720px]:gap-2`}>
            {[
              {
                label: "step 1",
                titleA: "Repeat",
                titleB: "all lines",
                body: ["listen", "echo", "shadow"],
                border: "border-blue-100",
                text: "text-blue-700",
                bg: "bg-blue-50",
              },
              {
                label: "step 2",
                titleA: "Pick",
                titleB: "a role",
                body: ["Person A", "Person B", "same scene"],
                border: "border-purple-100",
                text: "text-purple-700",
                bg: "bg-purple-50",
              },
              {
                label: "step 3",
                titleA: "Perform",
                titleB: "the role",
                body: ["partner line plays", "you answer", "cues if needed"],
                border: "border-pink-100",
                text: "text-pink-700",
                bg: "bg-pink-50",
              },
              {
                label: "step 4",
                titleA: "Get",
                titleB: "a score",
                body: ["pronunciation", "timing", "cue use"],
                border: "border-emerald-100",
                text: "text-emerald-700",
                bg: "bg-emerald-50",
              },
            ].map((step, index) => (
              <div key={step.label} className="contents">
                <SoftCard
                  className={`${ui.card.base} ${step.border} px-5 py-5 text-center max-h-[720px]:px-3 max-h-[720px]:py-4`}
                >
                  <div className={`text-[10px] font-black uppercase tracking-[0.2em] ${step.text}`}>
                    {step.label}
                  </div>

                  <div className="mt-4 flex min-h-[70px] items-center justify-center text-[clamp(1.15rem,1.5vw,1.45rem)] font-black leading-tight text-gray-950 max-h-[720px]:mt-2 max-h-[720px]:min-h-[44px] max-h-[720px]:text-base">
                    {step.titleA}
                    <br />
                    {step.titleB}
                  </div>

                  <div className={`mx-auto mt-5 rounded-2xl ${step.bg} px-4 py-4 text-[clamp(0.95rem,1.1vw,1.05rem)] font-black leading-relaxed text-gray-700 max-h-[720px]:mt-3 max-h-[720px]:px-3 max-h-[720px]:py-3 max-h-[720px]:text-sm`}>
                    {step.body.map((line) => (
                      <div key={line}>{line}</div>
                    ))}
                  </div>
                </SoftCard>

                {index < 3 && (
                  <div className="hidden items-center justify-center md:flex">
                    <div className="text-3xl font-black text-purple-300 max-h-[720px]:text-2xl">→</div>
                  </div>
                )}
              </div>
            ))}
          </div>

          <div className="mx-auto mt-7 w-full max-w-5xl rounded-[2rem] border border-gray-200/80 bg-white/84 px-6 py-5 shadow-sm ring-1 ring-white/80 max-h-[720px]:mt-3 max-h-[720px]:px-4 max-h-[720px]:py-3">
            <div className="text-xs font-black uppercase tracking-[0.2em] text-gray-500 max-h-[720px]:text-[10px]">
              cue ladder
            </div>

            <div className="mx-auto mt-4 grid gap-3 md:grid-cols-4 max-h-[720px]:mt-2 max-h-[720px]:gap-2">
              {["first word", "reshuffled sentence", "voiced line", "voice + text"].map(
                (cue) => (
                  <div
                    key={cue}
                    className="rounded-2xl bg-gray-50 px-4 py-3 text-[clamp(0.95rem,1.1vw,1.05rem)] font-black text-gray-900 ring-1 ring-gray-100 max-h-[720px]:px-3 max-h-[720px]:py-2 max-h-[720px]:text-sm"
                  >
                    {cue}
                  </div>
                )
              )}
            </div>

            <div className="mx-auto mt-4 max-w-4xl text-sm font-bold leading-relaxed text-gray-600 max-h-[720px]:mt-2">
              Learners are rewarded not only for accuracy,
              but for needing less support.
            </div>
          </div>
        </div>
      ),
      bgColor:
        "bg-[radial-gradient(circle_at_top_left,_#dbeafe,_transparent_32%),radial-gradient(circle_at_bottom_right,_#f3e8ff,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
    },

   {
  title: "",
  density: "medium",
  content: (
    <div className="mx-auto flex min-h-[540px] max-w-7xl flex-col justify-center px-4 py-3 text-center sm:px-6 max-h-[720px]:min-h-[490px] max-h-[720px]:py-2">
      {/* HEADER */}
      <div className="mx-auto max-w-5xl text-center">
        <div className={ui.label.green}>Social challenge model</div>

        <h3 className="mx-auto mt-3 max-w-4xl text-[clamp(1.75rem,2.45vw,2.45rem)] font-black leading-[1.07] tracking-tight text-gray-950 max-h-[760px]:text-[clamp(1.55rem,2.15vw,2.1rem)] max-h-[720px]:mt-2 max-h-[720px]:text-[1.6rem]">
          One learner challenges another.
        </h3>

       
      </div>

      {/* DIAGRAM */}
      <div className="mx-auto mt-7 w-full max-w-6xl max-h-[760px]:mt-6 max-h-[720px]:mt-4">
        {/* TOP ROW */}
        <div className="grid items-center gap-5 lg:grid-cols-[1fr_118px_1fr] max-h-[720px]:gap-4">
          {/* LEARNER 1 */}
          <div className="relative pt-6 max-h-[720px]:pt-5">
            <div className="absolute left-1/2 top-0 z-10 -translate-x-1/2">
              <div className="rounded-full border border-blue-200 bg-blue-50/95 px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.22em] text-blue-700 shadow-sm ring-1 ring-white/80 max-h-[720px]:px-3 max-h-[720px]:py-1 max-h-[720px]:text-[9px]">
                Learner 1
              </div>
            </div>

            <SoftCard className="flex min-h-[210px] flex-col items-center justify-center rounded-[2.2rem] border border-blue-100 bg-white/92 px-6 py-6 text-center shadow-sm ring-1 ring-white/80 max-h-[720px]:min-h-[178px] max-h-[720px]:rounded-[1.9rem] max-h-[720px]:px-5 max-h-[720px]:py-4">
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-blue-50 text-4xl shadow-sm ring-1 ring-blue-100 max-h-[720px]:h-14 max-h-[720px]:w-14 max-h-[720px]:text-3xl">
                🧑‍🦱
              </div>

              <div className="mt-4 text-[clamp(1.35rem,1.75vw,1.72rem)] font-black leading-tight text-gray-950 max-h-[720px]:mt-3 max-h-[720px]:text-[1.18rem]">
                Performs
                <br />
                the role
              </div>

              <div className="mx-auto mt-4 w-full max-w-[220px] rounded-[1.35rem] bg-blue-50 px-5 py-3.5 text-[0.92rem] font-black leading-relaxed text-gray-700 ring-1 ring-blue-100/70 max-h-[720px]:mt-3 max-h-[720px]:px-4 max-h-[720px]:py-3 max-h-[720px]:text-xs">
                performs first
                <br />
                sends challenge
              </div>
            </SoftCard>
          </div>

          {/* CHALLENGE CONNECTOR */}
          <div className="hidden lg:flex lg:flex-col lg:items-center lg:justify-center lg:pt-6">
            <div className="rounded-full border border-purple-200 bg-white/88 px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.2em] text-purple-700 shadow-sm ring-1 ring-white/80">
              challenge
            </div>

            <div className="mt-3 flex h-13 w-24 items-center justify-center rounded-full bg-white/80 text-5xl font-black text-purple-400 shadow-sm ring-1 ring-purple-100 max-h-[720px]:h-11 max-h-[720px]:text-4xl">
              →
            </div>

            <div className="mt-3 text-[10px] font-black uppercase tracking-[0.18em] text-purple-400">
              same task
            </div>
          </div>

          {/* LEARNER 2 */}
          <div className="relative pt-6 max-h-[720px]:pt-5">
            <div className="absolute left-1/2 top-0 z-10 -translate-x-1/2">
              <div className="rounded-full border border-emerald-200 bg-emerald-50/95 px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.22em] text-emerald-700 shadow-sm ring-1 ring-white/80 max-h-[720px]:px-3 max-h-[720px]:py-1 max-h-[720px]:text-[9px]">
                Learner 2
              </div>
            </div>

            <SoftCard className="flex min-h-[210px] flex-col items-center justify-center rounded-[2.2rem] border border-emerald-100 bg-white/92 px-6 py-6 text-center shadow-sm ring-1 ring-white/80 max-h-[720px]:min-h-[178px] max-h-[720px]:rounded-[1.9rem] max-h-[720px]:px-5 max-h-[720px]:py-4">
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-emerald-50 text-4xl shadow-sm ring-1 ring-emerald-100 max-h-[720px]:h-14 max-h-[720px]:w-14 max-h-[720px]:text-3xl">
                👩‍🦰
              </div>

              <div className="mt-4 text-[clamp(1.35rem,1.75vw,1.72rem)] font-black leading-tight text-gray-950 max-h-[720px]:mt-3 max-h-[720px]:text-[1.18rem]">
                Accepts
                <br />
                the challenge
              </div>

              <div className="mx-auto mt-4 w-full max-w-[220px] rounded-[1.35rem] bg-emerald-50 px-5 py-3.5 text-[0.92rem] font-black leading-relaxed text-gray-700 ring-1 ring-emerald-100/70 max-h-[720px]:mt-3 max-h-[720px]:px-4 max-h-[720px]:py-3 max-h-[720px]:text-xs">
                same scene
                <br />
                same role
              </div>
            </SoftCard>
          </div>
        </div>

        {/* CONNECTORS DOWN */}
        <div className="mx-auto hidden max-w-4xl grid-cols-[1fr_1fr] gap-28 lg:grid">
          <div className="flex justify-end pr-10">
            <div className="h-8 w-28 border-b-2 border-r-2 border-purple-200/90 max-h-[720px]:h-6" />
          </div>

          <div className="flex justify-start pl-10">
            <div className="h-8 w-28 border-b-2 border-l-2 border-purple-200/90 max-h-[720px]:h-6" />
          </div>
        </div>

        {/* SHARED COMPARISON */}
        <div className="mx-auto mt-2 max-w-4xl max-h-[720px]:mt-1">
          <SoftCard className="relative overflow-hidden rounded-[2.15rem] border border-purple-200 bg-white/96 px-7 py-5 text-center shadow-md ring-1 ring-purple-100 max-h-[720px]:rounded-[1.8rem] max-h-[720px]:px-5 max-h-[720px]:py-4">
            <div className="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500" />

            <div className="mx-auto inline-flex rounded-full border border-purple-200 bg-purple-50 px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.22em] text-purple-700 shadow-sm max-h-[720px]:py-1 max-h-[720px]:text-[9px]">
              Shared comparison
            </div>

            <div className="mt-4 grid items-center gap-5 md:grid-cols-[0.9fr_1.2fr_0.9fr] max-h-[720px]:mt-3 max-h-[720px]:gap-3">
              <div className="flex flex-col items-center justify-center">
                <div className="flex h-13 w-13 items-center justify-center rounded-full bg-purple-50 text-3xl shadow-sm ring-1 ring-purple-100 max-h-[720px]:h-11 max-h-[720px]:w-11 max-h-[720px]:text-2xl">
                  🧑‍🦱
                </div>

                <div className="mt-2 text-[clamp(1rem,1.18vw,1.15rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-sm">
                  Learner 1
                </div>
              </div>

              <div>
                <div className="text-[clamp(1.35rem,1.75vw,1.72rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-[1.18rem]">
                  Scores can
                  <br />
                  be compared.
                </div>

                <div className="mx-auto mt-4 grid max-w-md gap-3 md:grid-cols-2 max-h-[720px]:mt-3 max-h-[720px]:gap-2">
                  {["score", "replay"].map((item) => (
                    <div
                      key={item}
                      className="rounded-2xl bg-purple-50 px-4 py-3 text-sm font-black text-gray-700 ring-1 ring-purple-100/70 max-h-[720px]:px-3 max-h-[720px]:py-2 max-h-[720px]:text-xs"
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex flex-col items-center justify-center">
                <div className="flex h-13 w-13 items-center justify-center rounded-full bg-purple-50 text-3xl shadow-sm ring-1 ring-purple-100 max-h-[720px]:h-11 max-h-[720px]:w-11 max-h-[720px]:text-2xl">
                  👩‍🦰
                </div>

                <div className="mt-2 text-[clamp(1rem,1.18vw,1.15rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-sm">
                  Learner 2
                </div>
              </div>
            </div>
          </SoftCard>
        </div>
      </div>

      {/* BOTTOM */}
      <div className="mx-auto mt-5 max-w-5xl rounded-[2rem] bg-gradient-to-r from-emerald-100 via-blue-100 to-purple-100 px-8 py-4 text-center shadow-sm ring-1 ring-white/80 max-h-[760px]:mt-4 max-h-[720px]:mt-3 max-h-[720px]:px-5 max-h-[720px]:py-3">
        <div className="text-[clamp(1.02rem,1.32vw,1.25rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-sm">
          Practice becomes something learners can share, compare, and improve.
        </div>
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#dcfce7,_transparent_32%),radial-gradient(circle_at_bottom_right,_#dbeafe,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
},
    {
  title: "",
  density: "medium",
  content: (
    <div className="mx-auto flex min-h-[560px] max-w-7xl flex-col justify-center px-4 py-4 text-center sm:px-6 max-h-[720px]:min-h-[500px] max-h-[720px]:py-3">
      {/* HEADER */}
      <div className="mx-auto max-w-5xl">
        <div className="mx-auto inline-flex rounded-full border border-emerald-200 bg-emerald-50/90 px-5 py-1.5 text-[11px] font-black uppercase tracking-[0.26em] text-emerald-700 shadow-sm ring-1 ring-white/80 max-h-[720px]:px-4 max-h-[720px]:py-1 max-h-[720px]:text-[9px]">
          Possible use in offline practice
        </div>

        <h3 className="mx-auto mt-4 max-w-5xl text-[clamp(1.75rem,2.55vw,2.65rem)] font-black leading-[1.07] tracking-tight text-gray-950 max-h-[760px]:text-[clamp(1.55rem,2.2vw,2.15rem)] max-h-[720px]:mt-3 max-h-[720px]:text-[1.65rem]">
          Online rehearsal can make
          <br />
          real-life speech practice more purposeful.
        </h3>

        <p className="mx-auto mt-4 max-w-4xl text-[clamp(0.95rem,1.08vw,1.08rem)] font-semibold leading-relaxed text-gray-600 max-h-[720px]:mt-3 max-h-[720px]:text-sm">
          Learners prepare before language cafés, class sessions,
          speech clubs, or guided events — so the meeting can focus more on interaction.
        </p>
      </div>

      {/* MAIN FLOW */}
      <div className="mx-auto mt-9 grid w-full max-w-6xl items-stretch gap-5 md:grid-cols-[1fr_76px_1fr] max-h-[760px]:mt-7 max-h-[720px]:mt-5 max-h-[720px]:gap-4">
        {/* BEFORE */}
        <SoftCard className="relative overflow-hidden rounded-[2.35rem] border border-purple-100 bg-white/92 px-7 py-7 text-left shadow-sm ring-1 ring-purple-100/70 max-h-[720px]:rounded-[1.9rem] max-h-[720px]:px-5 max-h-[720px]:py-5">
          <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-purple-500 to-blue-500" />

          <div className="flex items-start gap-4">
            <div className="flex h-13 w-13 shrink-0 items-center justify-center rounded-2xl bg-purple-50 text-3xl shadow-sm ring-1 ring-purple-100 max-h-[720px]:h-11 max-h-[720px]:w-11 max-h-[720px]:text-2xl">
              📝
            </div>

            <div>
              <div className="text-[10px] font-black uppercase tracking-[0.24em] text-purple-700">
                before the gathering
              </div>

              <h4 className="mt-3 text-[clamp(1.32rem,1.75vw,1.8rem)] font-black leading-tight text-gray-950 max-h-[720px]:mt-2 max-h-[720px]:text-[1.22rem]">
                Purposeful
                <br />
                preparation
              </h4>
            </div>
          </div>

          <div className="mt-6 space-y-3 max-h-[720px]:mt-4 max-h-[720px]:space-y-2.5">
            {[
              "practice dialogue roles",
              "repeat difficult lines",
              "receive feedback",
              "arrive more confident",
            ].map((item) => (
              <div
                key={item}
                className="rounded-2xl bg-purple-50/70 px-4 py-3 text-[clamp(0.92rem,1.03vw,1.02rem)] font-black leading-tight text-gray-800 ring-1 ring-purple-100/70 max-h-[720px]:px-3 max-h-[720px]:py-2 max-h-[720px]:text-sm"
              >
                {item}
              </div>
            ))}
          </div>
        </SoftCard>

        {/* CENTER CONNECTOR */}
        <div className="hidden flex-col items-center justify-center md:flex">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white/85 text-4xl font-black text-purple-400 shadow-sm ring-1 ring-purple-100 max-h-[720px]:h-13 max-h-[720px]:w-13 max-h-[720px]:text-3xl">
            →
          </div>

          <div className="mt-4 rounded-full border border-purple-100 bg-white/75 px-4 py-2 text-[9px] font-black uppercase leading-relaxed tracking-[0.22em] text-purple-500 shadow-sm max-h-[720px]:mt-3 max-h-[720px]:px-3 max-h-[720px]:py-1.5 max-h-[720px]:text-[8px]">
            prepared
            <br />
            participation
          </div>
        </div>

        {/* DURING */}
        <SoftCard className="relative overflow-hidden rounded-[2.35rem] border border-emerald-100 bg-white/92 px-7 py-7 text-left shadow-sm ring-1 ring-emerald-100/70 max-h-[720px]:rounded-[1.9rem] max-h-[720px]:px-5 max-h-[720px]:py-5">
          <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-blue-500 to-emerald-500" />

          <div className="flex items-start gap-4">
            <div className="flex h-13 w-13 shrink-0 items-center justify-center rounded-2xl bg-emerald-50 text-3xl shadow-sm ring-1 ring-emerald-100 max-h-[720px]:h-11 max-h-[720px]:w-11 max-h-[720px]:text-2xl">
              ☕
            </div>

            <div>
              <div className="text-[10px] font-black uppercase tracking-[0.24em] text-emerald-700">
                during the gathering
              </div>

              <h4 className="mt-3 text-[clamp(1.32rem,1.75vw,1.8rem)] font-black leading-tight text-gray-950 max-h-[720px]:mt-2 max-h-[720px]:text-[1.22rem]">
                More useful
                <br />
                interaction
              </h4>
            </div>
          </div>

          <div className="mt-6 space-y-3 max-h-[720px]:mt-4 max-h-[720px]:space-y-2.5">
            {[
              "more time for speech",
              "less basic repair",
              "more contextual feedback",
              "stronger continuity",
            ].map((item) => (
              <div
                key={item}
                className="rounded-2xl bg-emerald-50/70 px-4 py-3 text-[clamp(0.92rem,1.03vw,1.02rem)] font-black leading-tight text-gray-800 ring-1 ring-emerald-100/70 max-h-[720px]:px-3 max-h-[720px]:py-2 max-h-[720px]:text-sm"
              >
                {item}
              </div>
            ))}
          </div>
        </SoftCard>
      </div>

      {/* FINAL MESSAGE */}
      <div className="mx-auto mt-8 max-w-5xl rounded-[2rem] bg-gradient-to-r from-emerald-100 via-blue-100 to-purple-100 px-8 py-5 text-center shadow-sm ring-1 ring-white/80 max-h-[760px]:mt-6 max-h-[720px]:mt-5 max-h-[720px]:px-5 max-h-[720px]:py-3">
        <div className="text-[clamp(1.08rem,1.42vw,1.38rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-base">
          The platform does not replace offline practice.
          <br />
          It helps learners arrive ready to speak.
        </div>
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#dcfce7,_transparent_30%),radial-gradient(circle_at_bottom_right,_#f3e8ff,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
},
  ],
},

overviewNo: {
  label: "Norsk",
  description: "kjernepitch",
  slides: [
   {
  title: "",
  density: "medium",
  content: (
    <div className="mx-auto flex min-h-[500px] max-w-7xl flex-col justify-center px-4 py-5 text-center sm:px-6 lg:min-h-[600px] max-h-[720px]:min-h-[430px] max-h-[680px]:min-h-[405px] max-h-[720px]:py-3">
      <div className="mx-auto mb-7 inline-flex rounded-full border border-red-200 bg-red-50/80 px-5 py-1.5 text-[10px] font-black uppercase tracking-[0.28em] text-red-700 shadow-sm ring-1 ring-white/80 max-h-[720px]:mb-5 max-h-[720px]:px-4 max-h-[720px]:py-1 max-h-[720px]:text-[9px]">
        Etter kurset
      </div>

      <h1 className="mx-auto max-w-5xl font-mono text-[clamp(2rem,3vw,3.15rem)] font-black leading-[1.02] tracking-tight text-gray-950 max-h-[760px]:text-[clamp(1.85rem,2.75vw,2.75rem)] max-h-[720px]:text-[2.35rem] max-h-[680px]:text-[2.1rem]">
        Studenten er ferdig
        <br />
        med kurset.
        <br />
        <span className="tracking-normal">Hva nå?</span>
      </h1>

      <div className="mx-auto mt-6 h-1.5 w-52 rounded-full bg-gradient-to-r from-blue-600 via-purple-600 to-pink-500 sm:w-64 max-h-[720px]:mt-5 max-h-[720px]:h-1" />

      <div className="mx-auto mt-10 grid w-full max-w-4xl gap-5 text-left md:grid-cols-3 max-h-[760px]:mt-8 max-h-[720px]:mt-7 max-h-[720px]:gap-4">
        <SoftCard className="rounded-[2rem] border-white/70 bg-white/88 px-6 py-6 shadow-sm ring-1 ring-white/80 transition-transform duration-300 hover:-translate-y-1 max-h-[720px]:px-5 max-h-[720px]:py-5">
          <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-blue-50 shadow-sm ring-1 ring-blue-100 max-h-[720px]:mb-4 max-h-[720px]:h-14 max-h-[720px]:w-14">
            <svg width="42" height="42" viewBox="0 0 54 54" fill="none">
              <circle cx="27" cy="27" r="21" stroke="#2563eb" strokeWidth="3" />
              <circle cx="20" cy="23" r="2.8" fill="#2563eb" />
              <circle cx="34" cy="23" r="2.8" fill="#2563eb" />
              <path
                d="M20 34H34"
                stroke="#2563eb"
                strokeWidth="3"
                strokeLinecap="round"
              />
            </svg>
          </div>

          <div className="text-[clamp(1rem,1.18vw,1.12rem)] font-black leading-[1.16] text-gray-900 max-h-[720px]:text-[0.96rem]">
            Kan følge med
            <br />
            i undervisningen ...
            <br />
            men ekte samtaler
            <br />
            føles fortsatt usikre.
          </div>
        </SoftCard>

        <SoftCard className="rounded-[2rem] border-white/70 bg-white/88 px-6 py-6 shadow-sm ring-1 ring-white/80 transition-transform duration-300 hover:-translate-y-1 max-h-[720px]:px-5 max-h-[720px]:py-5">
          <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-violet-50 shadow-sm ring-1 ring-violet-100 max-h-[720px]:mb-4 max-h-[720px]:h-14 max-h-[720px]:w-14">
            <svg width="44" height="44" viewBox="0 0 56 56" fill="none">
              <path
                d="M15 46V22L28 12L41 22V46"
                stroke="#7c3aed"
                strokeWidth="3"
                strokeLinejoin="round"
              />
              <path d="M23 46V34H33V46" stroke="#7c3aed" strokeWidth="3" />
              <path
                d="M21 27H21.01"
                stroke="#7c3aed"
                strokeWidth="4"
                strokeLinecap="round"
              />
              <path
                d="M35 27H35.01"
                stroke="#7c3aed"
                strokeWidth="4"
                strokeLinecap="round"
              />
            </svg>
          </div>

          <div className="text-[clamp(1rem,1.18vw,1.12rem)] font-black leading-[1.16] text-gray-900 max-h-[720px]:text-[0.96rem]">
            Grunnlaget
            <br />
            er på plass.
            <br />
            Tryggheten trenger
            <br />
            fortsatt øving.
          </div>
        </SoftCard>

        <SoftCard className="rounded-[2rem] border-white/70 bg-white/88 px-6 py-6 shadow-sm ring-1 ring-white/80 transition-transform duration-300 hover:-translate-y-1 max-h-[720px]:px-5 max-h-[720px]:py-5">
          <div className="mb-5 flex h-16 w-16 items-center justify-center rounded-full bg-rose-50 shadow-sm ring-1 ring-rose-100 max-h-[720px]:mb-4 max-h-[720px]:h-14 max-h-[720px]:w-14">
            <svg width="52" height="40" viewBox="0 0 74 54" fill="none">
              <path
                d="M8 46V10"
                stroke="#9ca3af"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M8 46H66"
                stroke="#9ca3af"
                strokeWidth="3"
                strokeLinecap="round"
              />
              <path
                d="M18 36 L34 20 L48 20 L62 20"
                stroke="#f43f5e"
                strokeWidth="4.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <circle cx="34" cy="20" r="4.5" fill="#f43f5e" />
              <circle cx="48" cy="20" r="4.5" fill="#f43f5e" />
            </svg>
          </div>

          <div className="text-[clamp(1rem,1.18vw,1.12rem)] font-black leading-[1.16] text-gray-900 max-h-[720px]:text-[0.96rem]">
            Fremgangen
            <br />
            går saktere.
            <br />
            Vaner setter seg.
            <br />
            Hva bør skje nå?
          </div>
        </SoftCard>
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#dbeafe,_transparent_35%),radial-gradient(circle_at_bottom_right,_#fce7f3,_transparent_35%),linear-gradient(135deg,#ffffff,#f8fafc)]",
},

    {
      title: "",
      density: "dense",
      content: (
        <div className={ui.shell.standard}>
          <h2 className={ui.title.main}>Vanlige veier etter kurs.</h2>

          <div className={ui.spacing.titleRule} />

          <div className={`${ui.spacing.section} mx-auto grid w-full max-w-6xl grid-cols-1 gap-5 text-center md:grid-cols-2 lg:grid-cols-4 max-h-[720px]:gap-3`}>
            {[
              {
                icon: "🌍",
                title: "Språkmiljø",
                circle: "bg-blue-50",
                line: "bg-blue-500",
                text: <>Man kommuniserer,<br />men ofte med<br />de samme trygge frasene.</>,
                bold: <>Overlevelsesflyt<br />blir en rutine.</>,
              },
              {
                icon: "📱",
                title: "Språkapper",
                circle: "bg-violet-50",
                line: "bg-violet-500",
                text: <>Gode for repetisjon,<br />men svake på ekte<br />menneskelig samspill.</>,
                bold: <>Streaks skaper ikke<br />samtale.</>,
              },
              {
                icon: "🧑‍🏫",
                title: "Privatlærer",
                circle: "bg-amber-50",
                line: "bg-amber-500",
                text: <>Én-til-én hjelper,<br />men kan føles intenst<br />og vurderende.</>,
                bold: <>Muntlig trygghet trenger<br />mer enn korreksjon.</>,
              },
              {
                icon: "☕",
                title: "Språkkafé",
                circle: "bg-rose-50",
                line: "bg-rose-500",
                text: <>Sosialt og trygt,<br />men ofte løst<br />og uregelmessig.</>,
                bold: <>Fremgang trenger kontinuitet<br />og forpliktelse.</>,
              },
            ].map((item) => (
              <SoftCard
                key={item.title}
                className={`${ui.card.base} ${ui.card.pad} sm:min-h-[260px] lg:min-h-[280px] max-h-[720px]:min-h-[210px]`}
              >
                <div className={`${ui.card.icon} ${item.circle}`}>{item.icon}</div>

                <h3 className={`mt-4 ${ui.title.card} max-h-[720px]:mt-3`}>
                  {item.title}
                </h3>

                <div className={`mx-auto mt-3 h-1 w-12 rounded-full ${item.line} max-h-[720px]:mt-2 max-h-[720px]:w-10`} />

                <p className={`mt-5 ${ui.text.body} max-h-[720px]:mt-3`}>
                  {item.text}
                </p>

                <p className={`mt-5 ${ui.text.strong} max-h-[720px]:mt-3`}>
                  {item.bold}
                </p>
              </SoftCard>
            ))}
          </div>

          <div className={`${ui.highlight} mt-7 max-w-5xl max-h-[760px]:mt-5 max-h-[720px]:mt-4`}>
            <div className="flex items-center justify-center gap-4 text-center">
              <div className="hidden h-12 w-12 shrink-0 items-center justify-center rounded-full bg-white/65 text-2xl sm:flex max-h-[720px]:h-9 max-h-[720px]:w-9 max-h-[720px]:text-xl">
                🧩
              </div>

              <div className="text-[clamp(1.25rem,1.8vw,1.75rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-[1.1rem]">
                Det som mangler er{" "}
                <span className="text-violet-700">
                  strukturert sosial taletrening.
                </span>
              </div>
            </div>
          </div>
        </div>
      ),
      bgColor:
        "bg-[radial-gradient(circle_at_top_left,_#dbeafe,_transparent_35%),radial-gradient(circle_at_bottom_right,_#fce7f3,_transparent_35%),linear-gradient(135deg,#ffffff,#f8fafc)]",
    },

   {
  title: "",
  density: "medium",
  content: (
    <div className={ui.shell.standard}>
      <div className="mx-auto max-w-6xl text-center">
        <div className="mx-auto max-w-2xl">
          <div className="text-[clamp(1rem,1.15vw,1.22rem)] font-semibold italic leading-tight text-gray-600 max-h-[720px]:text-[0.95rem]">
            “Et menneske trenger et annet menneske.”
          </div>

          <div className="mt-2 text-[10px] font-black uppercase tracking-[0.28em] text-gray-400 max-h-[720px]:text-[8px]">
            Solaris · Tarkovskij
          </div>
        </div>

        <h3 className="mx-auto mt-6 max-w-4xl text-[clamp(1.45rem,2.05vw,2.15rem)] font-black leading-[1.16] tracking-tight text-gray-950 max-h-[760px]:mt-5 max-h-[760px]:text-[clamp(1.35rem,1.9vw,1.95rem)] max-h-[720px]:text-[1.5rem]">
          Kan nettbasert øving hente noe fra veiledet undervisning,
<br className="hidden sm:block" />
språkkaféens trygghet og individuelt tempo?
        </h3>

        <div className="mx-auto mt-6 flex max-w-4xl items-center justify-center gap-4 max-h-[720px]:mt-4">
          <div className="hidden h-px flex-1 bg-gradient-to-r from-transparent via-blue-300 to-purple-300 sm:block" />

          <div className="relative">
            <div className="absolute inset-0 rounded-full bg-gradient-to-r from-blue-400/20 via-purple-400/20 to-pink-400/20 blur-xl" />

            <div className="relative rounded-full border border-purple-200 bg-white/90 px-7 py-2.5 shadow-sm ring-1 ring-white/80 max-h-[720px]:px-5 max-h-[720px]:py-2">
              <div className="text-[11px] font-black uppercase tracking-[0.28em] text-purple-700 max-h-[720px]:text-[9px]">
                Vi introduserer
              </div>

              <div className="mt-0.5 text-[clamp(1.05rem,1.45vw,1.35rem)] font-black tracking-tight text-gray-950 max-h-[720px]:text-base">
                Catchphraser
              </div>
            </div>
          </div>

          <div className="hidden h-px flex-1 bg-gradient-to-l from-transparent via-pink-300 to-purple-300 sm:block" />
        </div>
      </div>

      <div className="mx-auto mt-7 grid w-full max-w-6xl items-stretch gap-5 lg:grid-cols-[1fr_auto_1fr_auto_1fr] max-h-[760px]:mt-5 max-h-[720px]:mt-4 max-h-[720px]:gap-3">
        <SoftCard className={`${ui.card.base} flex min-h-[220px] flex-col items-center justify-center px-7 py-7 text-center max-h-[720px]:min-h-[175px] max-h-[720px]:px-5 max-h-[720px]:py-5`}>
          <div className="mb-4 text-4xl max-h-[720px]:mb-3 max-h-[720px]:text-3xl">
            🎧
          </div>

          <div className={ui.title.card}>
            Autentiske
            <br />
            taleeksempler
          </div>

          <div className={`mx-auto mt-4 max-w-sm ${ui.text.body} max-h-[720px]:mt-3`}>
            Lyd lest inn av mennesker, dialoger og konkrete uttaleeksempler.
          </div>
        </SoftCard>

        <div className="hidden items-center justify-center lg:flex">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/85 text-2xl font-black text-purple-400 shadow-sm ring-1 ring-purple-100">
            +
          </div>
        </div>

        <SoftCard className={`${ui.card.base} relative flex min-h-[240px] flex-col items-center justify-center overflow-hidden rounded-[2.5rem] px-8 py-8 text-center shadow-md ring-purple-100 max-h-[720px]:min-h-[190px] max-h-[720px]:rounded-[2rem] max-h-[720px]:px-5 max-h-[720px]:py-5`}>
          <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500" />

          <div className="mb-4 flex justify-center gap-3 text-4xl max-h-[720px]:mb-3 max-h-[720px]:text-3xl">
            <span>📈</span>
            <span>🗣️</span>
          </div>

          <div className="text-[clamp(1.45rem,1.85vw,1.85rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-[1.3rem]">
            Lyder
            <br />
            <span className="text-purple-700">og flyt</span>
          </div>

          <div className={`mx-auto mt-4 max-w-md ${ui.text.body} max-h-[720px]:mt-3`}>
            Uttale, rytme, trykk, intonasjon, timing og talemelodi.
          </div>
        </SoftCard>

        <div className="hidden items-center justify-center lg:flex">
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-white/85 text-2xl font-black text-purple-400 shadow-sm ring-1 ring-purple-100">
            +
          </div>
        </div>

        <SoftCard className={`${ui.card.base} flex min-h-[220px] flex-col items-center justify-center px-7 py-7 text-center max-h-[720px]:min-h-[175px] max-h-[720px]:px-5 max-h-[720px]:py-5`}>
          <div className="mb-4 text-4xl max-h-[720px]:mb-3 max-h-[720px]:text-3xl">
            💬
          </div>

          <div className={ui.title.card}>
            Sosial
            <br />
            øving
          </div>

          <div className={`mx-auto mt-4 max-w-sm ${ui.text.body} max-h-[720px]:mt-3`}>
            Tilbakemeldinger, kommentarer, utfordringer og felles øving med andre.
          </div>
        </SoftCard>
      </div>

      <div className="mx-auto mt-8 max-w-5xl rounded-[2rem] bg-gradient-to-r from-blue-100 via-purple-100 to-pink-100 px-8 py-5 text-center shadow-sm ring-1 ring-white/80 max-h-[760px]:mt-6 max-h-[720px]:mt-4 max-h-[720px]:px-5 max-h-[720px]:py-3">
        <div className="text-[clamp(1.08rem,1.45vw,1.35rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-base">
          Uttaletrening blir forberedelse til samtaler med andre.
        </div>

        <div className="mt-2 text-[clamp(0.9rem,1.05vw,1rem)] font-semibold leading-relaxed text-gray-600 max-h-[720px]:mt-1 max-h-[720px]:text-sm">
          Forståelig og trygg tale som kan brukes med mennesker.
        </div>
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#dbeafe,_transparent_32%),radial-gradient(circle_at_bottom_right,_#f3e8ff,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
  },

  {
  title: "",
  density: "screenshot",
  content: (
    <div className="mx-auto flex min-h-[560px] max-w-7xl flex-col justify-center px-4 py-4 sm:px-6 max-h-[720px]:min-h-[500px] max-h-[720px]:py-3">
      <div className="mx-auto grid w-full max-w-6xl items-center gap-8 xl:grid-cols-[0.88fr_1.12fr] max-h-[720px]:gap-6">
        <div className="flex flex-col justify-center">
          <div className="max-w-xl text-left">
            <div className={ui.label.purple}>Spesialisert kurs i intonasjon</div>

            <h3 className="mt-3 text-[clamp(1.8rem,2.45vw,2.5rem)] font-black leading-[1.08] tracking-tight text-gray-950 max-h-[720px]:mt-2 max-h-[720px]:text-[1.7rem]">
              Flyt og rytme
            </h3>

            <p className="mt-4 max-w-lg text-[clamp(0.98rem,1.1vw,1.08rem)] font-semibold leading-relaxed text-gray-600 max-h-[720px]:mt-3 max-h-[720px]:text-sm">
              Vi bruker målrettede oppgaver for rytme og intonasjon som gjør talemønstre konkrete,
              gjentakbare og lettere å justere.
            </p>
          </div>

          <SoftCard className="mt-6 rounded-[2.2rem] bg-gradient-to-br from-purple-50 to-white px-7 py-7 text-left shadow-sm ring-1 ring-purple-100 max-h-[720px]:mt-4 max-h-[720px]:px-5 max-h-[720px]:py-5">
            <div className="flex items-center gap-5">
              <div className="h-24 w-24 overflow-hidden rounded-full border-4 border-white shadow-xl max-h-[720px]:h-20 max-h-[720px]:w-20">
                <img src={asset("oh.jpg")} alt="Olaf Husby" className="h-full w-full object-cover" />
              </div>

              <div>
                <div className="text-[10px] font-black uppercase tracking-[0.24em] text-purple-700">
                  Kursforfatter
                </div>

                <div className="mt-2 text-[clamp(1.2rem,1.45vw,1.45rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-lg">
                  Olaf Husby
                </div>

                <div className="mt-1 text-[10px] font-black uppercase tracking-[0.22em] text-purple-700">
                  uttalepedagogikk
                </div>
              </div>
            </div>

            <div className="mt-6 rounded-[1.5rem] bg-white/82 px-5 py-5 shadow-sm ring-1 ring-purple-100 max-h-[720px]:mt-4 max-h-[720px]:px-4 max-h-[720px]:py-4">
              <div className="text-[10px] font-black uppercase tracking-[0.2em] text-gray-400">
                Kurset trener på
              </div>

              <div className="mt-3 space-y-2.5 text-[clamp(0.88rem,0.98vw,0.95rem)] font-semibold leading-relaxed text-gray-700 max-h-[720px]:space-y-2 max-h-[720px]:text-xs">
                <div>• konkrete rytmemål</div>
                <div>• persepsjon og produksjon sammen</div>
                <div>• synliggjøring av rytme og trykk</div>
                <div>• forberedelse til samtaler med andre</div>
              </div>

              <a
                href="https://www.catchphraser.com/course/flyt-og-rytme"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-flex items-center rounded-full border border-purple-200 bg-white px-4 py-2 text-[10px] font-black uppercase tracking-[0.18em] text-purple-700 shadow-sm transition-all hover:-translate-y-0.5 hover:bg-purple-50 max-h-[720px]:px-3 max-h-[720px]:py-1.5"
              >
                Åpne kurset ↗
              </a>
            </div>
          </SoftCard>
        </div>

        <div className="flex justify-center xl:justify-end">
          <div className="relative w-full max-w-[400px] max-h-[720px]:max-w-[365px]">
            <div className="absolute inset-0 rounded-[3rem] bg-gradient-to-br from-purple-200/35 via-blue-100/20 to-pink-200/30 blur-2xl" />

            <div className="relative rounded-[3rem] border border-slate-200 bg-slate-950 p-3 shadow-[0_32px_90px_rgba(15,23,42,0.22)] ring-1 ring-black/5 max-h-[720px]:rounded-[2.5rem] max-h-[720px]:p-2.5">
              <div className="pointer-events-none absolute left-1/2 top-3 z-10 flex -translate-x-1/2 items-center gap-2 rounded-full bg-slate-800 px-4 py-1.5 max-h-[720px]:top-2.5 max-h-[720px]:px-3 max-h-[720px]:py-1">
                <div className="h-1.5 w-10 rounded-full bg-slate-600 max-h-[720px]:w-8" />
                <div className="h-2 w-2 rounded-full bg-slate-600 max-h-[720px]:h-1.5 max-h-[720px]:w-1.5" />
              </div>

              <div className="overflow-hidden rounded-[2.45rem] bg-white pt-7 max-h-[720px]:rounded-[2rem] max-h-[720px]:pt-6">
                <div className="border-b border-gray-100 px-4 py-3 max-h-[720px]:px-3 max-h-[720px]:py-2.5">
                  <div className="flex items-start justify-between gap-3">
                    <div>
                      <div className="text-[10px] font-semibold text-gray-400">
                        av Olaf Husby
                      </div>

                      <div className="text-[1rem] font-black leading-tight text-gray-950 max-h-[720px]:text-[0.9rem]">
                        Øvelse 1A — Hva skal du fokusere på?
                      </div>
                    </div>

                    <a
                      href="https://www.catchphraser.com/course/flyt-og-rytme"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="shrink-0 rounded-full border border-blue-200 bg-blue-50 px-3 py-1 text-[9px] font-black uppercase tracking-[0.14em] text-blue-700"
                    >
                      kurs ↗
                    </a>
                  </div>

                  <div className="mt-3 flex flex-wrap gap-2 text-[10px] font-semibold max-h-[720px]:mt-2">
                    {["Student", "Lærer", "Ordliste", "Om"].map((tab, index) => (
                      <div
                        key={tab}
                        className={`rounded-full px-2.5 py-1.5 ${
                          index === 0
                            ? "bg-gray-100 text-gray-900 ring-1 ring-gray-200"
                            : "text-gray-500"
                        }`}
                      >
                        {tab}
                      </div>
                    ))}
                  </div>
                </div>

                <div className="bg-[linear-gradient(90deg,#eff6ff,#faf5ff,#fff1f2)] px-4 py-2.5 max-h-[720px]:px-3 max-h-[720px]:py-2">
                  <div className="flex flex-wrap gap-2">
                    {["XxXx", "XX", "XxXx"].map((chip) => (
                      <div key={chip} className="rounded-full bg-white px-3 py-1.5 text-[10px] font-black text-gray-700 ring-1 ring-gray-200">
                        {chip}
                      </div>
                    ))}
                  </div>

                  <div className="mt-1.5 text-[10px] font-medium text-gray-500">
                    Klapp på X • hold x lett
                  </div>
                </div>

                <div className="space-y-2.5 bg-[#fbfbfc] px-4 py-3.5 max-h-[720px]:space-y-2 max-h-[720px]:px-3 max-h-[720px]:py-2.5">
                  <div className="rounded-[1.35rem] border border-gray-100 bg-white px-4 py-3.5 shadow-sm">
                    <div className="text-center">
                      <div className="text-[9px] font-black uppercase tracking-[0.18em] text-gray-400">
                        Utfordring
                      </div>

                      <div className="mt-1 text-[0.9rem] font-black text-gray-950">
                        Rytmeanker
                      </div>

                      <div className="mt-2.5 text-[1.45rem] font-black leading-tight text-gray-950 max-h-[720px]:text-[1.2rem]">
                        To slag, én kjede.
                      </div>

                      <div className="mt-1 text-xs font-medium text-gray-500 max-h-[720px]:text-[10px]">
                        Ikke start på nytt midt i.
                      </div>
                    </div>
                  </div>

                  <div className="rounded-[1.35rem] border border-gray-100 bg-white px-4 py-3.5 shadow-sm">
                    <div className="text-center text-[9px] font-black uppercase tracking-[0.18em] text-gray-400">
                      Mål
                    </div>

                    <div className="mt-1 text-center text-[0.92rem] font-black text-gray-950">
                      Kopier rytmeformen
                    </div>

                    <div className="mt-3 space-y-2 max-h-[720px]:mt-2 max-h-[720px]:space-y-1.5">
                      {["KARi_SNAkker", "JENta_SYNger", "TOR_REIser"].map((item) => (
                        <div
                          key={item}
                          className="rounded-2xl bg-gray-50 px-4 py-2.5 text-center text-[0.9rem] font-medium tracking-[0.08em] text-gray-800 ring-1 ring-gray-100 max-h-[720px]:py-2 max-h-[720px]:text-[0.8rem]"
                        >
                          {item}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="bg-white px-4 pb-3 pt-1 max-h-[720px]:pb-2">
                  <div className="mx-auto h-1.5 w-24 rounded-full bg-gray-200 max-h-[720px]:w-20" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#ede9fe,_transparent_30%),radial-gradient(circle_at_bottom_right,_#dbeafe,_transparent_32%),linear-gradient(135deg,#ffffff,#faf5ff)]",
},

   {
  title: "",
  density: "screenshot",
  content: (
    <div className="mx-auto flex min-h-[560px] max-w-7xl flex-col justify-center px-4 py-4 text-center sm:px-6 max-h-[720px]:min-h-[500px] max-h-[720px]:py-3">
      <div className="mx-auto max-w-5xl">
        <div className={ui.label.purple}>Visuelle prosodisignaler</div>

        <h3 className="mx-auto mt-3 max-w-5xl text-[clamp(1.55rem,2.25vw,2.25rem)] font-black leading-[1.08] tracking-tight text-gray-950 max-h-[720px]:mt-2 max-h-[720px]:text-[1.45rem]">
          Studentene kan se rytme,
          <br />
          trykk og intonasjonens bevegelse.
        </h3>
      </div>

      <div className="relative mx-auto mt-6 w-full max-w-[1120px] max-h-[720px]:mt-4">
        <div className="absolute inset-0 scale-[1.015] rounded-[2.8rem] bg-gradient-to-r from-blue-200/30 via-purple-200/25 to-pink-200/30 blur-3xl" />

        <ZoomableImage
          src={asset("flyt-og-rytme-interface-enhanced.png")}
          alt="Visualisering av tonehøyde, rytme, trykk og intonasjon"
          caption="Visualisering av tonehøyde"
          className="relative block"
        >
          <div className="relative overflow-hidden rounded-[2.7rem] border border-white/80 bg-white/94 p-3 shadow-[0_32px_100px_rgba(15,23,42,0.16)] ring-1 ring-gray-200/70 transition-all duration-300 group-hover:scale-[1.006] max-h-[720px]:rounded-[2.2rem] max-h-[720px]:p-2.5">
            <div className="rounded-[2rem] border border-gray-100 bg-white px-3 py-3 max-h-[720px]:rounded-[1.6rem] max-h-[720px]:px-2 max-h-[720px]:py-2">
              <img
                src={asset("flyt-og-rytme-interface-enhanced.png")}
                alt="Visualisering av tonehøyde, rytme, trykk og intonasjon"
                className="mx-auto max-h-[430px] w-full object-contain contrast-[1.06] brightness-[1.02] max-h-[760px]:max-h-[380px] max-h-[720px]:max-h-[330px]"
              />
            </div>
          </div>
        </ZoomableImage>
      </div>

      <div className="mx-auto mt-5 grid w-full max-w-5xl gap-3 md:grid-cols-4 max-h-[720px]:mt-4 max-h-[720px]:gap-2">
        {[
          "fall / stigning",
          "intonasjonsgrupper",
          "bevegelse inne i ord",
          "klikkbare ord",
        ].map((title, index) => (
          <SoftCard
            key={index}
            className="rounded-[1.35rem] border border-gray-200/80 bg-white/88 px-4 py-4 text-center shadow-sm ring-1 ring-white/80 max-h-[720px]:px-3 max-h-[720px]:py-3"
          >
            <div className="flex min-h-[34px] items-center justify-center text-[clamp(0.95rem,1.15vw,1.15rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-sm">
              {title}
            </div>
          </SoftCard>
        ))}
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#dbeafe,_transparent_32%),radial-gradient(circle_at_bottom_right,_#ede9fe,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
},

  {
  title: "",
  density: "screenshot",
  content: (
    <div className="mx-auto flex min-h-[560px] max-w-7xl flex-col justify-center px-4 py-4 text-center sm:px-6 max-h-[720px]:min-h-[500px] max-h-[720px]:py-3">
      <div className="mx-auto max-w-6xl">
        <div className={ui.label.green || "text-sm font-black uppercase tracking-[0.24em] text-emerald-700"}>
          Det første sosiale laget
        </div>

        <h3 className="mx-auto mt-3 max-w-5xl text-[clamp(2rem,3vw,3rem)] font-black leading-[1.04] tracking-tight text-gray-950 max-h-[760px]:text-[clamp(1.7rem,2.45vw,2.4rem)] max-h-[720px]:mt-2 max-h-[720px]:text-[1.8rem]">
          Mennesker vurderer mennesker.
        </h3>
      </div>

      <div className="relative mx-auto mt-8 w-full max-w-[1160px] max-h-[760px]:mt-6 max-h-[720px]:mt-5">
        <div className="absolute inset-0 scale-[1.012] rounded-[2.8rem] bg-gradient-to-r from-emerald-200/30 via-blue-200/20 to-purple-200/25 blur-3xl" />

        <ZoomableImage
          src={asset("rateme-enhanced.png")}
          alt="Grensesnitt for uttalevurdering"
          caption="Uttalevurdering"
          className="relative block"
        >
          <div className="relative overflow-hidden rounded-[2.7rem] border border-white/80 bg-white/94 p-3 shadow-[0_32px_100px_rgba(15,23,42,0.16)] ring-1 ring-gray-200/70 transition-all duration-300 group-hover:scale-[1.006] max-h-[720px]:rounded-[2.2rem] max-h-[720px]:p-2.5">
            <div className="rounded-[2rem] border border-gray-100 bg-white px-3 py-3 max-h-[720px]:rounded-[1.6rem] max-h-[720px]:px-2 max-h-[720px]:py-2">
              <img
                src={asset("rateme-enhanced.png")}
                alt="Grensesnitt for uttalevurdering"
                className="mx-auto max-h-[430px] w-full object-contain contrast-[1.04] brightness-[1.02] max-h-[760px]:max-h-[380px] max-h-[720px]:max-h-[335px]"
              />
            </div>
          </div>
        </ZoomableImage>
      </div>

      <div className="mx-auto mt-6 grid w-full max-w-5xl gap-3 md:grid-cols-3 max-h-[720px]:mt-4 max-h-[720px]:gap-2">
        {[
          ["Presis markering", "fonem • ord • setning"],
          ["Menneskelig vurdering", "medelever • lærere • morsmålsbrukere"],
          ["Gjenbrukbare notater", "kommentarer følger eksemplet"],
        ].map(([title, text]) => (
          <SoftCard
            key={title}
            className="rounded-[1.35rem] border border-gray-200/80 bg-white/88 px-4 py-3.5 text-center shadow-sm ring-1 ring-white/80 max-h-[720px]:px-3 max-h-[720px]:py-2.5"
          >
            <div className="text-[clamp(0.95rem,1.1vw,1.08rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-sm">
              {title}
            </div>

            <div className="mx-auto mt-1 max-w-xs text-[clamp(0.75rem,0.85vw,0.85rem)] font-semibold leading-relaxed text-gray-600 max-h-[720px]:text-xs">
              {text}
            </div>
          </SoftCard>
        ))}
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#dcfce7,_transparent_30%),radial-gradient(circle_at_bottom_right,_#dbeafe,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
},

    {
  title: "",
  density: "medium",
  content: (
    <div className={ui.shell.standard}>
      <div className={ui.label.green}>Medvurdering som læring</div>

      <h3 className={ui.title.main}>
        Studentene lærer gradvis
        <br />
        å høre og beskrive tale.
      </h3>

      <div className="mx-auto mt-5 max-w-4xl max-h-[720px]:mt-3">
        <div className="text-[clamp(0.95rem,1.2vw,1.1rem)] italic leading-relaxed text-gray-600 max-h-[720px]:text-sm">
          “Det barnet kan gjøre i samarbeid i dag, kan det gjøre alene i morgen.”
        </div>

        <div className={ui.label.gray}>Vygotskij</div>
      </div>

      <div className={`${ui.spacing.section} mx-auto w-full max-w-5xl`}>
        <div className="rounded-[2rem] border border-emerald-100 bg-white/82 px-6 py-7 shadow-sm ring-1 ring-emerald-100 max-h-[720px]:px-5 max-h-[720px]:py-5">
          <div className="grid items-center gap-7 md:grid-cols-3 max-h-[720px]:gap-4">
            {[
              ["🧑‍🦱", "Vurdere", "andre", "bg-blue-50", "ring-blue-100"],
              ["💬", "Felles", "begreper", "bg-emerald-50", "ring-emerald-100"],
              ["👩‍🦰", "Høre egne", "feil", "bg-purple-50", "ring-purple-100"],
            ].map(([emoji, a, b, bg, ring]) => (
              <div key={emoji} className="flex flex-col items-center">
                <div
                  className={`mb-5 flex h-20 w-20 items-center justify-center rounded-full ${bg} text-5xl shadow-sm ring-1 ${ring} max-h-[720px]:mb-3 max-h-[720px]:h-14 max-h-[720px]:w-14 max-h-[720px]:text-3xl`}
                >
                  {emoji}
                </div>

                <div className={ui.title.card}>
                  {a}
                  <br />
                  {b}
                </div>
              </div>
            ))}
          </div>

          <div className="mx-auto mt-8 max-w-3xl rounded-3xl bg-emerald-50/70 px-6 py-4 text-[clamp(0.9rem,1vw,1rem)] font-black leading-relaxed text-gray-950 max-h-[720px]:mt-5 max-h-[720px]:py-3 max-h-[720px]:text-sm">
            Studentene utvikler vurderingskompetanse sammen med praktiske uttalebegreper.
          </div>
        </div>
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#dcfce7,_transparent_32%),radial-gradient(circle_at_bottom_right,_#ede9fe,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
},

   {
  title: "",
  density: "screenshot",
  content: (
    <div className={ui.shell.screenshot}>
      <div className="mx-auto max-w-6xl">
        <div className={ui.label.green}>
          Hver tilbakemelding kan hjelpe neste student
        </div>

        <h3 className={ui.title.medium}>
          En nyttig kommentar blir
          <br />
          liggende ved eksemplet.
        </h3>
      </div>

      <div className="relative mx-auto mt-7 w-full max-w-6xl max-h-[760px]:mt-5 max-h-[720px]:mt-3">
        <div className="absolute inset-0 scale-[1.012] rounded-[2.6rem] bg-gradient-to-r from-emerald-200/30 via-blue-200/20 to-purple-200/25 blur-3xl" />

        <ZoomableImage
          src={asset("rated-enhanced.png")}
          alt="Uttalevurdering med kommentarer og markerte uttaleproblemer"
          caption="Felles uttalevurdering"
          className="relative block"
        >
          <div className={ui.screenshot.frame}>
            <div className={ui.screenshot.inner}>
              <img
                src={asset("rated-enhanced.png")}
                alt="Uttalevurdering med kommentarer og markerte uttaleproblemer"
                className={ui.screenshot.imgMedium}
              />
            </div>
          </div>
        </ZoomableImage>
      </div>

      <div className="mx-auto mt-6 grid w-full max-w-6xl gap-4 md:grid-cols-3 max-h-[760px]:mt-5 max-h-[720px]:mt-3 max-h-[720px]:gap-3">
        {["L1→L2-mønstre", "Gjenbrukbare kommentarer", "Bedre tilbakemeldinger"].map((label) => (
          <SoftCard
            key={label}
            className={`${ui.card.base} px-5 py-4 text-center max-h-[720px]:px-4 max-h-[720px]:py-3`}
          >
            <div className="flex min-h-[40px] items-center justify-center text-[clamp(1rem,1.25vw,1.25rem)] font-black leading-tight text-gray-950 max-h-[720px]:min-h-[30px] max-h-[720px]:text-sm">
              {label}
            </div>
          </SoftCard>
        ))}
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#dcfce7,_transparent_34%),radial-gradient(circle_at_bottom_right,_#dbeafe,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
},

{
  title: "",
  density: "dense",
  content: (
    <div className="mx-auto flex w-full max-w-7xl items-center justify-center px-2 py-2">
      <svg
        viewBox="0 0 1280 720"
        preserveAspectRatio="xMidYMid meet"
        className="block aspect-video w-full"
        role="img"
        aria-label="Differensiert øving i et læringsfellesskap"
      >
        <defs>
          <filter id="wheelShadowPremiumFinal4" x="-25%" y="-25%" width="150%" height="150%">
            <feDropShadow
              dx="0"
              dy="18"
              stdDeviation="22"
              floodColor="#0f172a"
              floodOpacity="0.105"
            />
          </filter>

          <filter id="softShadowPremiumFinal4" x="-25%" y="-25%" width="150%" height="150%">
            <feDropShadow
              dx="0"
              dy="8"
              stdDeviation="10"
              floodColor="#0f172a"
              floodOpacity="0.08"
            />
          </filter>

          <filter id="cardShadowPremiumFinal4" x="-10%" y="-10%" width="120%" height="120%">
            <feDropShadow
              dx="0"
              dy="18"
              stdDeviation="22"
              floodColor="#0f172a"
              floodOpacity="0.105"
            />
          </filter>

          <radialGradient id="wheelPlatePremiumFinal4" cx="50%" cy="50%" r="64%">
            <stop offset="0%" stopColor="#ffffff" stopOpacity="0.99" />
            <stop offset="58%" stopColor="#f8fafc" stopOpacity="0.95" />
            <stop offset="100%" stopColor="#eef2ff" stopOpacity="0.55" />
          </radialGradient>

          <linearGradient id="segBluePremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#dbeafe" />
            <stop offset="100%" stopColor="#bfd6fb" />
          </linearGradient>

          <linearGradient id="segVioletPremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#ede9fe" />
            <stop offset="100%" stopColor="#dad1fb" />
          </linearGradient>

          <linearGradient id="segPurplePremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#f3e8ff" />
            <stop offset="100%" stopColor="#e5d4fb" />
          </linearGradient>

          <linearGradient id="segCyanPremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#cffafe" />
            <stop offset="100%" stopColor="#a9edf7" />
          </linearGradient>

          <linearGradient id="segEmeraldPremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#d1fae5" />
            <stop offset="100%" stopColor="#b8eccf" />
          </linearGradient>

          <linearGradient id="segSkyPremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#e0f2fe" />
            <stop offset="100%" stopColor="#bfe3fa" />
          </linearGradient>

          <linearGradient id="hubGradPremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#ffffff" />
            <stop offset="100%" stopColor="#f8fafc" />
          </linearGradient>

          <linearGradient id="badgeBluePremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#93c5fd" />
            <stop offset="100%" stopColor="#2563eb" />
          </linearGradient>

          <linearGradient id="badgePurplePremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#c4b5fd" />
            <stop offset="100%" stopColor="#7c3aed" />
          </linearGradient>

          <linearGradient id="badgeTealPremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#67e8f9" />
            <stop offset="100%" stopColor="#0891b2" />
          </linearGradient>

          <linearGradient id="badgeGreenPremiumFinal4" x1="0" x2="1" y1="0" y2="1">
            <stop offset="0%" stopColor="#86efac" />
            <stop offset="100%" stopColor="#16a34a" />
          </linearGradient>

          {/* arrowheads */}
          <marker
            id="arrowBluePremiumFinal4"
            viewBox="0 0 10 10"
            refX="8.2"
            refY="5"
            markerWidth="4.4"
            markerHeight="4.4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" fill="#2563eb" />
          </marker>

          <marker
            id="arrowVioletPremiumFinal4"
            viewBox="0 0 10 10"
            refX="8.2"
            refY="5"
            markerWidth="4.4"
            markerHeight="4.4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" fill="#8b5cf6" />
          </marker>

          <marker
            id="arrowPurplePremiumFinal4"
            viewBox="0 0 10 10"
            refX="8.2"
            refY="5"
            markerWidth="4.4"
            markerHeight="4.4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" fill="#7c3aed" />
          </marker>

          <marker
            id="arrowTealPremiumFinal4"
            viewBox="0 0 10 10"
            refX="8.2"
            refY="5"
            markerWidth="4.4"
            markerHeight="4.4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" fill="#06b6d4" />
          </marker>

          <marker
            id="arrowGreenPremiumFinal4"
            viewBox="0 0 10 10"
            refX="8.2"
            refY="5"
            markerWidth="4.4"
            markerHeight="4.4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" fill="#22c55e" />
          </marker>

          <marker
            id="arrowSkyPremiumFinal4"
            viewBox="0 0 10 10"
            refX="8.2"
            refY="5"
            markerWidth="4.4"
            markerHeight="4.4"
            orient="auto"
            markerUnits="strokeWidth"
          >
            <path d="M 0 0 L 10 5 L 0 10 z" fill="#60a5fa" />
          </marker>
        </defs>

        {/* background */}
        <rect x="0" y="0" width="1280" height="720" fill="transparent" />
        <circle cx="128" cy="88" r="230" fill="#dbeafe" fillOpacity="0.13" />
        <circle cx="1124" cy="642" r="248" fill="#dcfce7" fillOpacity="0.155" />
        <circle cx="586" cy="360" r="392" fill="#f5f3ff" fillOpacity="0.18" />

        {/* WHEEL */}
        <g transform="translate(-22 4)">
          <circle
            cx="392"
            cy="360"
            r="312"
            fill="url(#wheelPlatePremiumFinal4)"
            stroke="#e5e7eb"
            strokeWidth="1.5"
            filter="url(#wheelShadowPremiumFinal4)"
          />

          <circle
            cx="392"
            cy="360"
            r="292"
            fill="none"
            stroke="#ffffff"
            strokeWidth="3"
            opacity="0.88"
          />

          {[
            {
              d: "M260.2 77.3 A312 312 0 0 1 523.8 77.3 L449.6 223.8 A144 144 0 0 0 334.4 223.8 Z",
              fill: "url(#segBluePremiumFinal4)",
            },
            {
              d: "M550.1 92.9 A312 312 0 0 1 692.4 338.5 L528.6 347.1 A144 144 0 0 0 467.2 239.4 Z",
              fill: "url(#segVioletPremiumFinal4)",
            },
            {
              d: "M692.4 381.5 A312 312 0 0 1 550.1 627.1 L467.2 480.6 A144 144 0 0 0 528.6 372.9 Z",
              fill: "url(#segPurplePremiumFinal4)",
            },
            {
              d: "M523.8 642.7 A312 312 0 0 1 260.2 642.7 L334.4 496.2 A144 144 0 0 0 449.6 496.2 Z",
              fill: "url(#segCyanPremiumFinal4)",
            },
            {
              d: "M233.9 627.1 A312 312 0 0 1 91.6 381.5 L255.4 372.9 A144 144 0 0 0 316.8 480.6 Z",
              fill: "url(#segEmeraldPremiumFinal4)",
            },
            {
              d: "M91.6 338.5 A312 312 0 0 1 233.9 92.9 L316.8 239.4 A144 144 0 0 0 255.4 347.1 Z",
              fill: "url(#segSkyPremiumFinal4)",
            },
          ].map((seg, index) => (
            <path
              key={index}
              d={seg.d}
              fill={seg.fill}
              stroke="#ffffff"
              strokeWidth="10"
              filter="url(#softShadowPremiumFinal4)"
            />
          ))}

          {/* OUTSIDE SEGMENTED FLOW ARROWS */}
          <g
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="5.8"
            opacity="0.92"
          >
            <path
              d="M 438 33 A 330 330 0 0 1 629 131"
              stroke="#2563eb"
              markerEnd="url(#arrowBluePremiumFinal4)"
            />
            <path
              d="M 698 236 A 330 330 0 0 1 698 484"
              stroke="#8b5cf6"
              markerEnd="url(#arrowVioletPremiumFinal4)"
            />
            <path
              d="M 652 563 A 330 330 0 0 1 438 687"
              stroke="#7c3aed"
              markerEnd="url(#arrowPurplePremiumFinal4)"
            />
            <path
              d="M 346 687 A 330 330 0 0 1 132 563"
              stroke="#06b6d4"
              markerEnd="url(#arrowTealPremiumFinal4)"
            />
            <path
              d="M 86 484 A 330 330 0 0 1 86 236"
              stroke="#22c55e"
              markerEnd="url(#arrowGreenPremiumFinal4)"
            />
            <path
              d="M 132 157 A 330 330 0 0 1 346 33"
              stroke="#60a5fa"
              markerEnd="url(#arrowSkyPremiumFinal4)"
            />
          </g>

          {/* hub */}
          <circle
            cx="392"
            cy="360"
            r="122"
            fill="url(#hubGradPremiumFinal4)"
            stroke="#e5e7eb"
            strokeWidth="1.6"
            filter="url(#wheelShadowPremiumFinal4)"
          />

          <text
            x="392"
            y="350"
            textAnchor="middle"
            fontSize="31"
            fontWeight="900"
            fill="#111827"
          >
            Felles
          </text>
          <text
            x="392"
            y="392"
            textAnchor="middle"
            fontSize="31"
            fontWeight="900"
            fill="#111827"
          >
            læringssløyfe
          </text>

          {/* stage badges */}
          {[
            { x: 392, y: 50, n: "I", fill: "url(#badgeBluePremiumFinal4)" },
            { x: 661, y: 204, n: "II", fill: "url(#badgePurplePremiumFinal4)" },
            { x: 661, y: 516, n: "III", fill: "url(#badgePurplePremiumFinal4)" },
            { x: 392, y: 672, n: "IV", fill: "url(#badgeTealPremiumFinal4)" },
            { x: 123, y: 516, n: "V", fill: "url(#badgeGreenPremiumFinal4)" },
            { x: 123, y: 204, n: "VI", fill: "url(#badgeBluePremiumFinal4)" },
          ].map((b) => (
            <g key={b.n}>
              <circle
                cx={b.x}
                cy={b.y}
                r="27"
                fill={b.fill}
                stroke="#ffffff"
                strokeWidth="5"
                filter="url(#softShadowPremiumFinal4)"
              />
              <text
                x={b.x}
                y={b.y + 9}
                textAnchor="middle"
                fontSize="27"
                fontWeight="900"
                fill="#ffffff"
              >
                {b.n}
              </text>
            </g>
          ))}

          {/* I Expectations */}
          <text
            x="392"
            y="136"
            textAnchor="middle"
            fontSize="21.5"
            fontWeight="950"
            fill="#111827"
          >
            Forventninger
          </text>
          <text
            x="392"
            y="190"
            textAnchor="middle"
            fontSize="48"
            fontWeight="900"
            fill="#2563eb"
          >
            ↗
          </text>

          {/* II Tools */}
          <g>
            <path
              d="M522 264 C536 236, 556 236, 570 259 C581 278, 593 279, 606 252"
              fill="none"
              stroke="#5b21b6"
              strokeWidth="7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M544 283 C551 289, 560 290, 568 283"
              fill="none"
              stroke="#5b21b6"
              strokeWidth="5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <circle cx="557" cy="274" r="5" fill="#5b21b6" />
            <text
              x="562"
              y="330"
              textAnchor="middle"
              fontSize="21.5"
              fontWeight="950"
              fill="#111827"
            >
              Verktøy
            </text>
          </g>

          {/* III Challenges */}
          <g>
            <path
              d="M520 465 H542 V444 H564 V423 H588"
              fill="none"
              stroke="#7c3aed"
              strokeWidth="8"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M576 412 L590 423 L576 435"
              fill="none"
              stroke="#7c3aed"
              strokeWidth="7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <text
              x="548"
              y="518"
              textAnchor="middle"
              fontSize="21.5"
              fontWeight="950"
              fill="#111827"
            >
              Utfordringer
            </text>
          </g>

          {/* IV Feedback */}
          <text
            x="392"
            y="548"
            textAnchor="middle"
            fontSize="47"
            fill="#0891b2"
          >
            💬
          </text>
          <text
            x="392"
            y="604"
            textAnchor="middle"
            fontSize="21.5"
            fontWeight="950"
            fill="#111827"
          >
            Respons
          </text>

          {/* V Growth */}
          <text
            x="240"
            y="454"
            textAnchor="middle"
            fontSize="47"
            fill="#16a34a"
          >
            🌱
          </text>
          <text
            x="240"
            y="518"
            textAnchor="middle"
            fontSize="21.5"
            fontWeight="950"
            fill="#111827"
          >
            Utvikling
          </text>

          {/* VI Baseline */}
          <text
            x="218"
            y="250"
            textAnchor="middle"
            fontSize="42"
            fill="#f4b400"
          >
            ✨
          </text>
          <text
            x="206"
            y="323"
            textAnchor="middle"
            fontSize="21.5"
            fontWeight="950"
            fill="#111827"
          >
            Grunnnivå
          </text>
        </g>

        {/* RIGHT CARD */}
        <g>
          <rect
            x="746"
            y="76"
            width="488"
            height="618"
            rx="34"
            fill="#ffffff"
            fillOpacity="0.94"
            stroke="#e5e7eb"
            strokeWidth="1.3"
            filter="url(#cardShadowPremiumFinal4)"
          />

          <text
            x="990"
            y="128"
            textAnchor="middle"
            fontSize="34"
            fontWeight="900"
            fill="#111827"
          >
            Differensiert øving
          </text>

          <text
            x="990"
            y="164"
            textAnchor="middle"
            fontSize="34"
            fontWeight="900"
            fill="#111827"
          >
            i et læringsfellesskap
          </text>

          <line
            x1="786"
            y1="192"
            x2="1194"
            y2="192"
            stroke="#e5e7eb"
            strokeWidth="1.32"
          />
          <circle cx="990" cy="192" r="5" fill="#c7d2fe" />

          {/* vertical connector arrows */}
          <g fill="none" strokeLinecap="round" strokeWidth="4.5" opacity="0.95">
            <path
              d="M830 268 L830 296"
              stroke="#3b82f6"
              markerEnd="url(#arrowBluePremiumFinal4)"
            />
            <path
              d="M830 352 L830 384"
              stroke="#8b5cf6"
              markerEnd="url(#arrowVioletPremiumFinal4)"
            />
            <path
              d="M830 440 L830 472"
              stroke="#7c3aed"
              markerEnd="url(#arrowPurplePremiumFinal4)"
            />
            <path
              d="M830 528 L830 560"
              stroke="#06b6d4"
              markerEnd="url(#arrowTealPremiumFinal4)"
            />
            <path
              d="M830 616 L830 636"
              stroke="#22c55e"
              markerEnd="url(#arrowGreenPremiumFinal4)"
            />
          </g>

          {[
            {
              y: 240,
              n: "I",
              fill: "url(#badgeBluePremiumFinal4)",
              lines: ["Hev felles forventninger"],
            },
            {
              y: 324,
              n: "II",
              fill: "url(#badgePurplePremiumFinal4)",
              lines: ["Tilby avanserte verktøy", "(tonekurver og artikulasjon)"],
            },
            {
              y: 412,
              n: "III",
              fill: "url(#badgePurplePremiumFinal4)",
              lines: ["La deltakerne ta", "passende utfordringer"],
            },
            {
              y: 500,
              n: "IV",
              fill: "url(#badgeTealPremiumFinal4)",
              lines: ["Respons fra medlærende", "blir mer presis"],
            },
            {
              y: 588,
              n: "V",
              fill: "url(#badgeGreenPremiumFinal4)",
              lines: ["Synlige eksempler", "hjelper andre videre"],
            },
            {
              y: 664,
              n: "VI",
              fill: "url(#badgeBluePremiumFinal4)",
              lines: ["Gruppens grunnnivå løftes"],
            },
          ].map((row, index) => (
            <g key={row.n}>
              {index > 0 && (
                <line
                  x1="786"
                  y1={row.y - 41}
                  x2="1194"
                  y2={row.y - 41}
                  stroke="#e5e7eb"
                  strokeWidth="1.05"
                />
              )}

              <circle
                cx="830"
                cy={row.y}
                r="23.5"
                fill={row.fill}
                stroke="#ffffff"
                strokeWidth="4"
                filter="url(#softShadowPremiumFinal4)"
              />

              <text
                x="830"
                y={row.y + 8}
                textAnchor="middle"
                fontSize="21.5"
                fontWeight="900"
                fill="#ffffff"
              >
                {row.n}
              </text>

              <text
                x="880"
                y={row.lines.length === 1 ? row.y + 7 : row.y - 5}
                fontSize="18.2"
                fontWeight="850"
                fill="#111827"
              >
                {row.lines[0]}
              </text>

              {row.lines[1] && (
                <text
                  x="880"
                  y={row.y + 23}
                  fontSize="18.2"
                  fontWeight="850"
                  fill="#111827"
                >
                  {row.lines[1]}
                </text>
              )}
            </g>
          ))}
        </g>
      </svg>
    </div>
  ),
  bgColor: "bg-gradient-to-br from-white via-slate-50 to-blue-50",
},

{
  title: "",
  density: "medium",
  content: (
    <div className="mx-auto flex w-full max-w-7xl flex-col justify-center px-4 py-4 text-center sm:px-6">
      {/* CENTRAL QUOTE */}
      <div className="mx-auto max-w-5xl rounded-3xl border border-violet-100 bg-white/95 px-8 py-5 shadow-2xl ring-1 ring-white">
        <div className="mx-auto flex h-10 w-10 items-center justify-center rounded-full bg-gradient-to-br from-violet-50 to-blue-50 text-4xl font-black leading-none text-violet-500 shadow-md ring-1 ring-violet-100">
          “
        </div>

        <div className="mx-auto mt-3 max-w-4xl text-lg font-semibold italic leading-relaxed text-slate-800 lg:text-xl">
          “Livet er i sitt vesen dialogisk. Å leve betyr å delta
          i dialog: å stille spørsmål, å lytte, å svare…”
        </div>

        <div className="mx-auto mt-4 h-1 w-24 rounded-full bg-gradient-to-r from-blue-500 via-violet-500 to-purple-600" />

        <div className="mt-3 text-xs font-black uppercase tracking-widest text-slate-400">
          Mikhail Bakhtin
        </div>
      </div>

      <div className="mx-auto mt-5 grid w-full max-w-6xl gap-6 lg:grid-cols-2">
        {/* LEFT: INDIVIDUAL APP PATH */}
        <div className="rounded-3xl border border-slate-200 bg-white/95 p-5 shadow-xl">
          <div className="flex items-center justify-between gap-3">
            <div className="text-left">
              <div className="text-xs font-black uppercase tracking-widest text-slate-700">
                Individuell øving
              </div>
              <div className="mt-1 text-sm font-black text-slate-500">
                Samme rekkefølge for alle
              </div>
            </div>

            <div className="rounded-full border border-slate-300 bg-white px-4 py-2 text-xs font-black uppercase tracking-wider text-slate-600 shadow-sm">
              fast rute
            </div>
          </div>

          <div className="relative mt-4 h-72 overflow-hidden rounded-3xl border border-slate-200 bg-gradient-to-br from-slate-50 via-white to-blue-50 shadow-inner">
            <svg
              className="absolute inset-0 h-full w-full"
              viewBox="0 0 620 280"
              preserveAspectRatio="none"
            >
              <rect
                x="40"
                y="24"
                width="540"
                height="232"
                rx="34"
                fill="rgb(248 250 252)"
                opacity="0.92"
              />

              {/* isolated parallel lanes */}
              {[62, 96, 130, 164, 198, 232].map((y) => (
                <g key={y}>
                  <path
                    d={`M92 ${y} L552 ${y}`}
                    fill="none"
                    stroke="rgb(226 232 240)"
                    strokeWidth="10"
                    strokeLinecap="round"
                  />
                  <path
                    d={`M92 ${y} L552 ${y}`}
                    fill="none"
                    stroke="rgb(100 116 139)"
                    strokeWidth="2.6"
                    strokeLinecap="round"
                    strokeDasharray="10 11"
                    opacity="0.78"
                  />
                  <path
                    d={`M538 ${y - 9} L554 ${y} L538 ${y + 9}`}
                    fill="none"
                    stroke="rgb(100 116 139)"
                    strokeWidth="3.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    opacity="0.9"
                  />
                </g>
              ))}

              <text
                x="310"
                y="266"
                textAnchor="middle"
                fill="rgb(71 85 105)"
                stroke="white"
                strokeWidth="6"
                paintOrder="stroke"
                dominantBaseline="middle"
                style={{
                  fontSize: 14,
                  fontWeight: 850,
                  letterSpacing: "0.08em",
                }}
              >
                isolert repetisjon
              </text>
            </svg>

            {/* identical isolated learners */}
            {[
              { left: "7%", top: "15%" },
              { left: "7%", top: "27%" },
              { left: "7%", top: "39%" },
              { left: "7%", top: "51%" },
              { left: "7%", top: "63%" },
              { left: "7%", top: "75%" },
            ].map((p, index) => (
              <div
                key={index}
                className="absolute"
                style={{ left: p.left, top: p.top }}
              >
                <div className="relative h-9 w-9">
                  <div className="absolute left-1/2 top-0 h-4 w-4 -translate-x-1/2 rounded-full bg-slate-500 shadow-md ring-4 ring-white" />
                  <div className="absolute bottom-0 left-1/2 h-5 w-7 -translate-x-1/2 rounded-t-2xl bg-slate-500 shadow-md ring-4 ring-white" />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* RIGHT: DIALOGIC PATH */}
        <div className="relative overflow-hidden rounded-3xl border border-violet-200 bg-gradient-to-br from-violet-50 via-white to-blue-50 p-5 shadow-2xl">
          <div className="absolute -right-16 -top-16 h-48 w-48 rounded-full bg-violet-200/40 blur-2xl" />
          <div className="absolute -bottom-16 -left-16 h-48 w-48 rounded-full bg-blue-200/40 blur-2xl" />

          <div className="relative flex items-center justify-between gap-3">
            <div className="text-left">
              <div className="text-xs font-black uppercase tracking-widest text-violet-800">
                Samhandling
              </div>
              <div className="mt-1 text-sm font-black text-violet-700">
                Veiene tilpasses gjennom samhandling
              </div>
            </div>

            <div className="rounded-full border border-violet-200 bg-white px-4 py-2 text-xs font-black uppercase tracking-wider text-violet-700 shadow-sm">
              ruten endres
            </div>
          </div>

          <div className="relative mt-4 h-72 overflow-hidden rounded-3xl border border-white bg-white/80 shadow-inner">
            <svg
              className="absolute inset-0 h-full w-full"
              viewBox="0 0 620 280"
              preserveAspectRatio="none"
            >
              {/* soft social fields */}
              <circle cx="165" cy="88" r="64" fill="rgb(196 181 253)" opacity="0.24" />
              <circle cx="305" cy="148" r="88" fill="rgb(147 197 253)" opacity="0.23" />
              <circle cx="442" cy="88" r="70" fill="rgb(110 231 183)" opacity="0.18" />
              <circle cx="455" cy="198" r="68" fill="rgb(244 114 182)" opacity="0.16" />

              {/* subtle interaction traces */}
              <path
                d="M110 188 C182 108, 252 100, 322 140 C390 178, 462 166, 528 104"
                fill="none"
                stroke="rgb(100 116 139)"
                strokeWidth="2.3"
                strokeLinecap="round"
                strokeDasharray="6 10"
                opacity="0.34"
              />
              <path
                d="M200 72 C272 36, 382 46, 434 110 C478 166, 455 220, 360 232"
                fill="none"
                stroke="rgb(168 85 247)"
                strokeWidth="2.3"
                strokeLinecap="round"
                strokeDasharray="5 9"
                opacity="0.3"
              />
              <path
                d="M145 132 C225 184, 305 182, 388 126 C438 92, 480 94, 528 122"
                fill="none"
                stroke="rgb(14 165 233)"
                strokeWidth="2.3"
                strokeLinecap="round"
                strokeDasharray="4 9"
                opacity="0.28"
              />

              {/* living paths */}
              <path
                d="M54 198 C130 78, 224 70, 306 130 C390 192, 464 166, 560 82"
                fill="none"
                stroke="rgb(124 58 237)"
                strokeWidth="6.5"
                strokeLinecap="round"
              />

              <path
                d="M58 86 C146 164, 246 190, 336 130 C422 76, 492 88, 560 142"
                fill="none"
                stroke="rgb(37 99 235)"
                strokeWidth="5.6"
                strokeLinecap="round"
                opacity="0.96"
              />

              <path
                d="M70 140 C156 94, 246 112, 318 164 C392 216, 462 204, 545 154"
                fill="none"
                stroke="rgb(20 184 166)"
                strokeWidth="5"
                strokeLinecap="round"
                opacity="0.86"
              />

              <path
                d="M66 228 C150 220, 205 176, 282 184 C356 194, 402 242, 560 216"
                fill="none"
                stroke="rgb(236 72 153)"
                strokeWidth="5"
                strokeLinecap="round"
                opacity="0.82"
              />

              <path
                d="M70 220 C154 218, 210 179, 306 164 C410 144, 456 132, 546 174"
                fill="none"
                stroke="rgb(249 115 22)"
                strokeWidth="4.5"
                strokeLinecap="round"
                opacity="0.72"
              />

              {/* arrowheads */}
              <path
                d="M546 87 L562 81 L554 99"
                fill="none"
                stroke="rgb(124 58 237)"
                strokeWidth="5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M548 135 L563 142 L548 153"
                fill="none"
                stroke="rgb(37 99 235)"
                strokeWidth="4.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M530 148 L547 154 L532 166"
                fill="none"
                stroke="rgb(20 184 166)"
                strokeWidth="4.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M545 208 L562 216 L546 228"
                fill="none"
                stroke="rgb(236 72 153)"
                strokeWidth="4.4"
                strokeLinecap="round"
                strokeLinejoin="round"
              />

              <text
                x="310"
                y="266"
                textAnchor="middle"
                fill="rgb(109 40 217)"
                stroke="white"
                strokeWidth="6"
                paintOrder="stroke"
                dominantBaseline="middle"
                style={{
                  fontSize: 14,
                  fontWeight: 850,
                  letterSpacing: "0.07em",
                }}
              >
                respons · justering · oppmerksomhetsskifte
              </text>
            </svg>

            {/* diverse learners */}
            {[
              {
                left: "7%",
                top: "52%",
                color: "bg-violet-500",
                size: "h-11 w-11",
                head: "h-5 w-5",
                body: "h-7 w-9",
              },
              {
                left: "18%",
                top: "72%",
                color: "bg-orange-400",
                size: "h-12 w-12",
                head: "h-5 w-5",
                body: "h-8 w-10",
              },
              {
                left: "30%",
                top: "16%",
                color: "bg-blue-500",
                size: "h-12 w-12",
                head: "h-5 w-5",
                body: "h-8 w-10",
              },
              {
                left: "40%",
                top: "44%",
                color: "bg-teal-600",
                size: "h-14 w-14",
                head: "h-6 w-6",
                body: "h-8 w-11",
              },
              {
                left: "55%",
                top: "76%",
                color: "bg-indigo-500",
                size: "h-10 w-10",
                head: "h-4 w-4",
                body: "h-6 w-8",
              },
              {
                left: "67%",
                top: "20%",
                color: "bg-violet-600",
                size: "h-12 w-12",
                head: "h-6 w-6",
                body: "h-8 w-10",
              },
              {
                left: "82%",
                top: "50%",
                color: "bg-amber-400",
                size: "h-11 w-11",
                head: "h-5 w-5",
                body: "h-7 w-9",
              },
            ].map((p, index) => (
              <div
                key={index}
                className="absolute"
                style={{ left: p.left, top: p.top }}
              >
                <div className={`relative ${p.size}`}>
                  <div
                    className={`absolute left-1/2 top-0 ${p.head} -translate-x-1/2 rounded-full ${p.color} shadow-lg ring-4 ring-white`}
                  />
                  <div
                    className={`absolute bottom-0 left-1/2 ${p.body} -translate-x-1/2 rounded-t-2xl ${p.color} shadow-lg ring-4 ring-white`}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="mx-auto mt-5 max-w-4xl text-lg font-bold leading-relaxed text-slate-700">
        I individuell øving er ruten vanligvis fast.
        <br className="hidden sm:block" />
        I samhandling kan neste steg endre seg.
      </div>
    </div>
  ),
  bgColor: "bg-gradient-to-br from-white via-slate-50 to-blue-50",
},

   {
  title: "",
  density: "medium",
  content: (
    <div className={ui.shell.standard}>
      <div className={ui.label.purple}>Modell under utvikling</div>

      <h3 className={ui.title.main}>
        Dialogøving som
        <br />
        rolleøving.
      </h3>

      <p className={ui.text.lead}>
        Studentene blir først kjent med hele dialogen, og øver deretter på én rolle med gradvis mindre støtte.
      </p>

      <div className={`${ui.spacing.section} mx-auto grid w-full max-w-6xl items-stretch gap-4 md:grid-cols-[1fr_38px_1fr_38px_1fr_38px_1fr] max-h-[720px]:gap-2`}>
        {[
          {
            label: "steg 1",
            titleA: "Gjenta",
            titleB: "alle linjer",
            body: ["lytt", "gjenta", "skygge"],
            border: "border-blue-100",
            text: "text-blue-700",
            bg: "bg-blue-50",
          },
          {
            label: "steg 2",
            titleA: "Velg",
            titleB: "en rolle",
            body: ["Person A", "Person B", "samme scene"],
            border: "border-purple-100",
            text: "text-purple-700",
            bg: "bg-purple-50",
          },
          {
            label: "steg 3",
            titleA: "Spill",
            titleB: "rollen",
            body: ["partnerens linje spilles", "du svarer", "støtte ved behov"],
            border: "border-pink-100",
            text: "text-pink-700",
            bg: "bg-pink-50",
          },
          {
            label: "steg 4",
            titleA: "Få",
            titleB: "score",
            body: ["uttale", "timing", "bruk av støtte"],
            border: "border-emerald-100",
            text: "text-emerald-700",
            bg: "bg-emerald-50",
          },
        ].map((step, index) => (
          <div key={step.label} className="contents">
            <SoftCard
              className={`${ui.card.base} ${step.border} px-5 py-5 text-center max-h-[720px]:px-3 max-h-[720px]:py-4`}
            >
              <div className={`text-[10px] font-black uppercase tracking-[0.2em] ${step.text}`}>
                {step.label}
              </div>

              <div className="mt-4 flex min-h-[70px] items-center justify-center text-[clamp(1.15rem,1.5vw,1.45rem)] font-black leading-tight text-gray-950 max-h-[720px]:mt-2 max-h-[720px]:min-h-[44px] max-h-[720px]:text-base">
                {step.titleA}
                <br />
                {step.titleB}
              </div>

              <div className={`mx-auto mt-5 rounded-2xl ${step.bg} px-4 py-4 text-[clamp(0.95rem,1.1vw,1.05rem)] font-black leading-relaxed text-gray-700 max-h-[720px]:mt-3 max-h-[720px]:px-3 max-h-[720px]:py-3 max-h-[720px]:text-sm`}>
                {step.body.map((line) => (
                  <div key={line}>{line}</div>
                ))}
              </div>
            </SoftCard>

            {index < 3 && (
              <div className="hidden items-center justify-center md:flex">
                <div className="text-3xl font-black text-purple-300 max-h-[720px]:text-2xl">
                  →
                </div>
              </div>
            )}
          </div>
        ))}
      </div>

      <div className="mx-auto mt-7 w-full max-w-5xl rounded-[2rem] border border-gray-200/80 bg-white/84 px-6 py-5 shadow-sm ring-1 ring-white/80 max-h-[720px]:mt-3 max-h-[720px]:px-4 max-h-[720px]:py-3">
        <div className="text-xs font-black uppercase tracking-[0.2em] text-gray-500 max-h-[720px]:text-[10px]">
          støttestige
        </div>

        <div className="mx-auto mt-4 grid gap-3 md:grid-cols-4 max-h-[720px]:mt-2 max-h-[720px]:gap-2">
          {["første ord", "omstokket setning", "opplest linje", "stemme + tekst"].map((cue) => (
            <div
              key={cue}
              className="rounded-2xl bg-gray-50 px-4 py-3 text-[clamp(0.95rem,1.1vw,1.05rem)] font-black text-gray-900 ring-1 ring-gray-100 max-h-[720px]:px-3 max-h-[720px]:py-2 max-h-[720px]:text-sm"
            >
              {cue}
            </div>
          ))}
        </div>

        <div className="mx-auto mt-4 max-w-4xl text-sm font-bold leading-relaxed text-gray-600 max-h-[720px]:mt-2">
          Studentene belønnes ikke bare for nøyaktighet, men også for å klare seg med mindre støtte.
        </div>
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#dbeafe,_transparent_32%),radial-gradient(circle_at_bottom_right,_#f3e8ff,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
},

   {
  title: "",
  density: "medium",
  content: (
    <div className="mx-auto flex min-h-[540px] max-w-7xl flex-col justify-center px-4 py-3 text-center sm:px-6 max-h-[720px]:min-h-[490px] max-h-[720px]:py-2">
      <div className="mx-auto max-w-5xl text-center">
        <div className={ui.label.green}>Sosial utfordring</div>

        <h3 className="mx-auto mt-3 max-w-4xl text-[clamp(1.75rem,2.45vw,2.45rem)] font-black leading-[1.07] tracking-tight text-gray-950 max-h-[760px]:text-[clamp(1.55rem,2.15vw,2.1rem)] max-h-[720px]:mt-2 max-h-[720px]:text-[1.6rem]">
          Én student utfordrer en annen.
        </h3>
      </div>

      <div className="mx-auto mt-7 w-full max-w-6xl max-h-[760px]:mt-6 max-h-[720px]:mt-4">
        <div className="grid items-center gap-5 lg:grid-cols-[1fr_118px_1fr] max-h-[720px]:gap-4">
          <div className="relative pt-6 max-h-[720px]:pt-5">
            <div className="absolute left-1/2 top-0 z-10 -translate-x-1/2">
              <div className="rounded-full border border-blue-200 bg-blue-50/95 px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.22em] text-blue-700 shadow-sm ring-1 ring-white/80 max-h-[720px]:px-3 max-h-[720px]:py-1 max-h-[720px]:text-[9px]">
                Student 1
              </div>
            </div>

            <SoftCard className="flex min-h-[210px] flex-col items-center justify-center rounded-[2.2rem] border border-blue-100 bg-white/92 px-6 py-6 text-center shadow-sm ring-1 ring-white/80 max-h-[720px]:min-h-[178px] max-h-[720px]:rounded-[1.9rem] max-h-[720px]:px-5 max-h-[720px]:py-4">
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-blue-50 text-4xl shadow-sm ring-1 ring-blue-100 max-h-[720px]:h-14 max-h-[720px]:w-14 max-h-[720px]:text-3xl">
                🧑‍🦱
              </div>

              <div className="mt-4 text-[clamp(1.35rem,1.75vw,1.72rem)] font-black leading-tight text-gray-950 max-h-[720px]:mt-3 max-h-[720px]:text-[1.18rem]">
                Spiller
                <br />
                rollen
              </div>

              <div className="mx-auto mt-4 w-full max-w-[220px] rounded-[1.35rem] bg-blue-50 px-5 py-3.5 text-[0.92rem] font-black leading-relaxed text-gray-700 ring-1 ring-blue-100/70 max-h-[720px]:mt-3 max-h-[720px]:px-4 max-h-[720px]:py-3 max-h-[720px]:text-xs">
                gjør oppgaven først
                <br />
                sender utfordring
              </div>
            </SoftCard>
          </div>

          <div className="hidden lg:flex lg:flex-col lg:items-center lg:justify-center lg:pt-6">
            <div className="rounded-full border border-purple-200 bg-white/88 px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.2em] text-purple-700 shadow-sm ring-1 ring-white/80">
              utfordring
            </div>

            <div className="mt-3 flex h-[3.25rem] w-24 items-center justify-center rounded-full bg-white/80 text-5xl font-black text-purple-400 shadow-sm ring-1 ring-purple-100 max-h-[720px]:h-11 max-h-[720px]:text-4xl">
              →
            </div>

            <div className="mt-3 text-[10px] font-black uppercase tracking-[0.18em] text-purple-400">
              samme oppgave
            </div>
          </div>

          <div className="relative pt-6 max-h-[720px]:pt-5">
            <div className="absolute left-1/2 top-0 z-10 -translate-x-1/2">
              <div className="rounded-full border border-emerald-200 bg-emerald-50/95 px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.22em] text-emerald-700 shadow-sm ring-1 ring-white/80 max-h-[720px]:px-3 max-h-[720px]:py-1 max-h-[720px]:text-[9px]">
                Student 2
              </div>
            </div>

            <SoftCard className="flex min-h-[210px] flex-col items-center justify-center rounded-[2.2rem] border border-emerald-100 bg-white/92 px-6 py-6 text-center shadow-sm ring-1 ring-white/80 max-h-[720px]:min-h-[178px] max-h-[720px]:rounded-[1.9rem] max-h-[720px]:px-5 max-h-[720px]:py-4">
              <div className="flex h-16 w-16 items-center justify-center rounded-full bg-emerald-50 text-4xl shadow-sm ring-1 ring-emerald-100 max-h-[720px]:h-14 max-h-[720px]:w-14 max-h-[720px]:text-3xl">
                👩‍🦰
              </div>

              <div className="mt-4 text-[clamp(1.35rem,1.75vw,1.72rem)] font-black leading-tight text-gray-950 max-h-[720px]:mt-3 max-h-[720px]:text-[1.18rem]">
                Tar
                <br />
                utfordringen
              </div>

              <div className="mx-auto mt-4 w-full max-w-[220px] rounded-[1.35rem] bg-emerald-50 px-5 py-3.5 text-[0.92rem] font-black leading-relaxed text-gray-700 ring-1 ring-emerald-100/70 max-h-[720px]:mt-3 max-h-[720px]:px-4 max-h-[720px]:py-3 max-h-[720px]:text-xs">
                samme scene
                <br />
                samme rolle
              </div>
            </SoftCard>
          </div>
        </div>

        <div className="mx-auto hidden max-w-4xl grid-cols-[1fr_1fr] gap-28 lg:grid">
          <div className="flex justify-end pr-10">
            <div className="h-8 w-28 border-b-2 border-r-2 border-purple-200/90 max-h-[720px]:h-6" />
          </div>

          <div className="flex justify-start pl-10">
            <div className="h-8 w-28 border-b-2 border-l-2 border-purple-200/90 max-h-[720px]:h-6" />
          </div>
        </div>

        <div className="mx-auto mt-2 max-w-4xl max-h-[720px]:mt-1">
          <SoftCard className="relative overflow-hidden rounded-[2.15rem] border border-purple-200 bg-white/96 px-7 py-5 text-center shadow-md ring-1 ring-purple-100 max-h-[720px]:rounded-[1.8rem] max-h-[720px]:px-5 max-h-[720px]:py-4">
            <div className="absolute inset-x-0 top-0 h-1.5 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500" />

            <div className="mx-auto inline-flex rounded-full border border-purple-200 bg-purple-50 px-4 py-1.5 text-[10px] font-black uppercase tracking-[0.22em] text-purple-700 shadow-sm max-h-[720px]:py-1 max-h-[720px]:text-[9px]">
              Felles sammenligning
            </div>

            <div className="mt-4 grid items-center gap-5 md:grid-cols-[0.9fr_1.2fr_0.9fr] max-h-[720px]:mt-3 max-h-[720px]:gap-3">
              <div className="flex flex-col items-center justify-center">
                <div className="flex h-[3.25rem] w-[3.25rem] items-center justify-center rounded-full bg-purple-50 text-3xl shadow-sm ring-1 ring-purple-100 max-h-[720px]:h-11 max-h-[720px]:w-11 max-h-[720px]:text-2xl">
                  🧑‍🦱
                </div>

                <div className="mt-2 text-[clamp(1rem,1.18vw,1.15rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-sm">
                  Student 1
                </div>
              </div>

              <div>
                <div className="text-[clamp(1.35rem,1.75vw,1.72rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-[1.18rem]">
                  Resultater kan
                  <br />
                  sammenlignes.
                </div>

                <div className="mx-auto mt-4 grid max-w-md gap-3 md:grid-cols-2 max-h-[720px]:mt-3 max-h-[720px]:gap-2">
                  {["score", "avspilling"].map((item) => (
                    <div
                      key={item}
                      className="rounded-2xl bg-purple-50 px-4 py-3 text-sm font-black text-gray-700 ring-1 ring-purple-100/70 max-h-[720px]:px-3 max-h-[720px]:py-2 max-h-[720px]:text-xs"
                    >
                      {item}
                    </div>
                  ))}
                </div>
              </div>

              <div className="flex flex-col items-center justify-center">
                <div className="flex h-[3.25rem] w-[3.25rem] items-center justify-center rounded-full bg-purple-50 text-3xl shadow-sm ring-1 ring-purple-100 max-h-[720px]:h-11 max-h-[720px]:w-11 max-h-[720px]:text-2xl">
                  👩‍🦰
                </div>

                <div className="mt-2 text-[clamp(1rem,1.18vw,1.15rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-sm">
                  Student 2
                </div>
              </div>
            </div>
          </SoftCard>
        </div>
      </div>

      <div className="mx-auto mt-5 max-w-5xl rounded-[2rem] bg-gradient-to-r from-emerald-100 via-blue-100 to-purple-100 px-8 py-4 text-center shadow-sm ring-1 ring-white/80 max-h-[760px]:mt-4 max-h-[720px]:mt-3 max-h-[720px]:px-5 max-h-[720px]:py-3">
        <div className="text-[clamp(1.02rem,1.32vw,1.25rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-sm">
          Øving blir noe studentene kan dele, sammenligne og forbedre.
        </div>
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#dcfce7,_transparent_32%),radial-gradient(circle_at_bottom_right,_#dbeafe,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
},

 {
  title: "",
  density: "medium",
  content: (
    <div className="mx-auto flex min-h-[560px] max-w-7xl flex-col justify-center px-4 py-4 text-center sm:px-6 max-h-[720px]:min-h-[500px] max-h-[720px]:py-3">
      <div className="mx-auto max-w-5xl">
        <div className="mx-auto inline-flex rounded-full border border-emerald-200 bg-emerald-50/90 px-5 py-1.5 text-[11px] font-black uppercase tracking-[0.26em] text-emerald-700 shadow-sm ring-1 ring-white/80 max-h-[720px]:px-4 max-h-[720px]:py-1 max-h-[720px]:text-[9px]">
          Mulig bruk i praksis ansikt til ansikt
        </div>

        <h3 className="mx-auto mt-4 max-w-5xl text-[clamp(1.75rem,2.55vw,2.65rem)] font-black leading-[1.07] tracking-tight text-gray-950 max-h-[760px]:text-[clamp(1.55rem,2.2vw,2.15rem)] max-h-[720px]:mt-3 max-h-[720px]:text-[1.65rem]">
          Nettbasert øving kan gjøre
          <br />
          samtalepraksis ansikt til ansikt mer målrettet.
        </h3>

        <p className="mx-auto mt-4 max-w-4xl text-[clamp(0.95rem,1.08vw,1.08rem)] font-semibold leading-relaxed text-gray-600 max-h-[720px]:mt-3 max-h-[720px]:text-sm">
          Studentene forbereder seg før språkkafeer, undervisning, samtalegrupper eller veiledede samlinger — slik at møtet kan handle mer om faktisk samhandling.
        </p>
      </div>

      <div className="mx-auto mt-9 grid w-full max-w-6xl items-stretch gap-5 md:grid-cols-[1fr_76px_1fr] max-h-[760px]:mt-7 max-h-[720px]:mt-5 max-h-[720px]:gap-4">
        <SoftCard className="relative overflow-hidden rounded-[2.35rem] border border-purple-100 bg-white/92 px-7 py-7 text-left shadow-sm ring-1 ring-purple-100/70 max-h-[720px]:rounded-[1.9rem] max-h-[720px]:px-5 max-h-[720px]:py-5">
          <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-purple-500 to-blue-500" />

          <div className="flex items-start gap-4">
            <div className="flex h-[3.25rem] w-[3.25rem] shrink-0 items-center justify-center rounded-2xl bg-purple-50 text-3xl shadow-sm ring-1 ring-purple-100 max-h-[720px]:h-11 max-h-[720px]:w-11 max-h-[720px]:text-2xl">
              📝
            </div>

            <div>
              <div className="text-[10px] font-black uppercase tracking-[0.24em] text-purple-700">
                før samlingen
              </div>

              <h4 className="mt-3 text-[clamp(1.32rem,1.75vw,1.8rem)] font-black leading-tight text-gray-950 max-h-[720px]:mt-2 max-h-[720px]:text-[1.22rem]">
                Målrettet
                <br />
                forberedelse
              </h4>
            </div>
          </div>

          <div className="mt-6 space-y-3 max-h-[720px]:mt-4 max-h-[720px]:space-y-2.5">
            {[
              "øve på dialogroller",
              "gjenta vanskelige linjer",
              "få tilbakemelding",
              "møte mer forberedt",
            ].map((item) => (
              <div
                key={item}
                className="rounded-2xl bg-purple-50/70 px-4 py-3 text-[clamp(0.92rem,1.03vw,1.02rem)] font-black leading-tight text-gray-800 ring-1 ring-purple-100/70 max-h-[720px]:px-3 max-h-[720px]:py-2 max-h-[720px]:text-sm"
              >
                {item}
              </div>
            ))}
          </div>
        </SoftCard>

        <div className="hidden flex-col items-center justify-center md:flex">
          <div className="flex h-16 w-16 items-center justify-center rounded-full bg-white/85 text-4xl font-black text-purple-400 shadow-sm ring-1 ring-purple-100 max-h-[720px]:h-[3.25rem] max-h-[720px]:w-[3.25rem] max-h-[720px]:text-3xl">
            →
          </div>

          <div className="mt-4 rounded-full border border-purple-100 bg-white/75 px-4 py-2 text-[9px] font-black uppercase leading-relaxed tracking-[0.22em] text-purple-500 shadow-sm max-h-[720px]:mt-3 max-h-[720px]:px-3 max-h-[720px]:py-1.5 max-h-[720px]:text-[8px]">
            forberedt
            <br />
            deltakelse
          </div>
        </div>

        <SoftCard className="relative overflow-hidden rounded-[2.35rem] border border-emerald-100 bg-white/92 px-7 py-7 text-left shadow-sm ring-1 ring-emerald-100/70 max-h-[720px]:rounded-[1.9rem] max-h-[720px]:px-5 max-h-[720px]:py-5">
          <div className="absolute inset-x-0 top-0 h-1 bg-gradient-to-r from-blue-500 to-emerald-500" />

          <div className="flex items-start gap-4">
            <div className="flex h-[3.25rem] w-[3.25rem] shrink-0 items-center justify-center rounded-2xl bg-emerald-50 text-3xl shadow-sm ring-1 ring-emerald-100 max-h-[720px]:h-11 max-h-[720px]:w-11 max-h-[720px]:text-2xl">
              ☕
            </div>

            <div>
              <div className="text-[10px] font-black uppercase tracking-[0.24em] text-emerald-700">
                under samlingen
              </div>

              <h4 className="mt-3 text-[clamp(1.32rem,1.75vw,1.8rem)] font-black leading-tight text-gray-950 max-h-[720px]:mt-2 max-h-[720px]:text-[1.22rem]">
                Mer nyttig
                <br />
                samhandling
              </h4>
            </div>
          </div>

          <div className="mt-6 space-y-3 max-h-[720px]:mt-4 max-h-[720px]:space-y-2.5">
            {[
              "mer tid til tale",
              "mindre tid på grunnleggende reparasjon",
              "mer kontekstuell tilbakemelding",
              "sterkere kontinuitet",
            ].map((item) => (
              <div
                key={item}
                className="rounded-2xl bg-emerald-50/70 px-4 py-3 text-[clamp(0.92rem,1.03vw,1.02rem)] font-black leading-tight text-gray-800 ring-1 ring-emerald-100/70 max-h-[720px]:px-3 max-h-[720px]:py-2 max-h-[720px]:text-sm"
              >
                {item}
              </div>
            ))}
          </div>
        </SoftCard>
      </div>

      <div className="mx-auto mt-8 max-w-5xl rounded-[2rem] bg-gradient-to-r from-emerald-100 via-blue-100 to-purple-100 px-8 py-5 text-center shadow-sm ring-1 ring-white/80 max-h-[760px]:mt-6 max-h-[720px]:mt-5 max-h-[720px]:px-5 max-h-[720px]:py-3">
        <div className="text-[clamp(1.08rem,1.42vw,1.38rem)] font-black leading-tight text-gray-950 max-h-[720px]:text-base">
          Plattformen erstatter ikke møter ansikt til ansikt.
          <br />
          Den hjelper studentene å møte forberedt og klare til å snakke.
        </div>
      </div>
    </div>
  ),
  bgColor:
    "bg-[radial-gradient(circle_at_top_left,_#dcfce7,_transparent_30%),radial-gradient(circle_at_bottom_right,_#f3e8ff,_transparent_32%),linear-gradient(135deg,#ffffff,#f8fafc)]",
}
  ],
},
 pedagogy: {
  label: "Pedagogy",
  description: "learning theory",
  slides: [
    {
      title: "More Than Immersion",
      density: "dense",
      content: (
        <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">
          <div className="mx-auto max-w-4xl rounded-3xl border border-blue-100 bg-white/85 px-5 py-4 shadow-sm">
            <div className="text-xs font-black uppercase tracking-[0.18em] text-blue-700">
              Second-language acquisition
            </div>

            <div className="mt-2 text-base italic leading-relaxed text-gray-700 sm:text-lg">
              Exposure is important, but progress often depends on interaction,
              feedback, and opportunities to modify one’s output.
            </div>
          </div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            Immersion alone is not always enough.
          </h3>

          <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
            Intermediate learners often know enough to communicate, but not
            enough to speak with confidence, nuance, rhythm, humour, or social
            precision. They need structured situations where speech can be tried,
            adjusted, repeated, and made meaningful.
          </p>

          <div className="grid gap-4 md:grid-cols-4 xl:gap-5">
            {[
              ["Input", "varied language exposure"],
              ["Interaction", "negotiation of meaning"],
                 ["Output", "attempts that can be modified"],
              ["Feedback", "noticing and repair"],
            ].map(([title, text]) => (
              <SoftCard
                key={title}
                className="bg-white/82 text-center shadow-sm ring-1 ring-blue-100"
              >
                <div className="text-lg font-black text-gray-950">
                  {title}
                </div>
                <div className="mt-3 text-sm font-semibold leading-relaxed text-gray-600">
                  {text}
                </div>
              </SoftCard>
            ))}
          </div>

          <BigStatement title="The goal is not exposure alone." compact>
            The goal is meaningful speech that can be attempted, noticed,
            repaired, and used again.
          </BigStatement>
        </div>
      ),
      bgColor: "bg-[linear-gradient(135deg,#ffffff,#eff6ff)]",
    },

    {
      title: "Intermediate Learners Need Expressive Range",
      density: "dense",
      content: (
        <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">
          <div className="mx-auto max-w-4xl rounded-3xl border border-purple-100 bg-white/85 px-5 py-4 shadow-sm">
            <div className="text-xs font-black uppercase tracking-[0.18em] text-purple-700">
              Communicative competence
            </div>

            <div className="mt-2 text-base italic leading-relaxed text-gray-700 sm:text-lg">
              Language mastery is not only grammatical or semantic. It is also
              social, pragmatic, prosodic, and affective.
            </div>
          </div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            After the course, learners need more than correctness.
          </h3>

          <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
            They need practice with tone, timing, emotional colour, register,
            irony, hesitation, turn-taking, and social response — the parts of
            speech that make communication feel human.
          </p>

          <div className="grid gap-4 md:grid-cols-3 xl:gap-5">
            {[
              ["Prosody", "stress, rhythm, intonation, timing"],
              ["Pragmatics", "register, politeness, turn-taking"],
              ["Affect", "emotion, humour, hesitation, stance"],
            ].map(([title, text]) => (
              <SoftCard
                key={title}
                className="bg-white/82 text-center shadow-sm ring-1 ring-purple-100"
              >
                <div className="text-xl font-black text-gray-950">
                  {title}
                </div>
                <div className="mt-3 text-sm font-semibold leading-relaxed text-gray-600">
                  {text}
                </div>
              </SoftCard>
            ))}
          </div>

          <BigStatement title="The plateau is not only linguistic." tone="purple" compact>
            It is also social, expressive, and performative.
          </BigStatement>
        </div>
      ),
      bgColor: "bg-[linear-gradient(135deg,#ffffff,#faf5ff)]",
    },

    {
      title: "Why Rehearsal Matters",
      density: "dense",
      content: (
        <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">
          <div className="mx-auto max-w-4xl rounded-3xl border border-amber-100 bg-white/85 px-5 py-4 shadow-sm">
            <div className="text-xs font-black uppercase tracking-[0.18em] text-amber-700">
              Drama-based language learning
            </div>

            <div className="mt-2 text-base italic leading-relaxed text-gray-700 sm:text-lg">
              Drama creates structured, repeatable, emotionally varied, socially
              meaningful speaking situations.
            </div>
          </div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            Theater is useful because it creates roles.
          </h3>

          <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
            A role gives the learner a reason to speak differently: with another
            intention, emotion, relation, rhythm, or level of formality. This
            helps learners move beyond their fixed personal routines.
          </p>

          <ComparisonTable
            leftTitle="Ordinary conversation"
            rightTitle="Rehearsed role"
            rows={[
              ["repeated personal topics", "varied communicative situations"],
              ["same speech habits", "new tone, rhythm, and register"],
              ["low preparation", "practice between meetings"],
              ["unclear progression", "shared goal and culmination"],
            ]}
          />

          <BigStatement title="Rehearsal makes repetition purposeful." tone="amber" compact>
            Learners are not just repeating; they are preparing for a shared
            communicative event.
          </BigStatement>
        </div>
      ),
      bgColor: "bg-[linear-gradient(135deg,#ffffff,#fffbeb)]",
    },

    {
      title: "Scripts Reduce Cognitive Load",
      density: "dense",
      content: (
        <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">
          <div className="mx-auto max-w-4xl rounded-3xl border border-purple-100 bg-white/85 px-5 py-4 shadow-sm">
            <div className="text-xs font-black uppercase tracking-[0.18em] text-purple-700">
              Scaffolding
            </div>

            <div className="mt-2 text-base italic leading-relaxed text-gray-700 sm:text-lg">
              When the language material is structured, learners can focus more
              deeply on delivery, timing, pronunciation, and response.
            </div>
          </div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            Given words create space for better speech.
          </h3>

          <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
            Scripts reduce the pressure to invent content. This allows learners
            to concentrate on how the utterance is delivered: rhythm, stress,
            intonation, emotional force, and interactional timing.
          </p>

          <ComparisonTable
            leftTitle="Free conversation"
            rightTitle="Script-based dialogue"
            rows={[
              ["what should I say?", "how should I say it?"],
              ["topic search", "delivery focus"],
              ["grammar pressure", "voice and timing"],
              ["conversation anxiety", "prepared interaction"],
            ]}
          />

          <BigStatement title="The script is not the goal." tone="purple" compact>
            It is a scaffold for socially usable speech.
          </BigStatement>
        </div>
      ),
      bgColor: "bg-[linear-gradient(135deg,#ffffff,#faf5ff)]",
    },

    {
      title: "Why Group Practice Matters",
      density: "dense",
      content: (
        <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">
          <div className="mx-auto max-w-4xl rounded-3xl border border-emerald-100 bg-white/85 px-5 py-4 shadow-sm">
            <div className="text-xs font-black uppercase tracking-[0.18em] text-emerald-700">
              Peer interaction
            </div>

            <div className="mt-2 text-base italic leading-relaxed text-gray-700 sm:text-lg">
              Learning can happen not only through teacher correction, but also
              through participation, comparison, imitation, and peer feedback.
            </div>
          </div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            A group changes the social dynamics of correction.
          </h3>

          <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
            One-to-one tutoring is valuable, but it can become asymmetrical:
            one person evaluates, the other is evaluated. In a group, learners
            see that others struggle too, notice similar mistakes, and learn by
            observing repair in others before recognizing it in themselves.
          </p>

          <div className="grid gap-4 md:grid-cols-3 xl:gap-5">
            {[
              ["Shared difficulty", "learners see that struggle is normal"],
              ["Peer noticing", "mistakes in others become easier to identify"],
              ["Collective repair", "feedback becomes part of group practice"],
            ].map(([title, text]) => (
              <SoftCard
                key={title}
                className="bg-white/82 text-center shadow-sm ring-1 ring-emerald-100"
              >
                <div className="text-xl font-black text-gray-950">
                  {title}
                </div>
                <div className="mt-3 text-sm font-semibold leading-relaxed text-gray-600">
                  {text}
                </div>
              </SoftCard>
            ))}
          </div>

          <BigStatement title="Correction becomes less confrontational." tone="green" compact>
            Learners are not only corrected by an authority; they move through
            the same process together.
          </BigStatement>
        </div>
      ),
      bgColor: "bg-[linear-gradient(135deg,#ffffff,#ecfdf5)]",
    },

    {
      title: "From Language Café To Rehearsal Community",
      density: "dense",
      content: (
        <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">
          <div className="mx-auto max-w-4xl rounded-3xl border border-blue-100 bg-white/85 px-5 py-4 shadow-sm">
            <div className="text-xs font-black uppercase tracking-[0.18em] text-blue-700">
              Social learning design
            </div>

            <div className="mt-2 text-base italic leading-relaxed text-gray-700 sm:text-lg">
              Language cafés provide access and community. Rehearsal adds
              preparation, continuity, progression, and shared purpose.
            </div>
          </div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            The missing ingredient is continuity.
          </h3>

          <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
            Drop-in conversation is valuable, but learners may return to the
            same topics and habits. Rehearsal creates commitment: participants
            prepare between meetings and move toward something shared.
          </p>

          <ComparisonTable
            leftTitle="Language café"
            rightTitle="Rehearsal community"
            rows={[
              ["low-pressure access", "structured preparation"],
              ["open conversation", "roles and tasks"],
              ["limited continuity", "progress across sessions"],
              ["community contact", "shared communicative goal"],
            ]}
          />

          <BigStatement title="Community becomes more powerful with structure." compact>
            The platform can support the work before, during, and after social
            practice.
          </BigStatement>
        </div>
      ),
      bgColor: "bg-[linear-gradient(135deg,#ffffff,#eff6ff)]",
    },

    {
      title: "The Platform Hypothesis",
      density: "dense",
      content: (
        <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">
          <div className="mx-auto max-w-4xl rounded-3xl border border-gray-200 bg-white/85 px-5 py-4 shadow-sm">
            <div className="text-xs font-black uppercase tracking-[0.18em] text-gray-600">
              Research-informed, not yet product-proven
            </div>

            <div className="mt-2 text-base italic leading-relaxed text-gray-700 sm:text-lg">
              The exact platform still needs validation, but its components come
              from well-established traditions in second-language learning.
            </div>
          </div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            Catchphraser combines several supported mechanisms.
          </h3>

          <div className="mx-auto grid max-w-6xl gap-4 text-left md:grid-cols-2 xl:gap-5">
            {[
              ["Interaction", "language is negotiated and modified"],
              ["Feedback", "learners notice and repair problems"],
              ["Task repetition", "practice becomes more fluent over time"],
              ["Role-play", "speech gains emotional and social variation"],
              ["Peer learning", "learners improve by reviewing others"],
              ["Shared goals", "motivation comes from participation, not only streaks"],
            ].map(([title, text]) => (
              <SoftCard
                key={title}
                className="bg-white/82 shadow-sm ring-1 ring-gray-100"
              >
                <div className="text-lg font-black text-gray-950">
                  {title}
                </div>
                <div className="mt-2 text-sm font-semibold leading-relaxed text-gray-600">
                  {text}
                </div>
              </SoftCard>
            ))}
          </div>

          <BigStatement title="The claim is modest but strong." tone="gray" compact>
            Not that the whole platform is already proven — but that it combines
            pedagogically meaningful mechanisms in one social practice system.
          </BigStatement>
        </div>
      ),
      bgColor: "bg-[linear-gradient(135deg,#ffffff,#f8fafc)]",
    },
  ],
},

    technology: {
      label: "Technology",
      description: "product workflows",
      slides: [
        {
          title: "AI-Supported Pronunciation Training",
          density: "screenshot",
          content: (
            <div className="mx-auto max-w-7xl px-3 py-0 sm:px-4">
              <div className="grid items-center gap-5 xl:grid-cols-[1.42fr_0.58fr] xl:gap-7">
                <div className="space-y-4 text-center xl:space-y-5">
                  <h3 className="mx-auto max-w-4xl text-3xl font-black leading-tight text-gray-950 xl:text-4xl">
                    AI feedback gives learners a private preparation loop.
                  </h3>

                  <div className="mx-auto max-w-4xl rounded-[1.75rem] border border-gray-200/80 bg-white p-3 shadow-[0_22px_70px_rgba(15,23,42,0.11)]">
                    <img
                      src={asset("kattenspiserikkefisk.png")}
                      alt="AI pronunciation feedback interface"
                      className="w-full rounded-[1.2rem] border border-gray-100 object-contain"
                    />

                    <div className="px-2 pt-2 text-center text-xs font-medium text-gray-500">
                      AI-supported pronunciation practice with phonetic feedback
                    </div>
                  </div>
                </div>

                <div className="grid gap-4 md:grid-cols-2 xl:grid-cols-1">
                  <SoftCard className="bg-gradient-to-br from-blue-50 to-white text-left shadow-none ring-1 ring-blue-100">
                    <h4 className="mb-3 text-xl font-black text-gray-950">
                      Private preparation
                    </h4>

                    <CleanList
                      accent="blue"
                      items={[
                        "safe repetition",
                        "immediate feedback",
                        "pronunciation correction",
                        "unlimited attempts",
                      ]}
                    />
                  </SoftCard>

                  <SoftCard className="bg-gradient-to-br from-purple-50 to-white text-left shadow-none ring-1 ring-purple-100">
                    <h4 className="mb-3 text-xl font-black text-gray-950">
                      Human activation
                    </h4>

                    <CleanList
                      accent="purple"
                      items={[
                        "real listener response",
                        "meaningful explanation",
                        "social interpretation",
                        "collaborative attention",
                      ]}
                    />
                  </SoftCard>
                </div>
              </div>
            </div>
          ),
          bgColor: "bg-[linear-gradient(135deg,#ffffff,#eff6ff)]",
        },

        {
          title: "Community Pronunciation Review",
          density: "screenshot",
          content: (
            <div className="mx-auto max-w-7xl space-y-4 px-3 py-0 sm:px-4 xl:space-y-5">
              <div className="text-center">
                <SectionLabel>Product Workflow</SectionLabel>
                <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
                  Learners can ask the community to review pronunciation.
                </h3>
              </div>

              <div className="grid items-center gap-5 lg:grid-cols-[1.35fr_0.65fr] xl:gap-7">
                <ScreenshotFrame
                  src={asset("rateme-enhanced.png")}
                  alt="Rate Me pronunciation review interface"
                  caption="Learner request for structured pronunciation feedback"
                  imgClassName="max-h-[430px] object-contain bg-gray-50 xl:max-h-[500px]"
                />

                <SoftCard className="bg-blue-50/70 ring-1 ring-blue-100">
                  <h4 className="mb-4 text-xl font-black text-gray-950 xl:text-2xl">
                    Reviewers can
                  </h4>
                  <CleanList
                    accent="blue"
                    items={[
                      "replay the learner attempt",
                      "compare it with narrator audio",
                      "inspect rhythm and melody",
                      "mark unclear words or sounds",
                      "leave concrete suggestions",
                    ]}
                  />
                </SoftCard>
              </div>
            </div>
          ),
          bgColor:
            "bg-[radial-gradient(circle_at_top_left,_#dbeafe,_transparent_35%),linear-gradient(135deg,#ffffff,#f8fafc)]",
        },

        {
          title: "Collaborative Repair",
          density: "screenshot",
          content: (
            <div className="mx-auto max-w-6xl space-y-4 px-3 py-0 text-center sm:px-4">
              <div className="mx-auto max-w-4xl rounded-[1.75rem] border border-gray-200/80 bg-white p-3 shadow-[0_22px_70px_rgba(15,23,42,0.10)]">
                <img
                  src={asset("rated-enhanced.png")}
                  alt="Collaborative pronunciation review"
                  className="max-h-[300px] w-full rounded-[1.2rem] border border-gray-100 object-contain sm:max-h-[340px] xl:max-h-[365px]"
                />

                <div className="px-2 pt-2 text-center text-xs font-medium text-gray-500">
                  Pronunciation requests with ratings, marked segments, and discussion
                </div>
              </div>

              <div className="mx-auto max-w-4xl rounded-3xl border border-white/70 bg-gradient-to-r from-blue-50 via-white to-purple-50 px-5 py-4 shadow-[0_18px_50px_rgba(15,23,42,0.08)] sm:px-6">
                <p className="text-base font-semibold leading-relaxed text-gray-700 sm:text-lg">
                  Learners improve not only by speaking, but by listening,
                  evaluating, explaining, and repairing together.
                </p>
              </div>
            </div>
          ),
          bgColor: "bg-[linear-gradient(135deg,#f0fdf4,#faf5ff)]",
        },

        {
          title: "L1-Sensitive Feedback",
          density: "medium",
          content: (
            <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">
              <h3 className="mx-auto max-w-5xl text-3xl font-black leading-tight text-gray-950 md:text-5xl">
                The same mistake often has different causes.
              </h3>

              <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
                Feedback becomes more useful when it knows what language background
                the learner is coming from.
              </p>

              <ComparisonTable
                leftTitle="Observed patterns"
                rightTitle="Adaptive guidance"
                leftColor="green"
                rows={[
                  ["learners mark difficult words", "explanations fit the learner’s L1"],
                  ["reviewers notice recurring errors", "practice targets the likely cause"],
                  ["similar learners struggle in similar places", "examples become more precise"],
                  ["corrections accumulate over time", "feedback becomes reusable"],
                ]}
              />

              <BigStatement
                title="This creates accumulated pronunciation knowledge."
                tone="green"
                compact
              >
                A Russian speaker and a French speaker learning Norwegian may need
                different explanations, examples, and repair paths.
              </BigStatement>
            </div>
          ),
          bgColor: "bg-[linear-gradient(135deg,#ffffff,#ecfdf5)]",
        },

        {
          title: "Prosody Visualization",
          density: "screenshot",
          content: (
            <div className="mx-auto max-w-7xl space-y-4 px-3 py-0 text-center sm:px-4">
              <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
                Seeing rhythm, stress, and intonation.
              </h3>

              <ScreenshotFrame
                src={asset("muchwarmerthere.png")}
                alt="Pitch contour visualization showing intonation groups and pitch variation across phrase boundaries"
                className="mx-auto max-w-6xl"
                imgClassName="max-h-[270px] w-full object-contain bg-gray-50 sm:max-h-[310px] xl:max-h-[335px]"
              />

              <div className="grid gap-4 md:grid-cols-3">
                <SoftCard className="bg-white/80 text-left shadow-none ring-1 ring-blue-100">
                  <div className="mb-2 text-xs font-black uppercase tracking-[0.18em] text-blue-600">
                    Intonation groups
                  </div>

                  <p className="text-sm leading-relaxed text-gray-700">
                    Pitch develops across whole phrases, not only isolated words.
                  </p>
                </SoftCard>

                <SoftCard className="bg-white/80 text-left shadow-none ring-1 ring-purple-100">
                  <div className="mb-2 text-xs font-black uppercase tracking-[0.18em] text-purple-600">
                    Word boundaries
                  </div>

                  <p className="text-sm leading-relaxed text-gray-700">
                    The contour travels through connected speech and reveals phrasing.
                  </p>
                </SoftCard>

                <SoftCard className="bg-white/80 text-left shadow-none ring-1 ring-pink-100">
                  <div className="mb-2 text-xs font-black uppercase tracking-[0.18em] text-pink-600">
                    Stress perception
                  </div>

                  <p className="text-sm leading-relaxed text-gray-700">
                    Timing, prominence, and emphasis become easier to notice.
                  </p>
                </SoftCard>
              </div>
            </div>
          ),
          bgColor: "bg-[linear-gradient(135deg,#ffffff,#faf5ff)]",
        },
      ],
    },

 community: {
  label: "Community",
  description: "social speech practice",
  slides: [
    {
      title: "Speaking Develops Socially",
      density: "dense",
      content: (
        <div className="mx-auto max-w-6xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">

          <div className="mx-auto max-w-4xl rounded-3xl border border-purple-200 bg-gradient-to-r from-purple-100 via-white to-pink-100 px-5 py-4 shadow-[0_18px_50px_rgba(15,23,42,0.08)]">
            <div className="text-xs font-black uppercase tracking-[0.18em] text-purple-700">
              Lev Vygotsky
            </div>

            <div className="mt-2 text-lg italic leading-relaxed text-gray-800 sm:text-xl">
              “Human learning presupposes a specific social nature.”
            </div>
          </div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            Speaking is not only language production.
          </h3>

          <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
            People learn to speak through interaction:
            listening, responding, repairing misunderstandings,
            adjusting timing, and gradually becoming comfortable
            participating with others.
          </p>

          <ComparisonTable
            leftTitle="Private AI practice"
            rightTitle="Social speech rehearsal"
            leftColor="blue"
            rightColor="purple"
            rows={[
              ["individual repetition", "interaction with listeners"],
              ["private correction", "shared repair and feedback"],
              ["simulated conversation", "social coordination"],
              ["isolated learning loop", "visible group progression"],
            ]}
          />

          <BigStatement
            title="AI can simulate conversation, but speech is still fundamentally social."
            tone="purple"
            compact
          >
            Catchphraser uses scripts, peer review, rehearsal,
            and guided interaction to help learners move from
            isolated practice toward real participation with other people.
          </BigStatement>
        </div>
      ),
      bgColor:
        "bg-[radial-gradient(circle_at_top_left,_#dbeafe,_transparent_32%),radial-gradient(circle_at_bottom_right,_#f3e8ff,_transparent_30%),linear-gradient(135deg,#ffffff,#faf5ff)]",
    },

    {
      title: "Peers Make Progress Visible",
      density: "dense",
      content: (
        <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">

          <div className="mx-auto max-w-4xl rounded-3xl border border-purple-100 bg-white/85 px-5 py-4 shadow-sm">
            <div className="text-xs font-black uppercase tracking-[0.18em] text-purple-700">
              Lev Vygotsky
            </div>

            <div className="mt-2 text-base italic leading-relaxed text-gray-700 sm:text-lg">
              “What a learner can do in cooperation today,
              they can do independently tomorrow.”
            </div>
          </div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            Learners improve by hearing others improve.
          </h3>

          <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
            Native-speaker models show the target,
            but peers show the process:
            hesitation, repair, adaptation, and gradual fluency.
          </p>

          <ComparisonTable
            leftTitle="Models"
            rightTitle="Peers"
            rows={[
              ["show the target", "show the path"],
              ["ideal pronunciation", "visible gradual improvement"],
              ["reference", "participation"],
              ["polished delivery", "realistic variability"],
            ]}
          />

          <BigStatement title="Speech confidence grows socially." tone="purple" compact>
            Learners become less inhibited when they hear people like themselves
            struggling, repairing, and gradually improving together.
          </BigStatement>
        </div>
      ),
      bgColor: "bg-[linear-gradient(135deg,#ffffff,#faf5ff)]",
    },

    {
      title: "Shared Practice Reduces Pressure",
      density: "dense",
      content: (
        <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">

          <div className="mx-auto max-w-4xl rounded-3xl border border-emerald-100 bg-white/85 px-5 py-4 shadow-sm">
            <div className="text-xs font-black uppercase tracking-[0.18em] text-emerald-700">
              Mikhail Bakhtin
            </div>

            <div className="mt-2 text-base italic leading-relaxed text-gray-700 sm:text-lg">
              “To be means to communicate.”
            </div>
          </div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            Learners speak more when they feel safe enough to continue.
          </h3>

          <ComparisonTable
            leftTitle="High-pressure speech"
            rightTitle="Shared rehearsal"
            leftColor="amber"
            rightColor="green"
            rows={[
              ["one learner is evaluated", "everyone is visibly learning"],
              ["mistakes feel personal", "mistakes become normal"],
              ["perfect models create pressure", "similar learners reduce shame"],
              ["correction interrupts confidence", "repair becomes collaborative"],
            ]}
          />

          <BigStatement title="The goal is usable participation." tone="green" compact>
            Learners gradually become more comfortable speaking because
            speech becomes shared work rather than isolated performance.
          </BigStatement>
        </div>
      ),
      bgColor: "bg-[linear-gradient(135deg,#ffffff,#ecfdf5)]",
    },

    {
      title: "Dialogue Rehearsal",
      density: "dense",
      content: (
        <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">

        <div className="mx-auto max-w-4xl rounded-3xl border border-blue-100 bg-white/85 px-5 py-4 shadow-sm">
  <div className="text-xs font-black uppercase tracking-[0.18em] text-blue-700">
    Mikhail Bakhtin
  </div>

  <div className="mt-2 text-base italic leading-relaxed text-gray-700 sm:text-lg">
    “The utterance is filled with dialogic overtones.”
  </div>
</div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            Prepared dialogue turns speaking into coordination.
          </h3>

          <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
            Instead of inventing every sentence from scratch,
            learners can focus on timing, pronunciation,
            response, listening, and interaction.
          </p>

          <Timeline
            steps={[
              ["🎧", "Prepare", "individual rehearsal", "listen, repeat, inspect prosody", "ring-blue-100"],
              ["💬", "Review", "peer correction", "mark unclear rhythm and sounds", "ring-purple-100"],
              ["👥", "Perform", "dialogue together", "response timing and coordination", "ring-pink-100"],
            ]}
          />

          <BigStatement title="The script is a scaffold for social speech." tone="purple" compact>
            Learners move gradually from guided rehearsal toward more natural interaction.
          </BigStatement>
        </div>
      ),
      bgColor: "bg-[linear-gradient(135deg,#ffffff,#faf5ff)]",
    },

    {
      title: "Guided Social Events",
      density: "dense",
      content: (
        <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">

          <div className="mx-auto max-w-4xl rounded-3xl border border-pink-100 bg-white/85 px-5 py-4 shadow-sm">
            <div className="text-xs font-black uppercase tracking-[0.18em] text-pink-700">
              Lev Vygotsky
            </div>

            <div className="mt-2 text-base italic leading-relaxed text-gray-700 sm:text-lg">
              “Through others we become ourselves.”
            </div>
          </div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            Guided events create stronger social motivation.
          </h3>

          <div className="grid gap-5 md:grid-cols-3 xl:gap-6">
            <EmojiCard
              emoji="👥"
              title="Learners"
              text="prepare, review, rehearse"
              className="ring-1 ring-blue-100"
            />

            <EmojiCard
              emoji="🧑‍🏫"
              title="Guides"
              text="structure sessions and progression"
              className="ring-1 ring-purple-100"
            />

            <EmojiCard
              emoji="🎙️"
              title="Events"
              text="radio plays, workshops, staged readings"
              className="ring-1 ring-pink-100"
            />
          </div>

          <BigStatement title="Speech practice becomes a coordinated social activity." tone="purple" compact>
            The long-term direction is not only AI tutoring,
            but communities practicing speech together.
          </BigStatement>
        </div>
      ),
      bgColor: "bg-[linear-gradient(135deg,#ffffff,#faf5ff)]",
    },
  ],
},


gamification: {
  label: "Gamification",
  description: "rehearsal & dialogue challenges",
  slides: [
    {
      title: "Speech As Rehearsal",
      density: "dense",
      content: (
        <div className="mx-auto max-w-6xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">
          <div className="mx-auto max-w-4xl rounded-3xl border border-purple-100 bg-white/85 px-5 py-4 shadow-sm">
            <div className="text-xs font-black uppercase tracking-[0.18em] text-purple-700">
              Central analogy
            </div>

            <div className="mt-2 text-base italic leading-relaxed text-gray-700 sm:text-lg">
              An actor learns a role by rehearsing lines together with others.
              Speech practice can work in a similar way.
            </div>
          </div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            Learners rehearse dialogue roles.
          </h3>

          <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
            The system plays the opposite role while the learner practices responses,
            timing, pronunciation, and delivery inside a structured interaction.
          </p>

          <div className="grid gap-4 md:grid-cols-3 xl:gap-5">
            <SoftCard className="text-left ring-1 ring-blue-100">
              <div className="mb-2 text-xs font-black uppercase tracking-[0.18em] text-blue-700">
                Round 1
              </div>

              <h4 className="mb-3 text-xl font-black text-gray-950">
                Learn the lines
              </h4>

              <CleanList
                accent="blue"
                items={[
                  "hear all dialogue lines",
                  "repeat own and opponent lines",
                  "practice pronunciation and rhythm",
                  "become familiar with the scene",
                ]}
              />
            </SoftCard>

            <SoftCard className="text-left ring-1 ring-purple-100">
              <div className="mb-2 text-xs font-black uppercase tracking-[0.18em] text-purple-700">
                Round 2
              </div>

              <h4 className="mb-3 text-xl font-black text-gray-950">
                Rehearse the scene
              </h4>

              <CleanList
                accent="purple"
                items={[
                  "only opponent lines are played",
                  "produce missing responses",
                  "practice timing and recall",
                  "stay inside interaction flow",
                ]}
              />
            </SoftCard>

            <SoftCard className="text-left ring-1 ring-pink-100">
              <div className="mb-2 text-xs font-black uppercase tracking-[0.18em] text-pink-700">
                Round 3
              </div>

              <h4 className="mb-3 text-xl font-black text-gray-950">
                Perform the role
              </h4>

              <CleanList
                accent="pink"
                items={[
                  "minimal or no support",
                  "score depends on hint usage",
                  "AI evaluates performance",
                  "pronunciation and timing assessment",
                ]}
              />
            </SoftCard>
          </div>

          <BigStatement
            title="The learner does not only memorize sentences."
            tone="purple"
            compact
          >
            The learner rehearses timing, response, pronunciation,
            and participation inside structured interaction.
          </BigStatement>
        </div>
      ),
      bgColor:
        "bg-[radial-gradient(circle_at_top_left,_#f3e8ff,_transparent_30%),radial-gradient(circle_at_bottom_right,_#dbeafe,_transparent_30%),linear-gradient(135deg,#ffffff,#faf5ff)]",
    },

    {
      title: "Support And Progression",
      density: "dense",
      content: (
        <div className="mx-auto max-w-6xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">
          <div className="mx-auto max-w-4xl rounded-3xl border border-blue-100 bg-white/85 px-5 py-4 shadow-sm">
            <div className="text-xs font-black uppercase tracking-[0.18em] text-blue-700">
              Guided difficulty
            </div>

            <div className="mt-2 text-base italic leading-relaxed text-gray-700 sm:text-lg">
              Support gradually disappears as the learner becomes more confident.
            </div>
          </div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            Hints function as temporary scaffolding.
          </h3>

          <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
            The system can provide different levels of support while keeping
            the learner inside the interaction loop.
          </p>

          <ComparisonTable
            leftTitle="Hint type"
            rightTitle="Learning function"
            leftColor="blue"
            rightColor="purple"
            rows={[
              ["first-word cue", "small retrieval support"],
              ["shuffled words", "sentence reconstruction"],
              ["audio replay", "prosody and pronunciation support"],
              ["spoken line + text", "maximum scaffold"],
            ]}
          />

          <BigStatement
            title="More support gives lower scores."
            tone="green"
            compact
          >
            The scoring system rewards increasing independence,
            while still allowing learners to continue practicing safely.
          </BigStatement>
        </div>
      ),
      bgColor:
        "bg-[radial-gradient(circle_at_top_left,_#dbeafe,_transparent_30%),linear-gradient(135deg,#ffffff,#eff6ff)]",
    },

    {
      title: "Why The Game Loop Supports Learning",
      density: "dense",
      content: (
        <div className="mx-auto max-w-6xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">
          <div className="mx-auto max-w-4xl rounded-3xl border border-emerald-100 bg-white/85 px-5 py-4 shadow-sm">
            <div className="text-xs font-black uppercase tracking-[0.18em] text-emerald-700">
              Pedagogical logic
            </div>

            <div className="mt-2 text-base italic leading-relaxed text-gray-700 sm:text-lg">
              The game mechanics are derived from rehearsal, retrieval,
              scaffolding, and repeated exposure to useful language patterns.
            </div>
          </div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            The interaction loop supports speech automaticity.
          </h3>

          <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
            The learner responds to a spoken cue, not just a written prompt.
            This trains pronunciation, intonation, rhythm, and timing inside
            a realistic dialogue exchange.
          </p>

          <ComparisonTable
            leftTitle="Learning principle"
            rightTitle="Interactive implementation"
            leftColor="green"
            rightColor="purple"
            rows={[
              ["repeated language exposure", "hear dialogue patterns many times"],
              ["chunk and pattern learning", "practice complete useful responses"],
              ["retrieval practice", "produce missing lines from memory"],
              ["prosodic response", "answer spoken cues with rhythm and intonation"],
              ["gradual scaffolding removal", "reduce hints over time"],
            ]}
          />

          <BigStatement
            title="The score measures independence, delivery, and timing."
            tone="green"
            compact
          >
            Fewer hints, fewer retries, clearer pronunciation, and more natural intonation
            show movement from guided rehearsal toward increasingly automatic spoken participation.
          </BigStatement>
        </div>
      ),
      bgColor:
        "bg-[radial-gradient(circle_at_top_left,_#dcfce7,_transparent_30%),radial-gradient(circle_at_bottom_right,_#f3e8ff,_transparent_30%),linear-gradient(135deg,#ffffff,#f8fafc)]",
    },

    {
      title: "Challenge & Shared Rehearsal",
      density: "dense",
      content: (
        <div className="mx-auto max-w-6xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">
          <div className="mx-auto max-w-4xl rounded-3xl border border-purple-100 bg-white/85 px-5 py-4 shadow-sm">
            <div className="text-xs font-black uppercase tracking-[0.18em] text-purple-700">
              Social practice layer
            </div>

            <div className="mt-2 text-base italic leading-relaxed text-gray-700 sm:text-lg">
              When a learner is ready, the same scene can become a challenge,
              a shared recording, or preparation for offline rehearsal.
            </div>
          </div>

          <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
            Rehearsal becomes social when learners perform the same scene.
          </h3>

          <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
            Learners can challenge others on the same role, perform against
            another user’s recorded lines, and receive AI feedback with optional
            native-speaker review.
          </p>

          <ComparisonTable
            leftTitle="Social mechanic"
            rightTitle="Learning value"
            leftColor="purple"
            rightColor="green"
            rows={[
              ["challenge another learner", "same scene creates fair comparison"],
              ["use another user’s cue lines", "practice feels more alive"],
              ["AI scores pronunciation and timing", "feedback remains immediate"],
              ["native speaker can review", "human assessment can override AI"],
            ]}
          />

          <BigStatement
            title="The long-term goal is purposeful social rehearsal."
            tone="purple"
            compact
          >
            Online challenges can connect naturally to language cafés,
            reading groups, workshops, and offline dialogue practice.
          </BigStatement>
        </div>
      ),
      bgColor:
        "bg-[radial-gradient(circle_at_top_left,_#f3e8ff,_transparent_30%),radial-gradient(circle_at_bottom_right,_#dcfce7,_transparent_30%),linear-gradient(135deg,#ffffff,#faf5ff)]",
    },
  ],
},

    business: {
      label: "Business",
      description: "monetization and team",
      slides: [
        {
          title: "Monetization & Partnerships",
          density: "medium",
          content: (
            <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">
              <ConceptMark emoji="💼" label="Business" sub="community-first model" />
              <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
                Monetization follows the learning model.
              </h3>
              <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
                Catchphraser can become infrastructure for organized speech practice,
                guided rehearsal, narrated content, institutional speaking activities,
                and creator-led courses.
              </p>

              <div className="grid gap-4 md:grid-cols-4 xl:gap-5">
                <EmojiCard
                  emoji="🎧"
                  title="Publishers"
                  text="narrated content as interactive practice"
                  className="ring-1 ring-blue-100"
                />
                <EmojiCard
                  emoji="🎓"
                  title="Courses"
                  text="structured courses and revenue sharing"
                  className="ring-1 ring-amber-100"
                />
                <EmojiCard
                  emoji="🧑‍🏫"
                  title="Guided activities"
                  text="paid rooms, workshops, rehearsal groups"
                  className="ring-1 ring-purple-100"
                />
                <EmojiCard
                  emoji="🏛️"
                  title="Institutions"
                  text="university language cafés and cohorts"
                  className="ring-1 ring-emerald-100"
                />
              </div>

              <BigStatement title="The first offer: structured social practice and course infrastructure." tone="green" compact>
                Free peer exchange can bring users in. Guided rooms, institutional cohorts,
                publisher content, creator courses, and specialized workshops create monetization.
              </BigStatement>
            </div>
          ),
          bgColor:
            "bg-[radial-gradient(circle_at_top_left,_#dbeafe,_transparent_32%),radial-gradient(circle_at_bottom_right,_#dcfce7,_transparent_30%),linear-gradient(135deg,#ffffff,#f8fafc)]",
        },

        {
          title: "Long-Term Advantage",
          density: "medium",
          content: (
            <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">
              <h3 className="text-3xl font-black leading-tight text-gray-950 md:text-5xl">
                The platform becomes harder to copy as the ecosystem grows.
              </h3>
              <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-700 sm:text-lg xl:text-xl">
                Learners, institutions, publishers, and guided events create accumulated value:
                speech data, content, relationships, and community habits.
              </p>

              <ComparisonTable
                leftTitle="Accumulated knowledge"
                rightTitle="Content network"
                leftColor="green"
                rightColor="amber"
                rows={[
                  ["learner attempts create signal", "native-speaker audio creates quality"],
                  ["peer comments reveal patterns", "publishers get a new channel"],
                  ["L1-specific errors accumulate", "content becomes interactive practice"],
                  ["recommendations improve", "better material attracts learners"],
                ]}
              />

              <BigStatement title="A competitor can copy a feature, but not the accumulated ecosystem." tone="amber" compact>
                The long-term advantage is L1-specific pronunciation data,
                licensed practice material, institutional relationships,
                and a growing speech community.
              </BigStatement>
            </div>
          ),
          bgColor: "bg-[linear-gradient(135deg,#ffffff,#fffbeb)]",
        },

        {
          title: "Content & Course Platform",
          density: "dense",
          content: (
            <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4">
              <h3 className="mx-auto max-w-5xl text-3xl font-black leading-tight text-gray-950 md:text-5xl">
                Narrated content and courses become interactive speech practice.
              </h3>

              <p className="mx-auto max-w-4xl text-base leading-relaxed text-gray-600 sm:text-lg">
                Audiobooks, dialogues, graded readers, pronunciation courses, and
                teacher-made materials can become rehearsal, shadowing, feedback, and
                collaborative speaking experiences.
              </p>

              <div className="grid gap-5 md:grid-cols-2">
                <SoftCard className="bg-gradient-to-br from-amber-50 to-white text-left ring-1 ring-amber-200">
                  <div className="mb-4 text-center">
                    <div className="mb-1 text-xs font-black uppercase tracking-[0.18em] text-amber-700">
                      Creator value
                    </div>

                    <h4 className="text-xl font-black text-gray-950 xl:text-2xl">
                      New distribution layer
                    </h4>
                  </div>

                  <NumberedList
                    accent="amber"
                    items={[
                      "turn narrated material into interactive speech training",
                      "subscription or course revenue",
                      "developer and teacher publishing portal",
                      "platform handles rehearsal and delivery",
                    ]}
                  />
                </SoftCard>

                <SoftCard className="bg-gradient-to-br from-blue-50 to-white text-left ring-1 ring-blue-200">
                  <div className="mb-4 text-center">
                    <div className="mb-1 text-xs font-black uppercase tracking-[0.18em] text-blue-700">
                      Learner value
                    </div>

                    <h4 className="text-xl font-black text-gray-950 xl:text-2xl">
                      Structured speaking progression
                    </h4>
                  </div>

                  <NumberedList
                    accent="blue"
                    items={[
                      "high-quality speech models",
                      "practice with AI and human feedback",
                      "reading + listening + speaking integration",
                      "social rehearsal around shared material",
                    ]}
                  />
                </SoftCard>
              </div>

              <BigStatement title="This is not only content licensing." tone="amber" compact>
                The platform transforms narrated material and expert-made courses into
                reusable speech-practice infrastructure.
              </BigStatement>
            </div>
          ),
          bgColor: "bg-[linear-gradient(135deg,#fffdf5,#fffbeb)]",
        },

        {
          title: "The Catchphraser Team",
          density: "team",
          content: (
            <div className="mx-auto max-w-7xl space-y-5 px-3 py-1 text-center sm:px-4 xl:space-y-6">
              <div className="text-center">
                <h2 className="mb-3 text-3xl font-black leading-tight text-gray-950 md:text-5xl">
                  The Catchphraser Team
                </h2>
                <p className="mx-auto max-w-3xl text-base leading-relaxed text-gray-600 sm:text-lg xl:text-xl">
                  Researchers and language professionals building pronunciation training and rehearsal infrastructure.
                </p>
              </div>

              <div className="mx-auto grid max-w-6xl gap-5 md:grid-cols-3 xl:gap-6">
                {[
                  [
                    "it.jpg",
                    "Dr. Inna Tolskaya",
                    "CEO – Product & Linguistics",
                    "itolsk@gmail.com",
                    "Linguist, project manager, and software developer with a passion for innovation and e-learning.",
                    "from-blue-50 to-indigo-50 border-blue-200 text-blue-600",
                    "IT",
                  ],
                  [
                    "oh.jpg",
                    "Assoc. Prof. Olaf Husby",
                    "CCO – Teaching & Didactics",
                    "olafhusby@gmail.com",
                    "Phonetician, second-language educator, course developer, and Norwegian dialects evangelist.",
                    "from-purple-50 to-violet-50 border-purple-200 text-purple-600",
                    "OH",
                  ],
                  [
                    "ds.jpg",
                    "Dr. Dmitry Shcherbin",
                    "CTO/CPO – Tech & Research",
                    "dmitry.shcherbin@gmail.com",
                    "Product leader, software developer, data analyst, and researcher with an interest in practical applications.",
                    "from-cyan-50 to-teal-50 border-cyan-200 text-cyan-600",
                    "DS",
                  ],
                ].map(([img, name, role, email, bio, cardColor, initials]) => (
                  <div
                    key={name}
                    className={`rounded-3xl border bg-gradient-to-br ${cardColor} p-4 shadow-[0_18px_60px_rgba(15,23,42,0.08)] xl:p-5`}
                  >
                    <div className="text-center">
                      <div className="relative mx-auto mb-4 flex h-20 w-20 items-center justify-center overflow-hidden rounded-full border-4 border-white bg-gray-100 shadow-xl xl:h-24 xl:w-24">
                        <div className="absolute inset-0 flex items-center justify-center text-3xl font-black text-gray-500">
                          {initials}
                        </div>
                        <img
                          src={asset(img)}
                          alt={name}
                          className="relative z-10 h-full w-full object-cover"
                          onError={(event) => {
                            event.currentTarget.style.display = "none";
                          }}
                        />
                      </div>

                      <h3 className="mb-2 text-lg font-black text-gray-950 xl:text-xl">
                        {name}
                      </h3>
                      <p className="mb-2 text-sm font-bold">{role}</p>
                      <a href={`mailto:${email}`} className="break-all text-xs hover:underline">
                        {email}
                      </a>
                    </div>

                    <div className="mt-4 rounded-2xl border border-white/60 bg-white/85 p-4 shadow-sm backdrop-blur-sm">
                      <p className="text-sm leading-relaxed text-gray-700">{bio}</p>
                    </div>
                  </div>
                ))}
              </div>

              <div className="text-center">
                <p className="mb-1 text-sm text-gray-700 sm:text-base">
                  Interested in collaboration, testing, or research partnerships?
                </p>
                <a href="mailto:info@catchphraser.com" className="text-base font-bold text-blue-600 hover:underline">
                  info@catchphraser.com
                </a>
              </div>
            </div>
          ),
          bgColor:
            "bg-[radial-gradient(circle_at_top_left,_#dbeafe,_transparent_32%),radial-gradient(circle_at_bottom_right,_#ecfeff,_transparent_30%),linear-gradient(135deg,#ffffff,#f8fafc)]",
        },
      ],
    },
  };
};